import { gql } from '@nerdwallet/apollo';
import * as React from 'react';
import * as ApolloReactCommon from '@nerdwallet/apollo';
import * as ApolloReactComponents from '@nerdwallet/apollo';
import * as ApolloReactHoc from '@nerdwallet/apollo';
import * as ApolloReactHooks from '@nerdwallet/apollo';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /**
   * A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Date: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  StructuredContentDocument: any;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** For bigger integers */
  BigInt: any;
  /** ISO Date String in YYYY-MM-DDThh:mm:ssTZD */
  DateTimeWithTimeOffset: any;
  /**
   * A field whose value conforms to the standard internet email address format as
   * specified in RFC822: https://www.w3.org/Protocols/rfc822/.
   */
  EmailAddress: any;
};

/** TODO: the `canonicalInstitutionId` field should map to a canonical institution */
export type AccountAggregationInstitution = {
  __typename?: 'AccountAggregationInstitution';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /** Manual override by NW employee for the popularity of this institution */
  adminPopularity?: Maybe<Scalars['Int']>;
  /**
   * Indicator of which account aggregator we are surfacing this institution from
   * 
   * Example: `yodlee`
   */
  aggregatorType?: Maybe<MarketplaceAggregatorType>;
  /** The countries with which the institution is affiliated. */
  countryCodes?: Maybe<Array<InstitutionCountryCode>>;
  /**
   * The timestamp at which the institution was last deleted from marketplace, if applicable
   * 
   * Example: `1563480626`
   */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The status of the institution, typically used to determine whether to surface the institution or not
   * 
   * Example: `ACTIVE`
   */
  displayStatus: AccountAggregationInstitutionDisplayStatus;
  /** Whether the institution is manually deactivated by an NW employee or not ??? */
  iavAdminDeactivated?: Maybe<Scalars['Boolean']>;
  /** Whether the institution supports IAV or not */
  iavEnabled: Scalars['Boolean'];
  /**
   * The timestamp at which the institution was last updated in marketplace
   * 
   * Example: `1563480626`
   */
  lastSyncedAt: Scalars['DateTime'];
  /**
   * The logo for the institution as provided by the relevant third-party account aggregator. This may either be
   * a full url, or a data-image representation of an image.
   * 
   * Example: `https://yodlee-1.hs.llnwd.net/v1/LOGO/LOGO_643_1_2.SVG`
   */
  logoUrl?: Maybe<Scalars['String']>;
  /**
   * An alternate logo for the institution provided by NerdWallet that more clearly indicates which institution it is
   * (i.e. via text in the logo)
   */
  topInstitutionLogo?: Maybe<Scalars['String']>;
  /**
   * The URL at which the user will be logged in, as provided by the relevant third-party account aggregator
   * 
   * Example: `https://secure01c.chase.com/web/auth/dashboard`
   */
  loginUrl?: Maybe<Scalars['String']>;
  /**
   * How popular this institution is for linking to in relation to others, equal to the number of successful
   * links with this institution in the past
   */
  popularity: Scalars['Int'];
};

export type AccountAggregationInstitutionByIdResponse = {
  __typename?: 'AccountAggregationInstitutionByIdResponse';
  institution?: Maybe<AccountAggregationInstitution>;
};

export enum AccountAggregationInstitutionDisplayStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  /**  This institution is not supported, but is a major institution that we want to show to the user anyway (with messaging)  */
  Unavailable = 'UNAVAILABLE'
}

export type AccountAggregationInstitutionsResponse = {
  __typename?: 'AccountAggregationInstitutionsResponse';
  /** The total number of institutions that match your query */
  total: Scalars['Int'];
  /** The list of institutions that match your query */
  institutions: Array<AccountAggregationInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int'];
};

export enum AccountAggregationProductType {
  Banking = 'BANKING',
  CreditCards = 'CREDIT_CARDS',
  InvestmentAccounts = 'INVESTMENT_ACCOUNTS',
  Mortgages = 'MORTGAGES',
  PersonalLoans = 'PERSONAL_LOANS',
  StudentLoans = 'STUDENT_LOANS'
}

export type AccountLinkingOpportunitiesResponse = {
  __typename?: 'AccountLinkingOpportunitiesResponse';
  eligibility: AccountLinkingOpportunityEligibilityEnum;
  creditCardLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
  loanLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
};

export type AccountLinkingOpportunity = {
  __typename?: 'AccountLinkingOpportunity';
  institutionCanonicalName?: Maybe<Scalars['String']>;
  institutionLogoUrl?: Maybe<Scalars['URL']>;
  numberOfAccounts: Scalars['Int'];
};

export enum AccountLinkingOpportunityEligibilityEnum {
  /** Denotes if a user is eligible to link all types of accounts. */
  All = 'ALL',
  /** Denotes if a user is eligible to link only credit cards or loans. */
  CcsAndLoans = 'CCS_AND_LOANS',
  /** Denotes if a user already has all types of accounts linked or no TU data. */
  None = 'NONE'
}

/**
 * The `AccountOfferInterface` is the shared fields between savings and investments
 * for the marketplace tab recommendations.
 */
export type AccountOfferInterface = {
  imageUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/**
 * Wraps the add Net Worth Home - Integrated API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthHomeIntegratedResponse = {
  __typename?: 'AddNetWorthHomeIntegratedResponse';
  asset: NetWorthHomeIntegrated;
};

/**
 * Wraps the add Net Worth Real asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'AddNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

export type AdvancedOffsetPaginationInfo = {
  __typename?: 'AdvancedOffsetPaginationInfo';
  /** The adjusted maximum number of results to return based on the request limit and result set token. */
  limit?: Maybe<Scalars['Int']>;
  /**
   * The adjusted start index of the results to return based on the request limit and result set token.
   * If underlying data has changed, this will be reset to 0 and results will start from the "beginning" of the list.
   */
  offset?: Maybe<Scalars['Int']>;
  /** The token associated with the result set, which may be different if the underlying data changed */
  resultSetToken?: Maybe<Scalars['String']>;
};

export type AdvancedOffsetPaginationInput = {
  /** The maximum number of results to return. Default is 500. */
  limit?: Maybe<Scalars['Int']>;
  /** The start index of the results to return. */
  offset?: Maybe<Scalars['Int']>;
  /** The token associated with the result set, used to validate whether underlying data may have changed */
  resultSetToken?: Maybe<Scalars['String']>;
};

/**
 * The type used by Native and Web that describes how to handle a defined action.
 * On Mobile, it allows for a link that could deeplink or fall back to a webview if that deeplink
 * is not supported in the client version of the mobile app.
 * On Web, the action is determined using both targetType and the target.
 */
export type AppAction = {
  __typename?: 'AppAction';
  /** A string that describes the type of action (used for analytics). */
  name?: Maybe<Scalars['String']>;
  /** The user-facing copy on the action button/link */
  text: Scalars['String'];
  /** A NerdWallet mobile app deep link */
  mobileTarget?: Maybe<Scalars['String']>;
  /** Typically a web URL. If mobileTarget is not specified or invalid, this will open in a webview. */
  target?: Maybe<Scalars['String']>;
  /** A string that tells the client how to handle this action. Only used on Web. */
  targetType?: Maybe<AppActionTargetType>;
  /** Indicates whether the provided target is a place where the user can fulfill the described action */
  leadsToUserActionFulfillment?: Maybe<Scalars['Boolean']>;
};

export enum AppActionTargetType {
  WebLink = 'WEB_LINK',
  Navigation = 'NAVIGATION',
  Billshark = 'BILLSHARK',
  MyBillsSuggested = 'MY_BILLS_SUGGESTED',
  LinkAccount = 'LINK_ACCOUNT',
  LinkHome = 'LINK_HOME',
  SelfReportedIncome = 'SELF_REPORTED_INCOME'
}

export type AppleLoginInfoInput = {
  /** The app used to log in with Apple */
  appType: AppTypeEnum;
  /** The authorization code associated with the Apple log in/registration */
  authorizationCode: Scalars['String'];
  /** The client ID associated with the Apple log in/registration */
  clientId: Scalars['String'];
  /** The current user's email associated with the Apple log in/registration */
  email?: Maybe<Scalars['EmailAddress']>;
  /** The current user's first name associated with the Apple log in/registration */
  firstName?: Maybe<Scalars['String']>;
  /** The current user's last name associated with the Apple log in/registration */
  lastName?: Maybe<Scalars['String']>;
  /** The "number only used once" associated with the Apple log in/registration */
  nonce?: Maybe<Scalars['String']>;
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: Maybe<Scalars['String']>;
  /** The redirect URI ssociated with the Apple log in/registration */
  redirectUri?: Maybe<Scalars['String']>;
  /** Determines if the current user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

/** Enum used to determine the app type of a third party log in */
export enum AppTypeEnum {
  NerdwalletMobile = 'NERDWALLET_MOBILE',
  NerdwalletWeb = 'NERDWALLET_WEB',
  Nwadmin = 'NWADMIN'
}

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type Article = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Article';
  /** Whether or not to show the advertiser disclosure. An empty value here indicates it should be shown. */
  advertiserDisclosure?: Maybe<Scalars['String']>;
  /** The type of Article this is. */
  articleType?: Maybe<ArticleTypeEnum>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /**
   * The topic that should be used as the 'Attribution Topic' for this piece of
   * content. This value is used for attributing metrics related to this piece of
   * content in analytics reports.
   */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Article object. */
  categories?: Maybe<Array<Category>>;
  /** The Disqus thread ID for this content. */
  commentThreadId?: Maybe<Scalars['Int']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The content clusters for this piece of content. Content clusters are meant to be arbitrary groupings of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The BlockGroups to use as custom content below the main content of the Article. */
  customBelowContent?: Maybe<BlockGroup>;
  /** The custom HouseAd to use on this Article. */
  customHouseAd?: Maybe<HouseAd>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The BlockGroups to use as the custom next steps for this Article. */
  customNextSteps?: Maybe<BlockGroup>;
  /** The BlockGroups to use as custom Related Links for this Article. */
  customRelatedLinks?: Maybe<BlockGroup>;
  /** The block group to use as the custom sidebar on this Article. */
  customSidebar?: Maybe<BlockGroup>;
  /** The custom title to use for this piece of content on a feed by feed basis. */
  customTitlesForRssFeeds?: Maybe<Array<ArticleCustomTitlesForRssFeed>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /**
   * Editorial disclaimer setting to show, hide, or display a specific disclaimer.
   * An empty value here indicates it should be shown.
   */
  editorialDisclaimer?: Maybe<Scalars['String']>;
  /** Whether or not to disable comments on this piece of content. */
  enableComments?: Maybe<Scalars['Boolean']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** Whether or not to hide the Author information from the header of this piece of content. */
  hideAuthor?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the banner for this piece of content. */
  hideBanner?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the custom content to display below the main content for this Article. */
  hideBelowContent?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the featured image for this piece of content. */
  hideFeaturedImage?: Maybe<Scalars['Boolean']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not to prevent the content from getting syndicated to
   * NerdWalletWire.com and other services that use our full-text feeds.
   */
  isSyndicationEligible?: Maybe<Scalars['Boolean']>;
  /** The layout to use for the content. */
  layout?: Maybe<ArticleLayoutEnum>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The block to use as the methodology for this piece of content. */
  methodology?: Maybe<Block>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to show the author box in the footer of this piece of content. */
  showAuthorBox?: Maybe<Scalars['Boolean']>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Whether or not to use the custom content below the main content for this Article. */
  useCustomBelowContent?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom House Ad on this Article. */
  useCustomHouseAd?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use the custom next steps for this Article. */
  useCustomNextSteps?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use the custom related links for this Article. */
  useCustomRelatedLinks?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom sidebar for this Article. */
  useCustomSidebar?: Maybe<Scalars['Boolean']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** the breadcrumb to display on an article */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Whether the article's status is PUBLISHED or not. */
  isPublished: Scalars['Boolean'];
  /** User-facing label of the post type. */
  postTypeLabel: Scalars['String'];
  /** Block group to be rendered below the content. */
  belowContent?: Maybe<BlockGroup>;
  /** HouseAd to be rendered for house ad. */
  houseAd?: Maybe<HouseAd>;
  /** Block group to be rendered as 'next steps'. */
  nextSteps?: Maybe<BlockGroup>;
  /** Block group to be rendered as related links. */
  relatedLinks?: Maybe<BlockGroup>;
  /** Block group to be rendered as the sidebar. */
  sidebar?: Maybe<BlockGroup>;
  /** Whether or not to show the editorial disclaimer. */
  showEditorialDisclaimer: Scalars['Boolean'];
  /** Whether or not to show the advertiser disclosure. */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Display date based on flags and custom dates set on entity */
  displayDate?: Maybe<Scalars['DateTime']>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /** The banner to display on the article */
  banner?: Maybe<Banner>;
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleExcerptArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ArticleConnectionResponse = {
  __typename?: 'ArticleConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Article returned for the connection. */
  items?: Maybe<Array<Article>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Type modeling the data within the customTitlesForRssFeeds group of fields on the Article type. */
export type ArticleCustomTitlesForRssFeed = {
  __typename?: 'ArticleCustomTitlesForRssFeed';
  /** The title to show in this feed. */
  customTitle?: Maybe<Scalars['String']>;
  /** The feed this title should show on. */
  feedSlug?: Maybe<Scalars['String']>;
};

/** Query to fetch a collection of Article objects. */
export type ArticleFilterInput = {
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to Articles within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: Maybe<Scalars['String']>;
  /** Limit collection to Articles with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Limit collection to Articles with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** Enum values for layout field on Article type. */
export enum ArticleLayoutEnum {
  Default = 'DEFAULT',
  Full = 'FULL',
  Sidebar = 'SIDEBAR'
}

export type ArticlePage = StructuredContentPageInterface & {
  __typename?: 'ArticlePage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<Scalars['JSON']>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/** Enum values for articleType field on Article type. */
export enum ArticleTypeEnum {
  GeneralAnswer = 'GENERAL_ANSWER',
  Listicle = 'LISTICLE',
  StepByStep = 'STEP_BY_STEP',
  TableOfContents = 'TABLE_OF_CONTENTS'
}

/** Interface that must be implemented by log in/register user responses */
export type AuthenticationResponseInterface = {
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
  /** The A/B experiments associated with the current user */
  abExperiments?: Maybe<Array<Experiment>>;
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

/** The WordPress author type. */
export type Author = {
  __typename?: 'Author';
  /** An organization the author is affiliated with. */
  affiliation?: Maybe<Scalars['String']>;
  /** The author's alma mater. */
  alumniOf?: Maybe<Scalars['String']>;
  /** URLs to various avatar sizes. */
  avatarUrls?: Maybe<Array<AuthorAvatarUrl>>;
  /** An award the author has won. */
  award?: Maybe<Scalars['String']>;
  /** The email address to use to contact the author. */
  contactEmail?: Maybe<Scalars['String']>;
  /** Description for the author. */
  description?: Maybe<Scalars['String']>;
  /** The author's education history. */
  education?: Maybe<Scalars['String']>;
  /** Email address for the author. */
  email?: Maybe<Scalars['String']>;
  /** The author's previous experience. */
  experience?: Maybe<Scalars['String']>;
  /** Facebook URL for the author. */
  facebook?: Maybe<Scalars['URL']>;
  /** A collection of publications, organizations, etc. where the author has been featured in. */
  featuredIn?: Maybe<Array<AuthorFeaturedIn>>;
  /** The author's honorific suffix. eg: CFP, CPA */
  honorificSuffix?: Maybe<Scalars['String']>;
  /** ID of the author. */
  id: Scalars['ID'];
  /** The author's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /** Full url for the author's archive page. */
  link?: Maybe<Scalars['URL']>;
  /** LinkedIn URL for the author. */
  linkedin?: Maybe<Scalars['URL']>;
  /** Marketplace bio for the author. */
  marketplaceBio?: Maybe<Scalars['String']>;
  /** Name of the author. */
  name?: Maybe<Scalars['String']>;
  /** URI slug for the author. */
  slug?: Maybe<Scalars['String']>;
  /** A comma-separated list of this author's areas of specialty. */
  specialties?: Maybe<Scalars['String']>;
  /** Tagline message for the author. */
  tagline?: Maybe<Scalars['String']>;
  /** Twitter handle for the author. */
  twitter?: Maybe<Scalars['String']>;
  /** External URL for the author. */
  url?: Maybe<Scalars['URL']>;
  /** The bio that we display for an author on a roundup page. */
  roundupBio?: Maybe<Scalars['String']>;
  /** The social media links relevant to an author */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};


/** The WordPress author type. */
export type AuthorAvatarUrlsArgs = {
  sizes?: Maybe<Array<AvatarSizeEnum>>;
};

/** Avatar URL Type for authors. */
export type AuthorAvatarUrl = {
  __typename?: 'AuthorAvatarUrl';
  /** The size of the image. */
  size?: Maybe<Scalars['Int']>;
  /** The url for the image. */
  url?: Maybe<Scalars['URL']>;
};

/** Type modeling the data within the featuredIn group of fields on the Author type. */
export type AuthorFeaturedIn = {
  __typename?: 'AuthorFeaturedIn';
  /** The name of the publication, organization, etc. where the author has been featured. */
  name?: Maybe<Scalars['String']>;
  /** The URL of the publication, organization, etc. where the author was featured. */
  url?: Maybe<Scalars['URL']>;
};

/** The input for retrieving a single author. */
export type AuthorItemInput = {
  /** The WordPress ID for the Author. */
  identifier: Scalars['ID'];
};

/**
 * A social media link related to an author
 * Includes a type, a displayable name, and a URL to the social media
 */
export type AuthorSocialMediaLink = {
  __typename?: 'AuthorSocialMediaLink';
  /** The type of social media link. */
  type: AuthorSocialMediaLinkTypeEnum;
  /** Displayable name for social media link. */
  name: Scalars['String'];
  /** URL for social media link. */
  url: Scalars['String'];
};

export enum AuthorSocialMediaLinkTypeEnum {
  Twitter = 'twitter',
  Email = 'email',
  Facebook = 'facebook',
  Linkedin = 'linkedin'
}

/** Auto Insurance Prequal Offer */
export type AutoInsurancePrequalOffer = PrequalOffer & {
  __typename?: 'AutoInsurancePrequalOffer';
  applyLink: Scalars['String'];
  institutionName: Scalars['String'];
  institutionLogo: Scalars['String'];
  nwRating?: Maybe<Scalars['Float']>;
  providerId?: Maybe<Scalars['ID']>;
  /** The marketplace institution id for the offer */
  institutionId: Scalars['ID'];
  /** offerId indicates the corresponding marketplace id for the offer */
  offerId: Scalars['ID'];
  /** The marketplace product id for the offer */
  productId: Scalars['ID'];
  /** rank tells the client what order the offers should be shown */
  rank: Scalars['Int'];
};

/** Query variables for AutoInsurancePrequalOffers */
export type AutoInsurancePrequalOfferInput = {
  zipCode: Scalars['String'];
  age?: Maybe<Scalars['Int']>;
  creditScoreRange?: Maybe<QuinStreetCreditScoreRangeEnum>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: Maybe<Scalars['String']>;
  isHomeOwner?: Maybe<Scalars['Boolean']>;
  isMarried?: Maybe<Scalars['Boolean']>;
  isVeteran?: Maybe<Scalars['Boolean']>;
  isGoodDriver?: Maybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: Maybe<Scalars['String']>;
};

/** Format of response to autoInsurancePrequalOffers query */
export type AutoInsurancePrequalOffersResponse = {
  __typename?: 'autoInsurancePrequalOffersResponse';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<Maybe<AutoInsurancePrequalOffer>>>;
};

/** Enum of providerIds that are accepted by the auto insurance offers route */
export enum AutoInsuranceProviderId {
  Mock = 'MOCK',
  Quinstreet = 'QUINSTREET'
}

/** A Auto Loans institution */
export type AutoLoansInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'AutoLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Auto Loans offer */
export type AutoLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'AutoLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  product: AutoLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Auto Loans product */
export type AutoLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'AutoLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: AutoLoansInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** The list of avatar sizes available to choose from. */
export enum AvatarSizeEnum {
  Size_24 = 'SIZE_24',
  Size_48 = 'SIZE_48',
  Size_96 = 'SIZE_96'
}

/** A Banking institution */
export type BankingInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & {
  __typename?: 'BankingInstitutionV2';
  /** The display name for the entity. */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The editorial rating on the banking experience for the institution. */
  ratingBankExperience?: Maybe<Scalars['Float']>;
  /** The editorial rating on overdraft fees for the institution. */
  ratingOverdraftFee?: Maybe<Scalars['Float']>;
  /** The URL to the NerdWallet review of this institution. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall, editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** A Banking offer */
export type BankingOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'BankingOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** APY formatted for display in clients, with 2 decimal places and % symbol */
  displayApy?: Maybe<Scalars['String']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** The URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Calculates if this offer is monetizing for a specific user (after taking throttling into account) */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  product: BankingProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer's institution */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** State(s) where offer is available. If no states are specified, we will consider the offer to be nationally available */
  states?: Maybe<Array<StateAbbreviationsEnum>>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The annotation for the agency that federally insures the institution */
  federallyInsuredAnnotation?: Maybe<Scalars['String']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** A Banking product */
export type BankingProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'BankingProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: BankingInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type Banner = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'Banner';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text for the banner. */
  body?: Maybe<Scalars['StructuredContentDocument']>;
  /** The button text for the banner. */
  buttonText?: Maybe<Scalars['String']>;
  /** The url for the button in the banner. */
  buttonUrl?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The headline to use for the Banner. */
  headline?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BannerConnectionResponse = {
  __typename?: 'BannerConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Banner returned for the connection. */
  items?: Maybe<Array<Banner>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Banner objects. */
export type BannerFilterInput = {
  /** Limit collection to Banners published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to Banners with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type Block = PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'Block';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Block object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockConnectionResponse = {
  __typename?: 'BlockConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Block returned for the connection. */
  items?: Maybe<Array<Block>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Block objects. */
export type BlockFilterInput = {
  /** Limit collection to Blocks published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to Blocks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit collection to Blocks with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit collection to Blocks with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroup = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'BlockGroup';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the BlockGroup object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  blocks?: Maybe<Array<Maybe<CombinedBlockGroupBlock>>>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockGroupConnectionResponse = {
  __typename?: 'BlockGroupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BlockGroup returned for the connection. */
  items?: Maybe<Array<BlockGroup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BlockGroup objects. */
export type BlockGroupFilterInput = {
  /** Limit collection to BlockGroups published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to BlockGroups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit collection to BlockGroups with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit collection to BlockGroups with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** Breadcrumb to be used by global-nav */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  slug?: Maybe<Scalars['String']>;
  page?: Maybe<BreadcrumbPage>;
};

/** Breadcrumb Page object with a title */
export type BreadcrumbPage = {
  __typename?: 'BreadcrumbPage';
  title: Scalars['String'];
};

/** Controls whether the response is cacheable by clients and shared (proxy) caches. PRIVATE by default. */
export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CanonicalInstitution = {
  __typename?: 'CanonicalInstitution';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /**
   * The NerdWallet-maintained url for the square logo of the institution, if we have it
   * 
   * Example: `https://www.nerdwallet.com/cdn/financial-institutions/american-express/amex_logo_square%404x.png`
   */
  squareLogoUrl?: Maybe<Scalars['String']>;
  /**
   * The NerdWallet-maintained list of lowercase synonyms for how this institution may show up on a TU credit report
   * 
   * Example: [`amex`, `american express`]
   */
  tuCreditorSynonyms?: Maybe<Array<Scalars['String']>>;
  /**
   * The NerdWallet-maintained mapping to a yodlee provider id
   * 
   * Example: `175e9916-0ca9-4e32-ac2b-56f0c7e70196`
   */
  yodleeProviderId?: Maybe<Scalars['String']>;
};

export type CanonicalInstitutionsResponse = {
  __typename?: 'CanonicalInstitutionsResponse';
  /** The total number of institutions that match your query. */
  total: Scalars['Int'];
  /** The list of institutions that match your query */
  institutions: Array<CanonicalInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int'];
};

export type CardImageDetails = {
  __typename?: 'CardImageDetails';
  /** Determines if the card image is a portrait or not */
  isPortrait: Scalars['Boolean'];
  /** Card image sources from small to large */
  source: Scalars['String'];
  sourceMedium: Scalars['String'];
  sourceLarge?: Maybe<Scalars['String']>;
};

export type CardLinkedOffersActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CardLinkedOffersActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type CashFlowActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CashFlowActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type CashFlowBreakdown = {
  __typename?: 'CashFlowBreakdown';
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float'];
  /**
   * The user's estimated income for the month in dollars. Income is estimated
   * based on user self-reported values or if that is not provided, then based
   * on transactions in the income category.
   */
  estimatedIncome: Scalars['Float'];
  /** The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents. */
  upcomingBillsTotalDue: Scalars['Float'];
  /**
   * Computed as (estimated income - spending - upcomingBillsTotalDue).
   * Note: this value can be negative
   */
  remaining: Scalars['Float'];
};

export type CashFlowHistoryBreakdown = {
  __typename?: 'CashFlowHistoryBreakdown';
  /** Month by month breakdown of historical cash flow, current month included */
  cashFlowHistoryBreakdown: Array<CashFlowHistoryMonthlyBreakdownDatum>;
  /**
   * The average of the 'remaining' fields in the breakdown, current month NOT included
   * A positive number means, on average, the user has saved more than they have spent.
   */
  averageSavingsRemaining?: Maybe<Scalars['Float']>;
};

export type CashFlowHistoryMonthlyBreakdownDatum = {
  __typename?: 'CashFlowHistoryMonthlyBreakdownDatum';
  /** A date in the month that this datum represents */
  date: Scalars['Date'];
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float'];
  /**
   * The user's actual earning for the month, in dollars. Earning is credits minus
   * debits in the income category. Estimated income is based on user self-reported values
   * or if that is not provided, then based on transactions in the income category.
   */
  earning: Scalars['Float'];
  /**
   * The user's estimated income for the month, in dollars. It is only present for
   * the current month. Estimated income is based on user self-reported values or
   * if that is not provided, then based on transactions in the income category.
   */
  estimatedIncome?: Maybe<Scalars['Float']>;
  /**
   * The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents.
   * Note: this value is only present for the currentMonth (otherwise there are no upcoming bills)
   */
  upcomingBills?: Maybe<Scalars['Float']>;
  /**
   * Computed as ((earnings or estimatedIncome) - spending - upcomingBills (if any)).
   * Note: this value can be negative
   */
  remaining: Scalars['Float'];
};

export type CashFlowTakeaway = {
  __typename?: 'CashFlowTakeaway';
  /** A label describing the takeaway (user facing). */
  label?: Maybe<Scalars['String']>;
  /** The body of the takeaway - describes the takeaway for the user in more detail (user facing). */
  body: Scalars['String'];
  /** A string that describes the type of takeaway (e.g. ONBOARDING) (used for analytics). */
  theme?: Maybe<Scalars['String']>;
  /** A string that can further describe the type within the larger theme of the takeaway (used for analytics). */
  subtheme?: Maybe<Scalars['String']>;
  /** A string representing the takeaway name (used for analytics) */
  takeaway?: Maybe<Scalars['String']>;
  /**
   * Describes the sentiment of the takeaway and further helps distinguish when theme/subtheme are the same
   * (e.g. POSITIVE) (used for analytics).
   */
  condition?: Maybe<Scalars['String']>;
  /**
   * A list of actions that the user can take related to this takeaway. These usually represent
   * links to another page or screen so the user can dig into the details of the takeaway. There's usually
   * 1 action per takeaway (but this is not a requirement).
   */
  actions: Array<AppAction>;
};

/** Type modeling the data for terms within the category taxonomy from WordPress. */
export type Category = TermInterface & {
  __typename?: 'Category';
  /** The banner to display at the top of content within this category. */
  defaultBanner?: Maybe<Banner>;
  /** The default Block Group to use in the "Below Content" section for content in this category. */
  defaultBelowContent?: Maybe<BlockGroup>;
  /** The default House Ad to use for content in this category. */
  defaultHouseAd?: Maybe<HouseAd>;
  /** The default Block Group to use in the "Next Steps" section for content in this category. */
  defaultNextSteps?: Maybe<BlockGroup>;
  /** The default Block Group to use in the "Related Links" section for content in this category. */
  defaultRelatedLinks?: Maybe<BlockGroup>;
  /** The default Block Group to use as the sidebar for content in this category. */
  defaultSidebar?: Maybe<BlockGroup>;
  /** The WordPress ID for this resource. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The Category object for the parent of this entity. */
  parent?: Maybe<Category>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

export type ClientEligibilityConfig = {
  __typename?: 'ClientEligibilityConfig';
  /** The minimum native app version required to be eligible for this user insight */
  minNativeAppVersion?: Maybe<Scalars['String']>;
  /** The list of native app versions to block for this user insight */
  blocklistedNativeAppVersions?: Maybe<Array<Scalars['String']>>;
};

export type CombinedBlockGroupBlock = {
  __typename?: 'CombinedBlockGroupBlock';
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
};

export enum ContentCategory {
  Advisors = 'ADVISORS',
  AirlineCreditCards = 'AIRLINE_CREDIT_CARDS',
  AutoInsurance = 'AUTO_INSURANCE',
  AutoLoans = 'AUTO_LOANS',
  BalanceTransferCreditCards = 'BALANCE_TRANSFER_CREDIT_CARDS',
  Banking = 'BANKING',
  BankingBasics = 'BANKING_BASICS',
  BankingNews = 'BANKING_NEWS',
  BanksAndCreditUnions = 'BANKS_AND_CREDIT_UNIONS',
  BestCreditCards = 'BEST_CREDIT_CARDS',
  Bills = 'BILLS',
  BlackFriday = 'BLACK_FRIDAY',
  BlackFridayAdLeaks = 'BLACK_FRIDAY_AD_LEAKS',
  Brokers = 'BROKERS',
  BusinessCreditCards = 'BUSINESS_CREDIT_CARDS',
  Careers = 'CAREERS',
  CarInsurancEstimates = 'CAR_INSURANC_ESTIMATES',
  CashBackCreditCards = 'CASH_BACK_CREDIT_CARDS',
  Cds = 'CDS',
  CellPhones = 'CELL_PHONES',
  CheckingAccounts = 'CHECKING_ACCOUNTS',
  CollegeSavings = 'COLLEGE_SAVINGS',
  CompareCardOffers = 'COMPARE_CARD_OFFERS',
  CorporateNews = 'CORPORATE_NEWS',
  CorporateTaxRates = 'CORPORATE_TAX_RATES',
  CreditCards = 'CREDIT_CARDS',
  CreditCardBasics = 'CREDIT_CARD_BASICS',
  CreditCardData = 'CREDIT_CARD_DATA',
  CreditCardReviews = 'CREDIT_CARD_REVIEWS',
  CreditCardsAverageFairCredit = 'CREDIT_CARDS_AVERAGE_FAIR_CREDIT',
  CreditCardsBadCredit = 'CREDIT_CARDS_BAD_CREDIT',
  CreditScore = 'CREDIT_SCORE',
  DailyDeals = 'DAILY_DEALS',
  EmployeeEqutiy = 'EMPLOYEE_EQUTIY',
  EnergyGasWater = 'ENERGY_GAS_WATER',
  EnergyTaxIncentives = 'ENERGY_TAX_INCENTIVES',
  EstatePlanning = 'ESTATE_PLANNING',
  Finance = 'FINANCE',
  FinancialPlanning = 'FINANCIAL_PLANNING',
  Finanzas = 'FINANZAS',
  FindingHealthInsurance = 'FINDING_HEALTH_INSURANCE',
  FindingRightMortgage = 'FINDING_RIGHT_MORTGAGE',
  GovernmentPolicy = 'GOVERNMENT_POLICY',
  Health = 'HEALTH',
  HolidayTipsNews = 'HOLIDAY_TIPS_NEWS',
  HomeAffordability = 'HOME_AFFORDABILITY',
  Homeownership = 'HOMEOWNERSHIP',
  HomeownershipCosts = 'HOMEOWNERSHIP_COSTS',
  HomeownersInsurance = 'HOMEOWNERS_INSURANCE',
  HomeSearch = 'HOME_SEARCH',
  HowToStartABusiness = 'HOW_TO_START_A_BUSINESS',
  IncomeTaxes = 'INCOME_TAXES',
  Insurance = 'INSURANCE',
  InternetTv = 'INTERNET_TV',
  Investing = 'INVESTING',
  InvestingData = 'INVESTING_DATA',
  InvestingStrategy = 'INVESTING_STRATEGY',
  Investments = 'INVESTMENTS',
  InvestmentTaxes = 'INVESTMENT_TAXES',
  Ira = 'IRA',
  LifeInsurance = 'LIFE_INSURANCE',
  Loans = 'LOANS',
  LowInterestNoFeeCreditCards = 'LOW_INTEREST_NO_FEE_CREDIT_CARDS',
  LoyaltyPrograms = 'LOYALTY_PROGRAMS',
  MakingMoney = 'MAKING_MONEY',
  ManagingHealthInsurance = 'MANAGING_HEALTH_INSURANCE',
  ManagingMedicalBills = 'MANAGING_MEDICAL_BILLS',
  ManagingMoney = 'MANAGING_MONEY',
  ManagingYourMortgage = 'MANAGING_YOUR_MORTGAGE',
  MedicalCosts = 'MEDICAL_COSTS',
  Money = 'MONEY',
  MoneyMarketAccounts = 'MONEY_MARKET_ACCOUNTS',
  MoneyTransfer = 'MONEY_TRANSFER',
  MortgageProcess = 'MORTGAGE_PROCESS',
  MortgageRates = 'MORTGAGE_RATES',
  Mortgages = 'MORTGAGES',
  MyNerdwallet = 'MY_NERDWALLET',
  OtherRetirementAccounts = 'OTHER_RETIREMENT_ACCOUNTS',
  OtherVehicleInsurance = 'OTHER_VEHICLE_INSURANCE',
  PaydayLoans = 'PAYDAY_LOANS',
  PayingOffDebt = 'PAYING_OFF_DEBT',
  Pensions = 'PENSIONS',
  PersonalFinance = 'PERSONAL_FINANCE',
  PersonalLoans = 'PERSONAL_LOANS',
  PersonalLoansReviews = 'PERSONAL_LOANS_REVIEWS',
  PersonalTaxes = 'PERSONAL_TAXES',
  PetInsurance = 'PET_INSURANCE',
  PrepaidDebitCards = 'PREPAID_DEBIT_CARDS',
  ProductComparisons = 'PRODUCT_COMPARISONS',
  Promos = 'PROMOS',
  PropertyTaxes = 'PROPERTY_TAXES',
  RefinanceAutoLoans = 'REFINANCE_AUTO_LOANS',
  RentersInsurance = 'RENTERS_INSURANCE',
  Retirement_401K = 'RETIREMENT_401K',
  RetirementIncome = 'RETIREMENT_INCOME',
  RetirementPlanning = 'RETIREMENT_PLANNING',
  RewardOptimization = 'REWARD_OPTIMIZATION',
  RewardsCreditCards = 'REWARDS_CREDIT_CARDS',
  RothIra = 'ROTH_IRA',
  RunningYourBusiness = 'RUNNING_YOUR_BUSINESS',
  SavingsAccounts = 'SAVINGS_ACCOUNTS',
  SellingYourHome = 'SELLING_YOUR_HOME',
  Shopping = 'SHOPPING',
  ShoppingNews = 'SHOPPING_NEWS',
  ShoppingTips = 'SHOPPING_TIPS',
  SmallBusiness = 'SMALL_BUSINESS',
  SmallBusinessLegal = 'SMALL_BUSINESS_LEGAL',
  SmallBusinessLoans = 'SMALL_BUSINESS_LOANS',
  SmallBusinessTaxes = 'SMALL_BUSINESS_TAXES',
  SocialSecurity = 'SOCIAL_SECURITY',
  StartingABusiness = 'STARTING_A_BUSINESS',
  StoreSavingsGuide = 'STORE_SAVINGS_GUIDE',
  StudentCreditCards = 'STUDENT_CREDIT_CARDS',
  StudentLoans = 'STUDENT_LOANS',
  Studies = 'STUDIES',
  Taxes = 'TAXES',
  Travel = 'TRAVEL',
  TravelCreditCards = 'TRAVEL_CREDIT_CARDS',
  TravelDeals = 'TRAVEL_DEALS',
  TravelInsurance = 'TRAVEL_INSURANCE',
  Utilities = 'UTILITIES',
  VacationAndTripPlanning = 'VACATION_AND_TRIP_PLANNING'
}

/** Type modeling the data within the faqs group of fields on the Article type. */
export type ContentFaq = {
  __typename?: 'ContentFaq';
  /** The FAQ Answer. */
  answer?: Maybe<Scalars['StructuredContentDocument']>;
  /** The FAQ Question. */
  question?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPack = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'ContentPack';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the ContentPack object. */
  categories?: Maybe<Array<Category>>;
  /** The curation type for this Content Pack. */
  curationType?: Maybe<ContentPackCurationTypeEnum>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The heading for this Content Pack. */
  heading?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The content to display for this Content Pack. */
  items?: Maybe<Array<ContentPackItemsUnion>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The display type to use for this Content Pack. */
  listDisplayType?: Maybe<ContentPackListDisplayTypeEnum>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The subtitle to display for this Content Pack. */
  subtitle?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentPackConnectionResponse = {
  __typename?: 'ContentPackConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentPack returned for the connection. */
  items?: Maybe<Array<ContentPack>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for curationType field on ContentPack type. */
export enum ContentPackCurationTypeEnum {
  Default = 'DEFAULT',
  Manual = 'MANUAL',
  MobileContentRecs = 'MOBILE_CONTENT_RECS'
}

/** Query to fetch a collection of ContentPack objects. */
export type ContentPackFilterInput = {
  /** Limit collection to ContentPacks published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to ContentPacks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit collection to ContentPacks with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
};

/** The union containing the Type members that can be returned by the items field on the ContentPack type. */
export type ContentPackItemsUnion = Article | Hub | LandingPage | Page | Post | Review | Roundup;

/** Enum values for listDisplayType field on ContentPack type. */
export enum ContentPackListDisplayTypeEnum {
  Card = 'CARD',
  Carousel = 'CAROUSEL',
  Default = 'DEFAULT'
}

/** Contains a content pack and its meta data */
export type ContentPackPlacement = {
  __typename?: 'ContentPackPlacement';
  /** A single content pack and its associated data */
  contentPack: ContentPack;
  /** The list of model execution IDs used in personalized/fallback content packs */
  modelExecutionIds?: Maybe<Array<Scalars['String']>>;
};

export type ContentPackResponse = {
  __typename?: 'ContentPackResponse';
  /** The list of content packs returned by the query */
  contentPackPlacements?: Maybe<Array<ContentPackPlacement>>;
};

export type ContentPacksOptionsInput = {
  /** If specified, returns either personalized content pack or interest-based content pack */
  includePersonalizedContentPack?: Maybe<Scalars['Boolean']>;
};

/** Common interface containing fields to display within the ContentPageHeader component. */
export type ContentPageHeaderInterface = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  authors?: Maybe<Array<Author>>;
  primaryCategory?: Maybe<Category>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType?: Maybe<Scalars['String']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean'];
};

/** Input args to filter collections of content search results. */
export type ContentSearchFilterInput = {
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to search results within a specific Category. This field accepts an array of integer IDs or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit collection to search results within specific content types. */
  contentTypes?: Maybe<Array<PostTypeEnum>>;
  /** Limit collection to search results with or without specific IDs. */
  ids?: Maybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
};

export type ContentSearchInput = {
  /** A set of content categories to match against */
  categories?: Maybe<Array<ContentCategory>>;
  /** A flag to include highlights - a snippet of copy */
  includeHighlights?: Maybe<Scalars['Boolean']>;
  /** A search string to find related content */
  query?: Maybe<Scalars['String']>;
  /** A map of content attributes to relative importance in weighing search result relevancy */
  queryFieldWeights?: Maybe<ContentSearchQueryFieldsWeightsInput>;
  /** The "format" of the content requested */
  contentTypes?: Maybe<Array<ContentType>>;
  /**
   * The WP Post type is not used to build query params but is used to filter content for requested post types, post-search
   * 
   * This filters on nw_page.content_type, which maps to nw_content_type from the WP API
   * possible values include 'article', 'roundup', 'review' (supported here)
   * and 'calculator', 'marketplace', 'product_detail', & 'tool' (not yet supported)
   */
  postTypes?: Maybe<Array<PostType>>;
};

/**
 * Each available field carries a weight of 1 relative to it's counterparts. You can weigh certain attributes more than others
 * by supplying a weight. For example, a weight of 'Y' is Y times as important as another specified attribute
 */
export type ContentSearchQueryFieldsWeightsInput = {
  /** Weigh search results against author names */
  authorNames?: Maybe<Scalars['Int']>;
  /** Weight search results against category names */
  categoryNames?: Maybe<Scalars['Int']>;
  /** Weigh search results aginst the sanitized content */
  contentSanitized?: Maybe<Scalars['Int']>;
  /** Weigh search results against the content type */
  contentType?: Maybe<Scalars['Int']>;
  /** Weigh search results against the link URL */
  link?: Maybe<Scalars['Int']>;
  /** Weigh search results against the tag names */
  tagNames?: Maybe<Scalars['Int']>;
  /** Weigh search results against the sanitized title */
  titleSanitized?: Maybe<Scalars['Int']>;
};

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResult = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'ContentSearchResult';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /**
   * The legacy synopsis field for a search result. Once we support structured
   * content for the synopsis field we will return a structured content document.
   */
  legacySynopsis?: Maybe<Scalars['String']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The primary category object for the resource. */
  primaryCategory?: Maybe<Category>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentSearchResultConnectionResponse = {
  __typename?: 'ContentSearchResultConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentSearchResult returned for the connection. */
  items?: Maybe<Array<ContentSearchResult>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

export enum ContentSortDirection {
  /** Sort posts in reverse chronological order across all N search queries */
  MostRecent = 'MOST_RECENT',
  /** Sort posts in chronological order across all N search queries */
  Earliest = 'EARLIEST'
}

export enum ContentType {
  Article = 'ARTICLE',
  Review = 'REVIEW',
  Roundup = 'ROUNDUP'
}

/**
 * The `Cookie` type represents a cookie, with all the standard cookie properties.
 * See https://tools.ietf.org/html/rfc6265
 */
export type Cookie = {
  __typename?: 'Cookie';
  name: Scalars['String'];
  value: Scalars['String'];
  expires?: Maybe<Scalars['String']>;
  maxAge?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  secure?: Maybe<Scalars['Boolean']>;
  httpOnly?: Maybe<Scalars['Boolean']>;
  /**
   * A Set-Cookie header literal representing the Cookie
   * 
   * Example: 'AWSALB=n2EKrJVwfmU1FJ0KMGnRY01LfTmkFJmLAF0dNjkuMoW/V7QPwdDatoDKrmzTjDP7j1fO7VTyl/MXjp8Tljq3yM8nmTs9HsSUcZi0f2ik77H9chfNR86RX2ud7zMl; Expires=Fri, 29 Mar 2019 18:47:06 GMT; Path=/'
   */
  headerString: Scalars['String'];
};

export type CreateManualTransactionAccountResponse = {
  __typename?: 'CreateManualTransactionAccountResponse';
  financialAccount: FinancialAccount;
};

export type CreateMoneyTransferAccountResponse = {
  __typename?: 'CreateMoneyTransferAccountResponse';
  account: MoneyTransferAccount;
};

export type CreateMoneyTransferResponse = {
  __typename?: 'CreateMoneyTransferResponse';
  transfer: MoneyTransferTransfer;
};

export type CreditBoosterDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'CreditBoosterDataVisualization';
  /** This will always be CREDIT_BOOSTER */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /** User's credit score info dating back to a week */
  creditScoreChangeInfo: CreditScoreChangeInfo;
};

/**
 * A dictionary of credit card spending by various categories for a user over
 * the period of numOfMonths
 */
export type CreditCardCategorySpending = {
  __typename?: 'CreditCardCategorySpending';
  /** User average spending on dining */
  dining?: Maybe<Scalars['Float']>;
  /** User average spending on entertainment */
  entertainment?: Maybe<Scalars['Float']>;
  /** User average spending on gas */
  gas?: Maybe<Scalars['Float']>;
  /** User average spending on groceries */
  groceries?: Maybe<Scalars['Float']>;
  /** User average spending on other */
  shopping?: Maybe<Scalars['Float']>;
  /** User average spending on travel */
  travel?: Maybe<Scalars['Float']>;
  /** The time horizon of the credit card category spending */
  numOfMonths?: Maybe<Scalars['Int']>;
};

/** Credit Card Institutions */
export type CreditCardInstitution = InstitutionInterface & {
  __typename?: 'CreditCardInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Credit card offer */
export type CreditCardOffer = OfferInterface & {
  __typename?: 'CreditCardOffer';
  derivedDetails?: Maybe<CreditCardOfferDerivedDetails>;
  details: CreditCardOfferDetails;
  endsAt?: Maybe<Scalars['DateTime']>;
  institution: CreditCardInstitution;
  startsAt?: Maybe<Scalars['DateTime']>;
  product?: Maybe<CreditCardProduct>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /**
   * All active related card offers, must query for relatedCardIds in the parent details, and status in relatedCardOffers
   * For example
   *   creditCardOffer {
   *     details {
   *       relatedCardIds
   *     }
   *     relatedCardOffers {
   *       status
   *     }
   *   }
   */
  relatedCreditCardOffers?: Maybe<Array<CreditCardOffer>>;
};

export type CreditCardOfferBundlesResponse = {
  __typename?: 'CreditCardOfferBundlesResponse';
  bundles: Array<CreditCardRecommendationBundle>;
};

/** The derived detail section of a credit card offer */
export type CreditCardOfferDerivedDetails = {
  __typename?: 'CreditCardOfferDerivedDetails';
  /** Link to apply for a credit card offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The likelihood of approval for the card based on the user's credit score bucket */
  approvalLikelihood?: Maybe<Scalars['Float']>;
  /** Interstitial redirect terms and fees link */
  termsFeesRedirectLink?: Maybe<Scalars['URL']>;
  /** The monetary valuation (in cents) per reward point */
  rewardCentsPerUnit?: Maybe<Scalars['Float']>;
  /** The monetary valuation (in cents) per reward point in string format */
  rewardCentsPerUnitString?: Maybe<Scalars['String']>;
};

/** The details section of a credit card offer */
export type CreditCardOfferDetails = {
  __typename?: 'CreditCardOfferDetails';
  /** The annual fee for the card */
  annualFee?: Maybe<Scalars['Float']>;
  /** The display string for annual fee */
  annualFeeDetails?: Maybe<Scalars['String']>;
  /**
   * The likelihood of approval for the card based on the user's credit score bucket
   * @deprecated Use `derivedDetails.approvalLikelihood`
   */
  approvalOdds?: Maybe<Scalars['Float']>;
  /** The minimum APR */
  aprMin?: Maybe<Scalars['Float']>;
  /** The maximum APR */
  aprMax?: Maybe<Scalars['Float']>;
  /** The balance transfer fee as a percentage of the transfer amount */
  balanceTransferFee?: Maybe<Scalars['Float']>;
  /** A more detailed description of balance transfer */
  balanceTransferFeeDescription?: Maybe<Scalars['String']>;
  /** The balance transfer APR */
  balanceTransferIntroApr?: Maybe<Scalars['Float']>;
  /** The term of 'balanceTransferIntroApr', in months */
  balanceTransferInfoTime?: Maybe<Scalars['Int']>;
  /** The display string for the unit the billing cycle is calculated in (e.g. "months") */
  billingCycleUnits?: Maybe<Scalars['String']>;
  /** Custom details like 'credit cards great for:...' */
  customDetailsList?: Maybe<Array<Scalars['String']>>;
  /** A list of negative attributes about the card */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The foreign transaction fee as a percentage of the transaction  amount */
  foreignTransactionFee?: Maybe<Scalars['Float']>;
  /** URL of card image */
  imageSource?: Maybe<Scalars['String']>;
  /** URL of card image (larger format) */
  imageSourceLarge?: Maybe<Scalars['String']>;
  /** URL of card image (medium format) */
  imageSourceMedium?: Maybe<Scalars['String']>;
  /** Boolean flag indicating whether or not an offer is monetizing (revenue generating partnership) */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** The card issuer's information page on their domain */
  issuerInfoUrl?: Maybe<Scalars['URL']>;
  legacyId: Scalars['Int'];
  /** A list of marketing strings about the card */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Marketing strings with terms and fees link removed from list */
  marketingBulletsWithoutTermsFeesLink?: Maybe<Array<Scalars['String']>>;
  /** The maximum FICO recommended for approval */
  maxFico?: Maybe<Scalars['Int']>;
  /** The minimum recommended FICO for approval */
  minFico?: Maybe<Scalars['Int']>;
  /** The regular APR rate after the intro APR offer expires */
  ongoingApr?: Maybe<Scalars['String']>;
  /** List of perks this credit card has */
  perks?: Maybe<Array<Scalars['String']>>;
  /** The program name */
  programName?: Maybe<Scalars['String']>;
  /** A list of positive attributes of the card */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** User-friendly string representing the range of 'aprMin' - 'aprMax' */
  purchaseApr?: Maybe<Scalars['String']>;
  /** The introductory purchase APR for new card owners */
  purchaseIntroApr?: Maybe<Scalars['Float']>;
  /** The introductory length of the intro purchase APR in months (maps from purchase_intro_time) */
  purchaseIntroTerm?: Maybe<Scalars['Int']>;
  /** NerdWallet review star rating */
  rating?: Maybe<Scalars['Float']>;
  /** Cards related to this offer */
  relatedCardIds?: Maybe<Array<Scalars['Int']>>;
  /** URL to articles with related content to this card */
  relatedContent?: Maybe<Array<Scalars['String']>>;
  rewardCategoriesBestRates?: Maybe<Array<CreditCardOfferRewardCategories>>;
  /** More in depth detailed notes about the credit card offer */
  rewardRateNotes?: Maybe<Scalars['String']>;
  /** Type of reward units earned by this offer */
  rewardType?: Maybe<CreditCardOfferRewardType>;
  slug?: Maybe<Scalars['String']>;
  /** A link to the card's terms and fees, if applicable */
  termsFeesLink?: Maybe<Scalars['URL']>;
  /** Offer version id */
  versionId?: Maybe<Scalars['Int']>;
  /** Phone number for some issuers that allow calling to apply */
  applyPayPerCall?: Maybe<Scalars['String']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

/** Breakdown of bonus categories for this credit card offer */
export type CreditCardOfferRewardCategories = {
  __typename?: 'CreditCardOfferRewardCategories';
  category: CreditCardOfferRewardCategoryType;
  rate: Scalars['Float'];
};

export type CreditCardOfferRewardCategoryRates = {
  __typename?: 'CreditCardOfferRewardCategoryRates';
  dining: Scalars['Float'];
  entertainment: Scalars['Float'];
  gas: Scalars['Float'];
  groceries: Scalars['Float'];
  shopping: Scalars['Float'];
  travel: Scalars['Float'];
};

/**
 * Bonus categories of credit card offers
 * https://finproservices.nerdwallet.biz/flask_admin/rewardcategory/
 */
export enum CreditCardOfferRewardCategoryType {
  All = 'ALL',
  Airfare = 'AIRFARE',
  Bookstores = 'BOOKSTORES',
  Business = 'BUSINESS',
  CarRental = 'CAR_RENTAL',
  CarWashes = 'CAR_WASHES',
  Charity = 'CHARITY',
  Dining = 'DINING',
  Discount = 'DISCOUNT',
  Drugstores = 'DRUGSTORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprove = 'HOME_IMPROVE',
  Hotel = 'HOTEL',
  Lodging = 'LODGING',
  Movies = 'MOVIES',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Playstation = 'PLAYSTATION',
  RentalCars = 'RENTAL_CARS',
  Telecom = 'TELECOM',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  Wireless = 'WIRELESS',
  Overall = 'OVERALL'
}

/** Type of rewards this credit card offer gives */
export enum CreditCardOfferRewardType {
  Cash = 'CASH',
  Points = 'POINTS',
  NoRewards = 'NO_REWARDS',
  Miles = 'MILES'
}

export type CreditCardOffersNamedQueriesResponse = {
  __typename?: 'creditCardOffersNamedQueriesResponse';
  offers?: Maybe<Array<CreditCardOffer>>;
};

/** Query variables for the credit card offers query */
export type CreditCardOffersParameters = {
  debtPayment?: Maybe<Scalars['Int']>;
  ficoScore?: Maybe<Scalars['Int']>;
  numberOfMonths?: Maybe<Scalars['Int']>;
  totalDebt?: Maybe<Scalars['Int']>;
  categorySpend?: Maybe<CreditCardOffersParametersCategorySpend>;
  existingCardApr?: Maybe<Scalars['Float']>;
};

/** Input parameters for credit card offers marketplace queries */
export type CreditCardOffersParametersCategorySpend = {
  dining?: Maybe<Scalars['Int']>;
  gas?: Maybe<Scalars['Int']>;
  groceries?: Maybe<Scalars['Int']>;
  office?: Maybe<Scalars['Int']>;
  travel?: Maybe<Scalars['Int']>;
  other?: Maybe<Scalars['Int']>;
};

/** The response from a credit card offer query. */
export type CreditCardOffersResponse = {
  __typename?: 'CreditCardOffersResponse';
  /** The total number of offers that match your query. */
  total: Scalars['Int'];
  offers: Array<CreditCardOffer>;
  offset: Scalars['Int'];
};

/**
 * Since there are overlapping fields across the cc-prequal and personal-loans-prequal
 * services, the inputs are split into 3 different parts for better code reusability.
 */
export type CreditCardPrequalInput = {
  firstName: Scalars['String'];
  middleInitial?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  streetAddress: Scalars['String'];
  streetAddressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
  /** Last four digits of user's SSN */
  lastFour: Scalars['String'];
  /** User's date of birth in MM/DD/YYYY format */
  dateOfBirth: Scalars['String'];
  /** Agrees to terms of service */
  agreeToTos: Scalars['Boolean'];
  /** Credit card issuers they would like to see offers from */
  issuers: Array<CreditCardPrequalIssuersEnum>;
};

/** Enums for issuers. */
export enum CreditCardPrequalIssuersEnum {
  Chase = 'CHASE',
  CapitalOne = 'CAPITAL_ONE',
  AmericanExpress = 'AMERICAN_EXPRESS'
}

/** This creates the schema for a singular credit card/offer and refers to the response JSON. */
export type CreditCardPrequalOffer = {
  __typename?: 'CreditCardPrequalOffer';
  /** Issuer card identifier */
  sourceCode: Scalars['String'];
  /** The card's image details */
  cardImageDetails: CardImageDetails;
  /** Indicates if prescreen or prequal offer */
  isPrescreen: Scalars['Boolean'];
  /** Apply now URL */
  applyNowUrl: Scalars['URL'];
  /** Marketing bullets are used for bonus offer and additional info */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Purchase APR */
  purchaseRegularApr?: Maybe<Scalars['String']>;
  /** Balance transfer APR */
  balanceTransferRegApr?: Maybe<Scalars['String']>;
  /** Purchase introduction APR */
  purchaseIntroductionApr?: Maybe<Scalars['String']>;
  /** Balance transfer intro APR */
  balanceTransferIntroApr?: Maybe<Scalars['String']>;
  /**
   * cc-prequal-service receives a lot of the necessary fields from marketplace, which is passed
   * into the CreditCardOffer type. The remaining fields above are from the actual cc-prequal-service
   */
  creditCardOffer: CreditCardOffer;
};

export type CreditCardPrequalOffersResponse = {
  __typename?: 'CreditCardPrequalOffersResponse';
  /** In order to have working apply now links, we need to set the X-PREQUAL-COOKIE-ID cookie */
  prequalCookieId: Scalars['String'];
  offers?: Maybe<Array<CreditCardPrequalOffer>>;
};

/** Credit Card Product */
export type CreditCardProduct = ProductInterface & {
  __typename?: 'CreditCardProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The `CreditCardRecommendationBundle` represents one recommendation bundle from recommendationServiceApi. */
export type CreditCardRecommendationBundle = {
  __typename?: 'CreditCardRecommendationBundle';
  header?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  teaser?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  trackingId?: Maybe<Scalars['String']>;
  creditCardOffers?: Maybe<Array<CreditCardOffer>>;
  primaryAction?: Maybe<AppAction>;
};

/** A Credit Cards institution */
export type CreditCardsInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'CreditCardsInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Credit Cards offer */
export type CreditCardsOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'CreditCardsOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The approval calculation for logged in members. */
  approvalLikelihood?: Maybe<Scalars['Float']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Legacy ID used by some Credit Card specific components. */
  legacyId?: Maybe<Scalars['Int']>;
  /** The calculated match score value for the associated offer. A number between 5 and 99. */
  matchScore?: Maybe<Scalars['Int']>;
  /** Maximum reccommended FICO score */
  maxFico?: Maybe<Scalars['Int']>;
  /** Minimum reccommended FICO score */
  minFico?: Maybe<Scalars['Int']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** A product's apply by phone telephone number, if applicable. Displays below the CTA on product cards, typically. */
  phoneNumber?: Maybe<Scalars['String']>;
  product: CreditCardsProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /**
   * Path to the product's card details page. Keep it simple, and avoid including
   * payment network where possible. ex. 'chase-freedom-unlimited' or
   * 'us-bank-altitude-go-card'
   */
  slug?: Maybe<Scalars['String']>;
  /** Numeric value of the rating Content has assigned the product */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** A Credit Cards product */
export type CreditCardsProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'CreditCardsProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: CreditCardsInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type CreditFactor = {
  __typename?: 'CreditFactor';
  /** All common questions about this credit factor */
  commonQuestions?: Maybe<Array<CreditFactorCommonQuestion>>;
  /** Data about the core metric for this factor */
  coreMetric?: Maybe<CreditFactorCoreMetric>;
  /** The impact level of this factor on the user's credit score */
  impactLevel?: Maybe<CreditFactorImpactLevel>;
  /** All inquiry sections (only used in recentInquiries factor) */
  inquirySections?: Maybe<Array<CreditFactorInquirySection>>;
  /** The priority inquiry section (only used in recentInquiries factor) */
  priorityInquirySection?: Maybe<CreditFactorInquirySection>;
  /** A list of links to get more information about this factor */
  moreInfoLinks?: Maybe<Array<AppAction>>;
  /** The datetime the user's credit report was last pulled */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /** The priority tradeline section (used in all factors other than recentInquiries) */
  priorityTradelineSection?: Maybe<CreditFactorTradelineSection>;
  /** All tradeline sections (used in all factors other than recentInquiries) */
  tradelineSections?: Maybe<Array<CreditFactorTradelineSection>>;
};

export type CreditFactorCommonQuestion = {
  __typename?: 'CreditFactorCommonQuestion';
  /** The answer to the question, separated as paragraphs */
  answerParagraphs?: Maybe<Array<Scalars['String']>>;
  /** A unique identifier for this question */
  key?: Maybe<Scalars['String']>;
  /** The question */
  question?: Maybe<Scalars['String']>;
  /** An optional link to find out more (typically links to an article) */
  learnMoreLink?: Maybe<AppAction>;
};

export type CreditFactorCoreMetric = {
  __typename?: 'CreditFactorCoreMetric';
  /** The NerdWallet suggestion for the credit factor */
  commentary?: Maybe<Scalars['String']>;
  /** The tooltip description for the status of the credit factor */
  description?: Maybe<Scalars['String']>;
  /** The main headline figure for the core metric of the factor */
  displayName?: Maybe<Scalars['String']>;
  /** The label for the displayName */
  label?: Maybe<Scalars['String']>;
  /** The primary value of the core metric (for analytics purposes) */
  value?: Maybe<Scalars['String']>;
  /** An optional secondary value for some factors (for analytics purposes) */
  secondaryValue?: Maybe<Scalars['String']>;
};

export enum CreditFactorImpactLevel {
  Highest = 'HIGHEST',
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW'
}

export type CreditFactorInquiry = {
  __typename?: 'CreditFactorInquiry';
  /** The bureau responsible for the inquiry */
  bureau?: Maybe<Scalars['String']>;
  /** A non-guaranteed unique identifier for this inquiry */
  compositeKey?: Maybe<Scalars['String']>;
  /** The industry the inquirer is in */
  industry?: Maybe<Scalars['String']>;
  /** The date of the inquiry */
  inquiredAt?: Maybe<Scalars['DateTime']>;
  /** The type of inquiry */
  inquiryType?: Maybe<Scalars['String']>;
  /**
   * True if the inquiry has "fallen off" of the user's credit report: exists on
   * their second-most-recent credit report, but not on their most recent credit report.
   */
  isNoLongerValid?: Maybe<Scalars['Boolean']>;
  /** The name of the creditor that made the inquiry */
  subscriberName?: Maybe<Scalars['String']>;
};

export type CreditFactorInquirySection = {
  __typename?: 'CreditFactorInquirySection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']>;
  /** The list of all inquiries on the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** True for groups of inquiries that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']>;
  /** The user-facing label describing the sentiment of the inquiry section */
  label?: Maybe<Scalars['String']>;
  /** The sentiment of the inquiry section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The full length title for the section (only use in priority sections) */
  title?: Maybe<Scalars['String']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
};

export type CreditFactors = {
  __typename?: 'CreditFactors';
  ageAndMixOfAccounts?: Maybe<CreditFactor>;
  balances?: Maybe<CreditFactor>;
  creditUtilization?: Maybe<CreditFactor>;
  paymentHistory?: Maybe<CreditFactor>;
  recentInquiries?: Maybe<CreditFactor>;
  numTradelines?: Maybe<Scalars['Int']>;
};

export enum CreditFactorSentiment {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

/** Metadata passed to analytics events */
export type CreditFactorTrackingMetadata = {
  __typename?: 'CreditFactorTrackingMetadata';
  /** The sentiment of the credit factor or "-" */
  highlightStatus?: Maybe<Scalars['String']>;
  /** The change in account status (used in the ageAndMixOfAccounts factor) */
  accountStatusChange?: Maybe<Scalars['String']>;
  /** The change in inquiry status (used in the recentInquiries factor) */
  inquiryStatusChange?: Maybe<Scalars['String']>;
  /** The derogatory payment type (optional) (used in the paymentHistory factor) */
  paymentDerogatoryType?: Maybe<Scalars['String']>;
  /** The change in payment status (used in the paymentHistory factor) */
  paymentStatusChange?: Maybe<Scalars['String']>;
  /** The current bucket of credit utilization, as defined by NW (used in the creditUtilization factor) */
  utilizationCurrentBucket?: Maybe<Scalars['String']>;
  /** The direction of change of credit utilization (used in the creditUtilization factor) */
  utilizationDirectionChange?: Maybe<Scalars['String']>;
};

export type CreditFactorTradeline = {
  __typename?: 'CreditFactorTradeline';
  /** The condition of the account */
  accountCondition?: Maybe<Scalars['String']>;
  /** The party responsible for the account (e.g. Individual) */
  accountDesignator?: Maybe<Scalars['String']>;
  /** The last 4 digits on the account */
  accountNumberLast4?: Maybe<Scalars['String']>;
  /** The type of tradeline (e.g. Installment / Credit Card) */
  accountType?: Maybe<Scalars['String']>;
  /** The 1-character symbol for the account type */
  accountTypeSymbol?: Maybe<Scalars['String']>;
  /** The amount due on the due date */
  amountPastDue?: Maybe<Scalars['Float']>;
  /** A non-guaranteed unique identifier for this tradeline for this user */
  compositeKey?: Maybe<Scalars['String']>;
  /** The user friendly name for the creditor */
  creditorDisplayName?: Maybe<Scalars['String']>;
  /** A URL for the logo of the creditor */
  creditorLogo?: Maybe<Scalars['String']>;
  /** The raw name of the creditor */
  creditorName?: Maybe<Scalars['String']>;
  /** The balance on the account */
  currentBalance?: Maybe<Scalars['Float']>;
  /** The date the account was opened */
  dateOpenedAt?: Maybe<Scalars['DateTime']>;
  /** The most recent date the account was reported */
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  /** The monthly payment for the account */
  monthlyPayment?: Maybe<Scalars['Float']>;
  /** The normalized credit limit */
  nwCreditLimitNormalized?: Maybe<Scalars['Float']>;
  /** The number of months the account has been open */
  nwMonthsOpened?: Maybe<Scalars['Int']>;
  /** The utilization on the account (decimal between 0 and 1) */
  nwUtilizationPct?: Maybe<Scalars['Float']>;
  /** The open/closed symbol of the account */
  openClosedSymbol?: Maybe<CreditFactorTradelineOpenClosedSymbol>;
  /** The pay history of the account */
  payHistoryBreakDown?: Maybe<Array<CreditFactorTradelinePayHistoryDatum>>;
  /** The current pay status of the account (raw) */
  payStatus?: Maybe<Scalars['String']>;
  /** The current pay status of the account (user-friendly) */
  payStatusDisplayName?: Maybe<Scalars['String']>;
  /** An optional remark on the account */
  remark?: Maybe<Scalars['String']>;
  /** The length of the loan in months */
  termMonths?: Maybe<Scalars['Int']>;
  /** The user-friendly name for the tradeline */
  tradelineDisplayName?: Maybe<Scalars['String']>;
};

export enum CreditFactorTradelineOpenClosedSymbol {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type CreditFactorTradelinePayHistoryDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryDatum';
  /** The date that the corresponding status was submitted */
  date?: Maybe<Scalars['DateTime']>;
  /** The pay status for the tradeline */
  status?: Maybe<CreditHistoryPayStatusCode>;
};

export type CreditFactorTradelineSection = {
  __typename?: 'CreditFactorTradelineSection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']>;
  /** True for groups of tradelines that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the section */
  key?: Maybe<Scalars['String']>;
  /** The user-facing label describing the sentiment of the tradeline section */
  label?: Maybe<Scalars['String']>;
  /** The sentiment of the tradeline section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The subtitle describing the tradeline section */
  subtitle?: Maybe<Scalars['String']>;
  /** The title of the tradeline section */
  title?: Maybe<Scalars['String']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
  /** All tradelines associated with this section */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
};

export enum CreditHistoryPayStatusCode {
  Current = 'CURRENT',
  Unknown = 'UNKNOWN',
  Late_30Days = 'LATE_30_DAYS',
  Late_60Days = 'LATE_60_DAYS',
  Late_90Days = 'LATE_90_DAYS',
  Late_120Days = 'LATE_120_DAYS',
  Late_150Days = 'LATE_150_DAYS',
  PaymentPlan = 'PAYMENT_PLAN',
  Repossession = 'REPOSSESSION',
  CollectionChargeoff = 'COLLECTION_CHARGEOFF'
}

export type CreditProfileAuthAnswer = {
  __typename?: 'CreditProfileAuthAnswer';
  /** The ID of the answer */
  id: Scalars['String'];
  /** The value of the answer */
  text: Scalars['String'];
  /** The order to show the answer */
  sequence: Scalars['Int'];
};

export type CreditProfileAuthAnswerInput = {
  /** The ID of the question */
  questionId: Scalars['String'];
  /** The ID of the answer */
  answerId: Scalars['String'];
};

export type CreditProfileAuthCustomerInput = {
  /** User's full SSN (e.g. "123456789") */
  fullSsn?: Maybe<Scalars['String']>;
  /** User's last four of SSN (e.g. "1234") */
  partialSsn?: Maybe<Scalars['String']>;
  /** User's first name */
  firstName: Scalars['String'];
  /** User's last name */
  lastName: Scalars['String'];
  /** User's date of birth in the format YYYY-MM-DD */
  dateOfBirth: Scalars['Date'];
  /** User's mailing address */
  mailingAddress: IdentityAddressInput;
  /** User's middle name */
  middleName?: Maybe<Scalars['String']>;
  /** User's prefix */
  prefix?: Maybe<Scalars['String']>;
  /** User's suffix */
  suffix?: Maybe<Scalars['String']>;
  /** User's previous address */
  previousAddress?: Maybe<IdentityAddressInput>;
};

export type CreditProfileAuthQuestion = {
  __typename?: 'CreditProfileAuthQuestion';
  /** The ID of the question */
  id: Scalars['String'];
  /** The type of the question */
  type: Scalars['String'];
  /** The question itself as text */
  text: Scalars['String'];
  /** The order to show the question */
  sequence: Scalars['Int'];
  /** The list of answer choices */
  answers: Array<CreditProfileAuthAnswer>;
};

export enum CreditProfileAuthStatus {
  Active = 'ACTIVE',
  Authenticated = 'AUTHENTICATED',
  Blocked = 'BLOCKED',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING'
}

/**
 * The `CreditProfileAuthStatusProfile` represents a TransUnion Authentication Status.
 * Github link (TUAuthenticationStatusProfile): https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type CreditProfileAuthStatusProfile = {
  __typename?: 'CreditProfileAuthStatusProfile';
  /** What is the status of the TU link (PENDING, ACTIVE, AUTHENTICATED, etc.) */
  status: CreditProfileAuthStatus;
  /** When was the profile authenticated at */
  authenticatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile activated at */
  activatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile deactivated at */
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile reactivated at */
  reactivatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile blocked at */
  blockedAt?: Maybe<Scalars['DateTime']>;
  /** List of questions to authenticate */
  questions?: Maybe<Array<CreditProfileAuthQuestion>>;
  /** Indicates if the user has a thin file */
  hasThinFile?: Maybe<Scalars['Boolean']>;
  /** Reason for the thin file */
  thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
  /** Is the user deceased */
  isDeceased?: Maybe<Scalars['Boolean']>;
  /** Indicates if there is not enough data */
  notEnoughData?: Maybe<Scalars['Boolean']>;
  /** Number of pulls in the past 24 hours */
  numPullsInPast24Hours?: Maybe<Scalars['Int']>;
  /** TU ID */
  tuId?: Maybe<Scalars['String']>;
  /** The previous status */
  previousStatus?: Maybe<CreditProfileAuthStatus>;
  /** Short message about the status of the operation (TU Initialized, User Already Active, etc.) */
  message?: Maybe<Scalars['String']>;
  /** More details on top of the message (e.g. User already has activated TU on same NW account) */
  description?: Maybe<Scalars['String']>;
};

export enum CreditProfileAuthThinFileReason {
  /** TU is enforcing rate limiting */
  Duplicate = 'DUPLICATE',
  /** True ThinFile - user lacks enough data to generate exam */
  NoData = 'NO_DATA',
  /** User has been 'fuzzy matched' but something doesn't look right */
  FailVerification = 'FAIL_VERIFICATION',
  /** Catch all */
  Other = 'OTHER'
}

export type CreditScoreActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CreditScoreActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
  /** If the user is blocked from using the Credit Score feature, this field indicates the reason why. */
  blockedReason?: Maybe<CreditScoreBlockedReasonEnum>;
};

export type CreditScoreActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'CreditScoreActivationVisualization';
  /** This will always be CREDIT_SCORE_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/**
 * This enum represents each of the possible reasons why the user might be blocked from using the Credit Score feature.
 * 
 * Note that it intentionally deviates from the semantics of the underlying data model in order to better align
 * with the product experience.
 */
export enum CreditScoreBlockedReasonEnum {
  Deceased = 'DECEASED',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  NotEnoughData = 'NOT_ENOUGH_DATA',
  RateLimited = 'RATE_LIMITED',
  ThinFile = 'THIN_FILE'
}

export type CreditScoreChangeInfo = {
  __typename?: 'CreditScoreChangeInfo';
  /** User's current credit score */
  currentScore?: Maybe<Scalars['Int']>;
  /** User's previous credit score */
  previousScore?: Maybe<Scalars['Int']>;
  /** User's projected future credit score */
  projectedScore?: Maybe<Scalars['Int']>;
  /** User's current credit bucket */
  currentBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's previous credit bucket */
  previousBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's projected future credit bucket */
  projectedBucket?: Maybe<TuVantageScore3Buckets>;
};

/** A user insight sourced from credit-service */
export type CreditScoreInsight = UserInsightInterface & {
  __typename?: 'CreditScoreInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   * 
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   * 
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   * 
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   * 
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   * 
   * For exmaple, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   * 
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   * 
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   * 
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   * 
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

/** The object representing the size of the image. */
export type CroppedImageSize = {
  __typename?: 'CroppedImageSize';
  /** The file name for this crop size. */
  file?: Maybe<Scalars['String']>;
  /** The height of this crop size in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The mime type for this crop size. */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the crop size. */
  size: MediaItemImageSizeEnum;
  /** The full url path to the crop of this image. */
  sourceUrl?: Maybe<Scalars['URL']>;
  /** The width of this crop size in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type CursorPaginationInput = {
  /** The ID of the item from which pagination should start reading backwards. */
  before?: Maybe<Scalars['ID']>;
  /** The ID of the item from which pagination should start reading forwards. */
  after?: Maybe<Scalars['ID']>;
  /** The number of items to return in the pagination */
  limit?: Maybe<Scalars['Int']>;
};




export enum DebtActivationState {
  Unknown = 'Unknown',
  Unactivated = 'Unactivated',
  Activated = 'Activated',
  BlockedTu = 'BlockedTU',
  BlockedDti = 'BlockedDTI',
  BlockedNoDebtTradelines = 'BlockedNoDebtTradelines'
}

export type DebtRecentChange = {
  __typename?: 'DebtRecentChange';
  actions?: Maybe<Array<AppAction>>;
  body?: Maybe<Scalars['String']>;
  condition: Scalars['String'];
  debtType?: Maybe<DebtTypes>;
  label?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  takeaway?: Maybe<Scalars['String']>;
};

export type DebtSummary = {
  __typename?: 'DebtSummary';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activationState?: Maybe<DebtActivationState>;
  annualGrossIncome?: Maybe<Scalars['Float']>;
  debtFreeDateFormat?: Maybe<Scalars['DateTime']>;
  /**
   * A user-friendly approximation of how much time until they will be debt-free
   * 
   * Example: `9¾ years`
   */
  debtFreeDateDisplayString?: Maybe<Scalars['String']>;
  isRecentlyActivatedUser?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  previousTotalDebtAmount?: Maybe<Scalars['Float']>;
  primaryDebtMotivation?: Maybe<Scalars['String']>;
  recentChanges?: Maybe<Array<DebtRecentChange>>;
  totalDebtAmount?: Maybe<Scalars['Float']>;
  /** The percent change from the user’s previous total debt amount to their current total debt amount */
  totalDebtChangePercent?: Maybe<Scalars['Float']>;
};

export enum DebtTypes {
  CreditCard = 'credit_card',
  AutoLoan = 'auto_loan',
  PersonalLoan = 'personal_loan',
  StudentLoan = 'student_loan',
  Deferred = 'deferred'
}

export type DeleteFinancialPortalResponse = {
  __typename?: 'DeleteFinancialPortalResponse';
  success: Scalars['Boolean'];
};

export type DeleteFinancialTransactionResponse = {
  __typename?: 'DeleteFinancialTransactionResponse';
  success: Scalars['Boolean'];
};

/** Wraps the delete net worth real API response, which allows for adding fields at a later date */
export type DeleteNetWorthRealAssetResponse = {
  __typename?: 'DeleteNetWorthRealAssetResponse';
  success: Scalars['Boolean'];
};

/**
 * Wraps the edit Net Worth Real Asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type EditNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'EditNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

/** A Education Loans institution */
export type EducationLoansInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'EducationLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Education Loans offer */
export type EducationLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'EducationLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** Available term lengths for the offer */
  availableTermLengths?: Maybe<Scalars['String']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  product: EducationLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriverInterface>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Education Loans product */
export type EducationLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'EducationLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: EducationLoansInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};


/** A type that represents an empty object. */
export type EmptyObject = {
  __typename?: 'EmptyObject';
  _empty?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPost = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'EngineeringPost';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /**
   * The topic that should be used as the 'Attribution Topic' for this piece of
   * content. This value is used for attributing metrics related to this piece of
   * content in analytics reports.
   */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The content clusters for this piece of content. Content clusters are meant to be arbitrary groupings of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostExcerptArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type EngineeringPostConnectionResponse = {
  __typename?: 'EngineeringPostConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The EngineeringPost returned for the connection. */
  items?: Maybe<Array<EngineeringPost>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of EngineeringPost objects. */
export type EngineeringPostFilterInput = {
  /** Limit collection to EngineeringPosts published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: Maybe<Scalars['String']>;
  /** Limit collection to EngineeringPosts with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit collection to EngineeringPosts with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

export type EntityPlacementAnalyticsProps = {
  __typename?: 'EntityPlacementAnalyticsProps';
  /** The marketplace UUID for the associated institution. */
  institutionId: Scalars['ID'];
  /** The marketplace UUID for the associated offer. Null for institutions and products. */
  offerId?: Maybe<Scalars['ID']>;
  /** The marketplace UUID for the associated product. Null for institutions. */
  productId?: Maybe<Scalars['ID']>;
  /**
   * Boolean indicating if the entity can log a legacy impression. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  hasLegacyImpression: Scalars['Boolean'];
  /**
   * Additional data to be sent to legacy impression events. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  legacyAdditionalEventData?: Maybe<Scalars['JSON']>;
  /**
   * The entity's issuer name. This is only used for legacy analytics and can be removed after
   * the Bedrock cutover.
   */
  legacyIssuer: Scalars['String'];
  /**
   * The entity slug. This is only used for legacy analytics and can be removed after
   * the Bedrock cutover.
   */
  legacySlug?: Maybe<Scalars['String']>;
  /**
   * The vertical name to use to map to the legacy impression. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  legacyVertical?: Maybe<Scalars['String']>;
};

export type EntityPlacementCta = {
  __typename?: 'EntityPlacementCTA';
  /** The destination url of the CTA */
  link: Scalars['URL'];
  /** Whether or not to show the icon in the CTA */
  showIcon: Scalars['Boolean'];
  /** The text to show underneath the CTA button */
  subtext?: Maybe<Scalars['String']>;
  /** The button/link text to show for the CTA */
  text: Scalars['String'];
  /** The ultimate destination type of the CTA */
  type: EntityPlacementCtaTypeEnum;
};

export enum EntityPlacementCtaTypeEnum {
  ApplyNow = 'APPLY_NOW',
  Prequal = 'PREQUAL',
  ReadReview = 'READ_REVIEW'
}

export type EntityPlacementDriver = EntityPlacementDriverInterface & {
  __typename?: 'EntityPlacementDriver';
  /** The driver description */
  description?: Maybe<Scalars['StructuredContentDocument']>;
  /** The driver label */
  label: Scalars['String'];
  /** The tooltip associated with the driver label */
  labelTooltip?: Maybe<Scalars['String']>;
  /** The driver value */
  value?: Maybe<Scalars['StructuredContentDocument']>;
  /** The driver tooltip */
  tooltip?: Maybe<Scalars['StructuredContentDocument']>;
};

export type EntityPlacementDriverInterface = {
  /** The driver description */
  description?: Maybe<Scalars['StructuredContentDocument']>;
  /** The driver label */
  label: Scalars['String'];
  /** The tooltip associated with the driver label */
  labelTooltip?: Maybe<Scalars['String']>;
  /** The driver value */
  value?: Maybe<Scalars['StructuredContentDocument']>;
};

export type EntityPlacementImage = {
  __typename?: 'EntityPlacementImage';
  /** The alt text that will accompany the logo */
  alt?: Maybe<Scalars['String']>;
  /** The URL for the logo */
  source?: Maybe<Scalars['URL']>;
  /** The URL for the large-size logo */
  sourceLarge?: Maybe<Scalars['URL']>;
  /** The URL for the medium-size logo */
  sourceMedium?: Maybe<Scalars['URL']>;
};

export type ExpandedMarketplaceStaticOffer = {
  __typename?: 'ExpandedMarketplaceStaticOffer';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** Loan amount retrieved from the user's profile */
  loanAmount: Scalars['Float'];
  /**
   * Loan term months is hardcoded to 24 because we don't have an input asking for
   * loan term, but we need loan term to calculate monthly payment
   */
  loanTermMonths: Scalars['Int'];
};

export type Experiment = {
  __typename?: 'Experiment';
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** The ID of the experiment */
  experimentId: Scalars['String'];
  /**
   * The ID of the variant the requesting user is bucketed into.
   * This accounts for variants forced using a request header or query param on the
   * originating URL of the form `test_[testname]=[variantname]`
   */
  assignedVariant: Scalars['String'];
  /**
   * The name of the variant the requesting user is bucketed into.
   * This accounts for variants forced using a request header or query param on the
   * originating URL of the form `test_[testname]=[variantname]`
   */
  assignedVariantName: Scalars['String'];
  /**
   * Is the variant forced via query param. Variants can be forced using a request
   * header or query param on the originating URL of the form
   * `test_[testname]=[variantname]`
   */
  isForcedVariant: Scalars['Boolean'];
  rampNum: Scalars['Int'];
  usesEEE: Scalars['Boolean'];
  variants: Array<Maybe<Variant>>;
};

/** FacetCategory represents the category name, the number of matched WP entites, and whether it was selected */
export type FacetCategory = {
  __typename?: 'FacetCategory';
  value: Scalars['String'];
  count: Scalars['Int'];
  selected: Scalars['Boolean'];
};

/** FacetContentType represents more about the WP entities returned by the search */
export type FacetContentType = {
  __typename?: 'FacetContentType';
  value: Scalars['String'];
  count: Scalars['Int'];
  selected: Scalars['Boolean'];
};

/** Facets are metadata about the search results, particularly a list of results grouped by category and content type */
export type Facets = {
  __typename?: 'Facets';
  /** The name of the category */
  category?: Maybe<Array<FacetCategory>>;
  /** The content-type */
  contentType?: Maybe<Array<FacetContentType>>;
};

export enum FdpOptInState {
  Ineligible = 'INELIGIBLE',
  Eligible = 'ELIGIBLE',
  Dismissed = 'DISMISSED',
  OptedIn = 'OPTED_IN',
  Completed = 'COMPLETED',
  Error = 'ERROR'
}

export type FdpOptInStateResponse = {
  __typename?: 'FDPOptInStateResponse';
  state: FdpOptInState;
};

export type FeatureDiscoveryResponse = {
  __typename?: 'FeatureDiscoveryResponse';
  isEnabled: Scalars['Boolean'];
  details?: Maybe<WebFeatureDiscoveryDetails>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** The name of the feature flag */
  name: Scalars['String'];
  /**
   * The value of the feature flag.
   * This accounts for values forced using a request header or query param on the
   * originating URL of the form `feat_[featurename]=[true|false]`
   */
  value: Scalars['Boolean'];
  /**
   * Extra feature data
   * This accounts for values forced using a request header or query param on the
   * originating URL of the form `feat_[featurename]_data=<stringified_json>`
   */
  extraData?: Maybe<Scalars['JSON']>;
  /**
   * Is the value or extraData forced.
   * values can be forced using a request header or query param on the originating
   * URL of the form `feat_[featurename]=[true|false]`
   * extraData can be forced using a request header or query param on the
   * originating URL of the form `feat_[featurename]_data=<stringified_json>`
   */
  isForced: Scalars['Boolean'];
};

/** The `FeedCard` represents the card JSON shape. */
export type FeedCard = {
  __typename?: 'FeedCard';
  id: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  cardTemplate?: Maybe<FeedCardTemplate>;
  recommendation?: Maybe<FeedCardRecommendation>;
  fields?: Maybe<FeedCardFields>;
  displayPlatforms?: Maybe<Scalars['String']>;
  indexInStatement?: Maybe<Scalars['Int']>;
};

/** The `FeedCardAction` type represents shape each item in the primary_actions JSON array takes. */
export type FeedCardAction = {
  __typename?: 'FeedCardAction';
  href?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

/**
 * The `FeedCardFields` represents the fields JSON shape. Data contains all fields not shared
 * by all card templates. cardActions will be renamed primaryActions to match the
 * JSON response once the apollo plural codegen error is resolved.
 */
export type FeedCardFields = {
  __typename?: 'FeedCardFields';
  data?: Maybe<Scalars['JSON']>;
  primaryAction?: Maybe<FeedCardPrimaryAction>;
  cardActions?: Maybe<Array<Maybe<FeedCardAction>>>;
  primaryCta?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** A user insight sourced from the Feed CMS (includes feed cards and Nerds-Eye View items) */
export type FeedCardInsight = UserInsightInterface & {
  __typename?: 'FeedCardInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   * 
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   * 
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   * 
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   * 
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   * 
   * For exmaple, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   * 
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   * 
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   * 
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   * 
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The number of days after which a FeedCardInsight can be considered "new" to the user.
   * 
   * Clients should disregard all local user engagement data that is older than this value.
   */
  expiresInDays?: Maybe<Scalars['Int']>;
};

/** The `FeedCardPrimaryAction` represents the primary_action JSON shape. */
export type FeedCardPrimaryAction = {
  __typename?: 'FeedCardPrimaryAction';
  mobileTarget?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** The `FeedCardRecommendation` represents the recommendation JSON shape. */
export type FeedCardRecommendation = {
  __typename?: 'FeedCardRecommendation';
  id: Scalars['Int'];
  actionTarget?: Maybe<Scalars['String']>;
  actionText?: Maybe<Scalars['String']>;
  actionType?: Maybe<Scalars['String']>;
  actionMobileTarget?: Maybe<Scalars['String']>;
};

/** The `FeedCardTemplate` represents the card_template JSON shape. */
export type FeedCardTemplate = {
  __typename?: 'FeedCardTemplate';
  id?: Maybe<Scalars['String']>;
  renderId?: Maybe<Scalars['String']>;
};

/** The `FeedStatement` represents the statement JSON shape. */
export type FeedStatement = {
  __typename?: 'FeedStatement';
  id: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/accounts
 */
export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  autoRefreshRequired?: Maybe<Scalars['Boolean']>;
  /**  The "cent-normalized" account balance as an integer. e.g. 100 equals $1.00  */
  balance?: Maybe<Scalars['BigInt']>;
  /**  The currency code that transactions on the account are in  */
  currency?: Maybe<FinancialCurrency>;
  /**  JSON Formatted fields related to specific account types: APR, CreditLimit, etc  */
  extra?: Maybe<Scalars['JSON']>;
  /**  The financial portal under which the account resides  */
  financialPortal?: Maybe<FinancialPortal>;
  /**  IAV verification status flag  */
  iavVerified?: Maybe<Scalars['Boolean']>;
  /**  The date at which the account was last synced  */
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  /**  Account mask  */
  mask?: Maybe<Scalars['String']>;
  /**  Account name  */
  name?: Maybe<Scalars['String']>;
  /**  Account status  */
  status?: Maybe<FinancialAccountStatus>;
  /**  Account sub-type  */
  subtype?: Maybe<FinancialAccountSubtype>;
  /**  Account sub-type details, e.g. "CHECKING_ACCOUNT", "PREPAID_CARD", "FSA"  */
  subtypeDetails?: Maybe<Scalars['String']>;
  /**  Timestamp of the last transactions sync for the account  */
  transactionsSyncedAt?: Maybe<Scalars['DateTime']>;
  /**  The type of account, e.g. "bank" or "investment"  */
  type?: Maybe<FinancialAccountType>;
  /**  Verification state of the account  */
  verificationState?: Maybe<Scalars['String']>;
  /**  Whether the account is included in calculations and visible to the user  */
  isHidden?: Maybe<Scalars['Boolean']>;
};

export enum FinancialAccountAccountNames {
  NwManualTransactionAccount = 'NW_MANUAL_TRANSACTION_ACCOUNT'
}

export type FinancialAccountsActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'FinancialAccountsActivationVisualization';
  /** This will always be FINANCIAL_ACCOUNTS_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

export type FinancialAccountsIavDetailsResponse = {
  __typename?: 'FinancialAccountsIAVDetailsResponse';
  details: Array<IavDetailsResponse>;
};

export type FinancialAccountSnapshot = {
  __typename?: 'FinancialAccountSnapshot';
  account_id: Scalars['ID'];
  amount: Scalars['Int'];
  created_at: Scalars['DateTime'];
  date: Scalars['DateTime'];
  identity_id: Scalars['ID'];
  updated_at: Scalars['DateTime'];
};

export enum FinancialAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum FinancialAccountSubtype {
  Bill = 'BILL',
  Checking = 'CHECKING',
  CreditCard = 'CREDIT_CARD',
  Invalid = 'INVALID',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Retirement = 'RETIREMENT',
  Reward = 'REWARD',
  Savings = 'SAVINGS',
  Stuff = 'STUFF',
  Vehicle = 'VEHICLE'
}

export enum FinancialAccountType {
  Bank = 'BANK',
  Bill = 'BILL',
  CreditCard = 'CREDIT_CARD',
  Insurance = 'INSURANCE',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  Reward = 'REWARD'
}

export type FinancialAccountTypeSumsResponse = {
  __typename?: 'FinancialAccountTypeSumsResponse';
  /**  Sum of ALL assets, i.e. bank balances + investments in cents  */
  assets: Scalars['BigInt'];
  /**  Sum of bank balances in cents  */
  banks: Scalars['BigInt'];
  /**  Sum of bill balances in cents  */
  bills: Scalars['BigInt'];
  /**  Sum of credit card balances (unsigned) in cents  */
  creditCards: Scalars['BigInt'];
  /**  Sum of ALL debts (unsigned), i.e. credit card balances + loan balances in cents  */
  debts: Scalars['BigInt'];
  /**  Sum of investments in cents  */
  investments: Scalars['BigInt'];
  /**  Sum of loans (unsigned) in cents  */
  loans: Scalars['BigInt'];
  /**  Sum of other account balances in cents  */
  other: Scalars['BigInt'];
};

/**  We currently only only support USD. Other currencies should be filtered out in the resolver  */
export enum FinancialCurrency {
  Usd = 'USD'
}

export enum FinancialDataSource {
  Nerdwallet = 'NERDWALLET',
  Plaid = 'PLAID',
  Qa = 'QA',
  User = 'USER',
  Yodlee = 'YODLEE'
}

/** The `FinancialIdentityDebtTypes` type represents debt types of a user */
export type FinancialIdentityDebtTypes = {
  __typename?: 'FinancialIdentityDebtTypes';
  creditDebt?: Maybe<Scalars['Boolean']>;
  personalLoanDebt?: Maybe<Scalars['Boolean']>;
  autoLoanDebt?: Maybe<Scalars['Boolean']>;
  studentLoanDebt?: Maybe<Scalars['Boolean']>;
  mortgageDebt?: Maybe<Scalars['Boolean']>;
  medicalDebt?: Maybe<Scalars['Boolean']>;
  paydayLoanDebt?: Maybe<Scalars['Boolean']>;
  otherDebt?: Maybe<Scalars['Boolean']>;
};

/** The `FinancialIdentityProfile` type represents the user's financial profile */
export type FinancialIdentityProfile = {
  __typename?: 'FinancialIdentityProfile';
  id?: Maybe<Scalars['ID']>;
  annualIncome?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
  currentSpousesAnnualIncome?: Maybe<Scalars['Int']>;
  employmentType?: Maybe<Scalars['String']>;
  cashSavingPattern?: Maybe<Scalars['String']>;
  currentSpendingPattern?: Maybe<Scalars['String']>;
  creditScore?: Maybe<Scalars['Int']>;
  creditScoreRange?: Maybe<Scalars['String']>;
  amountOwed?: Maybe<Scalars['Int']>;
  debtTypes?: Maybe<FinancialIdentityDebtTypes>;
  totalSavings?: Maybe<Scalars['Int']>;
  savingTypes?: Maybe<FinancialIdentitySavingTypes>;
  monthlyHousingCost?: Maybe<Scalars['Float']>;
  residenceOwnershipType?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<UserReportedFinancialAccount>>>;
};

/** The `FinancialIdentitySavingTypes` type represents saving types of a user */
export type FinancialIdentitySavingTypes = {
  __typename?: 'FinancialIdentitySavingTypes';
  monthlyBills?: Maybe<Scalars['Boolean']>;
  travel?: Maybe<Scalars['Boolean']>;
  carExpenses?: Maybe<Scalars['Boolean']>;
  homeCosts?: Maybe<Scalars['Boolean']>;
  creditCardInterest?: Maybe<Scalars['Boolean']>;
  studentLoans?: Maybe<Scalars['Boolean']>;
};

/** A user insight sourced from financial-insights service */
export type FinancialInsight = UserInsightInterface & {
  __typename?: 'FinancialInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   * 
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   * 
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   * 
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   * 
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   * 
   * For exmaple, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   * 
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   * 
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   * 
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   * 
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

/** Correlates to each of the "products" Plaid offers. Plaid breaks down the status of an institution on a per product basis. */
export type FinancialInstitutionStatusByProduct = {
  __typename?: 'FinancialInstitutionStatusByProduct';
  auth?: Maybe<FinancialInstitutionStatusByProductDetails>;
  balance?: Maybe<FinancialInstitutionStatusByProductDetails>;
  identity?: Maybe<FinancialInstitutionStatusByProductDetails>;
  itemLogins?: Maybe<FinancialInstitutionStatusByProductDetails>;
  transactionsUpdates?: Maybe<FinancialInstitutionStatusByProductDetails>;
};

export type FinancialInstitutionStatusByProductDetails = {
  __typename?: 'FinancialInstitutionStatusByProductDetails';
  lastStatusChange?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PlaidInstitutionHealthStatus>;
};

export type FinancialInstitutionStatusResponse = {
  __typename?: 'FinancialInstitutionStatusResponse';
  status?: Maybe<FinancialInstitutionStatusByProduct>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/financial_portals
 */
export type FinancialPortal = {
  __typename?: 'FinancialPortal';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /**  Accounts synchronization state for the portal  */
  accountsState?: Maybe<FinancialPortalProductState>;
  /**  A portal's migration state  */
  activeMigration?: Maybe<Scalars['Boolean']>;
  /**  Authentication state of the portal  */
  authState?: Maybe<FinancialPortalAuthState>;
  /**  The time at which the authentication state was set (ms precision)  */
  authStateSetAt?: Maybe<Scalars['DateTime']>;
  /**  The id of the canonical institution this portal is associated with  */
  canonicalInstitutionId?: Maybe<Scalars['ID']>;
  /**  The error message returned by the source if auth state went into "ERROR"  */
  errorMessage?: Maybe<FinancialPortalErrorMessage>;
  /**  The type of error returned if the auth state went into "ERROR"  */
  errorName?: Maybe<Scalars['String']>;
  /**  The priority of the error  */
  errorPriority?: Maybe<Scalars['String']>;
  /**  Whether the portal's data is being fetched for the first time  */
  isActiveSync?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal is being automatically refreshed  */
  isAutoRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal's balance is being refreshed  */
  isBalanceRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal is being manually refreshed  */
  isManualRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the portal is refreshable  */
  isRefreshable?: Maybe<Scalars['Boolean']>;
  /**  Whether the portal is current refreshing (an OR of all types of refreshing)  */
  isRefreshing?: Maybe<Scalars['Boolean']>;
  /**  The time at which the portal was last refreshed  */
  lastRefreshedAt?: Maybe<Scalars['DateTime']>;
  /**  The account aggregation institution this portal is associated with  */
  marketplaceInstitution?: Maybe<AccountAggregationInstitution>;
  /**
   * The id of the acct agg institution this portal is associated with. This can be used instead of
   * marketplaceInstitution.id to avoid an extra network request to marketplace
   */
  marketplaceInstitutionId?: Maybe<Scalars['ID']>;
  /**  Information on the state of a portal being migrated from vendor to vendor, if relevant  */
  migrationDetails?: Maybe<FinancialPortalMigrationDetails>;
  /**  The primary action for a client to take for an institution in a sub-optimal state  */
  primaryClientAction?: Maybe<FinancialPortalPrimaryClientAction>;
  /**  The secondary action for a client to take for an institution in a sub-optimal state  */
  secondaryClientAction?: Maybe<Scalars['String']>;
  /**  The source institution id for the portal  */
  sourceInstitutionId: Scalars['String'];
  /**  Contains metadata about the portal. Requires elevated permissions to query.  */
  sourceMeta?: Maybe<FinancialPortalSourceMeta>;
  /**  The transactions synchronization state for the portal  */
  transactionsState?: Maybe<FinancialPortalProductState>;
  /**  The financial accounts associated with this portal  */
  accounts?: Maybe<Array<FinancialAccount>>;
};

export enum FinancialPortalAuthState {
  Authenticated = 'AUTHENTICATED',
  Error = 'ERROR',
  Init = 'INIT',
  Null = 'NULL',
  UserActionRequired = 'USER_ACTION_REQUIRED'
}

export enum FinancialPortalErrorMessage {
  DataNotReady = 'DATA_NOT_READY',
  DataRetrievalFailed = 'DATA_RETRIEVAL_FAILED',
  InstitutionDown = 'INSTITUTION_DOWN',
  InstitutionNotSupported = 'INSTITUTION_NOT_SUPPORTED',
  InstitutionRequiresUserAction = 'INSTITUTION_REQUIRES_USER_ACTION',
  InternalError = 'INTERNAL_ERROR',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidMfa = 'INVALID_MFA',
  InvalidMicrodepositAmount = 'INVALID_MICRODEPOSIT_AMOUNT',
  LoginRequired = 'LOGIN_REQUIRED',
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  MfaRequired = 'MFA_REQUIRED',
  NoDataOrAccount = 'NO_DATA_OR_ACCOUNT',
  NoEligibleAccounts = 'NO_ELIGIBLE_ACCOUNTS',
  NoInvestmentAccounts = 'NO_INVESTMENT_ACCOUNTS',
  NoLiabilityAccounts = 'NO_LIABILITY_ACCOUNTS',
  NoPropertyValue = 'NO_PROPERTY_VALUE',
  OtherError = 'OTHER_ERROR',
  PortalBlocked = 'PORTAL_BLOCKED',
  PortalLocked = 'PORTAL_LOCKED',
  ProductNotSupported = 'PRODUCT_NOT_SUPPORTED',
  TooManyVerificationAttempts = 'TOO_MANY_VERIFICATION_ATTEMPTS'
}

/**
 * Used to filter a financial portal by fields such as its institution ID. The
 * fields listed here are a subset of the complete list found here:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listFinancialPortals
 */
export type FinancialPortalFilterInput = {
  mpInstitutionId?: Maybe<Scalars['ID']>;
};

export type FinancialPortalMessageResponse = {
  __typename?: 'FinancialPortalMessageResponse';
  success: Scalars['Boolean'];
  /**  a portal will be returned only in the event of an AUTHORIZATION_SUCCESS event  */
  portal?: Maybe<FinancialPortal>;
};

export type FinancialPortalMigrationDetails = {
  __typename?: 'FinancialPortalMigrationDetails';
  /**  A map of previous account id to new account id  */
  accountsMapping?: Maybe<Scalars['JSON']>;
  /**  Whether the user has confirmed the migration is acceptable or not  */
  hasUserConfirmed: Scalars['Boolean'];
  /**  Whether data for the new portal is currently being ported over   */
  isDataPortInProgress: Scalars['Boolean'];
  /**  Whether data for the new portal has been retrieved  */
  isDataRetrieved: Scalars['Boolean'];
  /**  The id of the portal being migrated from  */
  migratedFromFinancialPortalId?: Maybe<Scalars['ID']>;
  /**  The id of the portal being migrated to  */
  migratedToFinancialPortalId?: Maybe<Scalars['ID']>;
  /**  List of new account ids  */
  newAccountIds?: Maybe<Array<Scalars['ID']>>;
  /**  List of old account ids  */
  oldAccountIds?: Maybe<Array<Scalars['ID']>>;
  /**  The id of the marketplace account aggregation institution to migrate to, if a canonical id mapping exists  */
  recommendedMarketplaceInstitutionId?: Maybe<Scalars['ID']>;
  /**  The source (e.g. Plaid) id of the institution to migrate to  */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']>;
};

export enum FinancialPortalPrimaryClientAction {
  Fix = 'FIX',
  GoToSite = 'GO_TO_SITE',
  Migrate = 'MIGRATE',
  Refresh = 'REFRESH',
  SearchToMigrate = 'SEARCH_TO_MIGRATE',
  TryOtherInstitution = 'TRY_OTHER_INSTITUTION',
  Unlink = 'UNLINK',
  UserConfirmation = 'USER_CONFIRMATION',
  LegacyFix = 'LEGACY_FIX'
}

export enum FinancialPortalProductState {
  DataRetrieved = 'DATA_RETRIEVED',
  Null = 'NULL',
  PartialDataRetrieved = 'PARTIAL_DATA_RETRIEVED',
  RetrievalFailed = 'RETRIEVAL_FAILED',
  RetrievalInProgress = 'RETRIEVAL_IN_PROGRESS'
}

export type FinancialPortalSourceMeta = {
  __typename?: 'FinancialPortalSourceMeta';
  /**  Failed login attempts in the past 30 days  */
  failedLoginAttemptsPast30Days?: Maybe<Scalars['Int']>;
  /**  Failed login attempts in the past hour  */
  failedLoginAttemptsPastHour?: Maybe<Scalars['Int']>;
  /**  The previous auth state  */
  portalPreviousAuthState?: Maybe<FinancialPortalAuthState>;
  /**  The Yodlee status code  */
  portalStatusCode?: Maybe<Scalars['String']>;
  /**  The Yodlee status message  */
  portalStatusMessage?: Maybe<Scalars['String']>;
  /**  The source access token  */
  sourceAccessToken?: Maybe<Scalars['String']>;
  /**  The source entity id  */
  sourceEntityId?: Maybe<Scalars['String']>;
  /**  The Yodlee username (corresponds to the owner of this portal)  */
  username?: Maybe<Scalars['String']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/transactions
 */
export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /**  The financial account under which the transaction resides  */
  account?: Maybe<FinancialAccount>;
  /**
   *  The ID of the account associated with this transaction. Useful if you need the
   * id but don't want to invoke an extra network request to fetch accounts 
   */
  accountId?: Maybe<Scalars['ID']>;
  /**  The "cent-normalized" amount of the transaction as an integer. e.g. 100 equals $1.00  */
  amount: Scalars['Int'];
  /**  The NW category of the transaction. Nullable if reading an enrichment, otherwise guaranteed  */
  category?: Maybe<FinancialTransactionCategory>;
  /**  The currency of the account to which the transaction belongs  */
  currency?: Maybe<FinancialCurrency>;
  /**  The date that the transaction took place  */
  date: Scalars['DateTime'];
  /**  The type of account, e.g. "bank" or "investment"  */
  accountType?: Maybe<FinancialAccountType>;
  /**  A short description of the transaction  */
  description?: Maybe<Scalars['String']>;
  /**  Whether or not the transaction is in a pending status, or if it has posted.  */
  isPending?: Maybe<Scalars['Boolean']>;
  /**  Whether or not the transaction is hidden. */
  isHidden?: Maybe<Scalars['Boolean']>;
  /**  The name of the merchant associated to the transaction  */
  merchantName?: Maybe<Scalars['String']>;
  /**  Generally, whether this is a credit or a debt  */
  type?: Maybe<FinancialTransactionType>;
  /**  Used to label additional information about a transaction. e.g. REFUND  */
  tags?: Maybe<Array<FinancialTransactionTag>>;
};

export enum FinancialTransactionCategory {
  Entertainment = 'ENTERTAINMENT',
  Fees = 'FEES',
  Groceries = 'GROCERIES',
  Health = 'HEALTH',
  Housing = 'HOUSING',
  Income = 'INCOME',
  Other = 'OTHER',
  Restaurants = 'RESTAURANTS',
  Shopping = 'SHOPPING',
  Transfers = 'TRANSFERS',
  Transport = 'TRANSPORT',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES'
}

export type FinancialTransactionsAverageSpendingByDayOfTheMonth = {
  __typename?: 'FinancialTransactionsAverageSpendingByDayOfTheMonth';
  averageSpendingByDayOfTheMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsCategorySpendingAmount = {
  __typename?: 'FinancialTransactionsCategorySpendingAmount';
  amount: Scalars['Float'];
  category: FinancialTransactionCategory;
};

/**
 * Note: this is not a complete set of available filters of the underlying API
 * 
 * See docs for full support: https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listTransactions
 */
export type FinancialTransactionsFilterInput = {
  /** The account ID by which to filter the transactions. */
  accountId?: Maybe<Scalars['ID']>;
  /**
   * To be deprecated. Please use "accountTypes".
   * Only return transactions from an account with one of these types.
   */
  accountType?: Maybe<Array<FinancialAccountType>>;
  /** Only return transactions from an account with one of these types. */
  accountTypes?: Maybe<Array<FinancialAccountType>>;
  /**
   * To be deprecated. Please use "excludeAccountTypes".
   * Exclude transactions from any accounts with one of these types.
   */
  excludeAccountType?: Maybe<Array<FinancialAccountType>>;
  /** Exclude transactions from any accounts with one of these types. */
  excludeAccountTypes?: Maybe<Array<FinancialAccountType>>;
  /** The merchant by which to filter the transactions. */
  merchantName?: Maybe<Scalars['String']>;
  /** The merchant names by which to filter the transactions. */
  merchantNames?: Maybe<Array<Scalars['String']>>;
  /**
   * To be deprecated. Please use "categories".
   * Only return transactions in one of these categories.
   */
  category?: Maybe<Array<FinancialTransactionCategory>>;
  /** Only return transactions in one of these categories. */
  categories?: Maybe<Array<FinancialTransactionCategory>>;
  /**
   * To be deprecated. Please use "excludeCategories".
   * Exclude transactions in any of these categories.
   */
  excludeCategory?: Maybe<Array<FinancialTransactionCategory>>;
  /** Exclude transactions in any of these categories. */
  excludeCategories?: Maybe<Array<FinancialTransactionCategory>>;
  /** The type by which to filter the transactions. */
  type?: Maybe<Scalars['String']>;
  /** Whether to include transactions for hidden accounts. */
  includeHiddenAccounts?: Maybe<Scalars['Boolean']>;
  /** Whether or not to include transactions marked as hidden. Defaults to false. */
  excludeHiddenTransactions?: Maybe<Scalars['Boolean']>;
  /** Whether or not to include pending transactions. Defaults to false. */
  includePending?: Maybe<Scalars['Boolean']>;
  /** The beginning bound of the transaction date (ISO 8601) */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end bound of the transaction date (ISO 8601) */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Only return transactions with one of these tags. */
  includeTags?: Maybe<Array<FinancialTransactionTag>>;
  /** Exclude transactions with any one of these tags. */
  excludeTags?: Maybe<Array<FinancialTransactionTag>>;
  /** Transactions that have been modified since this date (ISO 8601). */
  updatedSince?: Maybe<Scalars['DateTime']>;
  /** Whether or not to include accounts marked as disabled. Defaults to false. */
  includeDisabledAccounts?: Maybe<Scalars['Boolean']>;
};

export type FinancialTransactionsMerchantSpendingAmount = {
  __typename?: 'FinancialTransactionsMerchantSpendingAmount';
  amount: Scalars['Float'];
  merchantName: Scalars['String'];
};

export type FinancialTransactionsProjectionForMonth = {
  __typename?: 'FinancialTransactionsProjectionForMonth';
  earning: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarning = {
  __typename?: 'FinancialTransactionsSpendingAndEarning';
  spending: Scalars['Float'];
  earning: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarningForDate = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForDate';
  date: Scalars['Date'];
  spending: Scalars['Float'];
  earning: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarningForMonthRangeResponse = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse';
  spendingAndEarningForMonthRange: FinancialTransactionsSpendingAndEarning;
};

export type FinancialTransactionsSpendingByCategory = {
  __typename?: 'FinancialTransactionsSpendingByCategory';
  entertainment: Scalars['Float'];
  fees: Scalars['Float'];
  groceries: Scalars['Float'];
  health: Scalars['Float'];
  housing: Scalars['Float'];
  income: Scalars['Float'];
  other: Scalars['Float'];
  restaurants: Scalars['Float'];
  shopping: Scalars['Float'];
  transfers: Scalars['Float'];
  transport: Scalars['Float'];
  travel: Scalars['Float'];
  utilities: Scalars['Float'];
};

export type FinancialTransactionsSpendingByCategoryForMonth = {
  __typename?: 'FinancialTransactionsSpendingByCategoryForMonth';
  spendingByCategoryForMonth: FinancialTransactionsSpendingByCategory;
};

export type FinancialTransactionsSpendingByDayOfTheMonthForMonth = {
  __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth';
  spendingByDayOfTheMonthForPriorMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
  spendingByDayOfTheMonthForTargetMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsSpendingByMonth = {
  __typename?: 'FinancialTransactionsSpendingByMonth';
  spendingByMonth: Array<FinancialTransactionsSpendingOnDate>;
};

export type FinancialTransactionsSpendingForDayOfTheMonth = {
  __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth';
  amount: Scalars['Float'];
  dayOfTheMonth: Scalars['Int'];
};

export type FinancialTransactionsSpendingOnDate = {
  __typename?: 'FinancialTransactionsSpendingOnDate';
  amount: Scalars['Float'];
  date: Scalars['Date'];
};

export type FinancialTransactionsTopCategoriesBySpending = {
  __typename?: 'FinancialTransactionsTopCategoriesBySpending';
  topCategoriesBySpending: Array<FinancialTransactionsCategorySpendingAmount>;
};

export type FinancialTransactionsTopMerchantsBySpending = {
  __typename?: 'FinancialTransactionsTopMerchantsBySpending';
  topMerchantsBySpending: Array<FinancialTransactionsMerchantSpendingAmount>;
};

export enum FinancialTransactionTag {
  AccountFee = 'ACCOUNT_FEE',
  AccountFeeAnnual = 'ACCOUNT_FEE_ANNUAL',
  BankFeeAtm = 'BANK_FEE_ATM',
  BankFeeOverdraft = 'BANK_FEE_OVERDRAFT',
  CashWithdrawal = 'CASH_WITHDRAWAL',
  CheckPayment = 'CHECK_PAYMENT',
  Deposit = 'DEPOSIT',
  Education = 'EDUCATION',
  InvestmentIncome = 'INVESTMENT_INCOME',
  PayrollDeposit = 'PAYROLL_DEPOSIT',
  RebalanceTransfer = 'REBALANCE_TRANSFER',
  Refund = 'REFUND',
  RentPayment = 'RENT_PAYMENT',
  TaxRefund = 'TAX_REFUND'
}

export enum FinancialTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type FinishPortalMigrationResponse = {
  __typename?: 'FinishPortalMigrationResponse';
  portal?: Maybe<FinancialPortal>;
};

export type GetFinancialAccountsResponse = {
  __typename?: 'GetFinancialAccountsResponse';
  accounts?: Maybe<Array<FinancialAccount>>;
};

export type GetInstitutionHealthDetailsResponse = {
  __typename?: 'GetInstitutionHealthDetailsResponse';
  institution?: Maybe<FinancialInstitutionStatusResponse>;
};

export type GetPortalsResponse = {
  __typename?: 'GetPortalsResponse';
  portals?: Maybe<Array<FinancialPortal>>;
};

export type GetTransactionsResponse = {
  __typename?: 'GetTransactionsResponse';
  /**
   * The pagination metadata associated with the request. If underlying data has changed, this will not match the
   * requested pagination (offset will be set to 0 and a new result set token will be generated)
   */
  pagination: AdvancedOffsetPaginationInfo;
  /**  The list of transactions associated with this result set  */
  transactions: Array<FinancialTransaction>;
};

/** The `GlobalIdentityProfile` type represents the global identity profile */
export type GlobalIdentityProfile = {
  __typename?: 'GlobalIdentityProfile';
  phoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<IdentityAddress>;
  age?: Maybe<Scalars['Int']>;
  maritalStatus?: Maybe<Scalars['String']>;
  previousAddress?: Maybe<IdentityAddress>;
  dateOfBirth?: Maybe<Scalars['String']>;
  currentLocation?: Maybe<Scalars['String']>;
  legalFirstName?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  ageBucket?: Maybe<Scalars['String']>;
};

export type GoogleLoginInfoInput = {
  /** The app used to log in with Google */
  appType: AppTypeEnum;
  /** The google OAuth token required for log in/registration */
  googleOAuthToken: Scalars['String'];
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: Maybe<Scalars['String']>;
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type GreenhouseDepartment = {
  __typename?: 'GreenhouseDepartment';
  /** Unique ID of a GreenhouseDepartment */
  id: Scalars['ID'];
  /** Name of a GreenhouseDepartment */
  name: Scalars['String'];
  /** Kebab Name of a GreenhouseDepartment */
  kebabName: Scalars['String'];
  /** List of jobs available within a GreenhouseDepartment */
  jobs?: Maybe<Array<GreenhouseJob>>;
};

export type GreenhouseJob = {
  __typename?: 'GreenhouseJob';
  /** Unique ID of a GreenhouseJob */
  id: Scalars['ID'];
  /** URL to the job page on nerdwallet.com, of the form `http://www.nerdwallet.com/careers/job/2930840?gh_jid=2930840` */
  absoluteUrl: Scalars['URL'];
  /** Last update date */
  updatedAt: Scalars['DateTime'];
  /** Title of a GreenhouseJob */
  title: Scalars['String'];
  /**
   * Content body of a GreenhouseJob. Contains html-encoded html, e.g.
   * `&lt;p&gt;&lt;span style=&quot;font-weight: 400;&quot;&gt;`
   */
  content?: Maybe<Scalars['String']>;
  /** Location of the GreenhouseJob */
  location?: Maybe<Scalars['String']>;
};

/** Metadata properties for the given HealthabilityReport */
export type HealthabilityMeta = {
  __typename?: 'HealthabilityMeta';
  /** Indy version used to generate the HealthabilityReport */
  indyVersion: Scalars['String'];
  /** Name of the repo Healthability ran on to generate the given HealthabilityReport */
  repoName: Scalars['String'];
  /** Repo version Healthability ran on to generate the given HealthabilityReport */
  repoVersion: Scalars['String'];
  /** Time when the HealthabilityReport was generated */
  time: Scalars['String'];
};

/** Generated report containing Healthability information for a given repo */
export type HealthabilityReport = {
  __typename?: 'HealthabilityReport';
  /** Metadata properties for the given HealthabilityReport */
  meta?: Maybe<HealthabilityMeta>;
  /** An array of HealthabilitySpecs containing information regarding technical debt in the given repo */
  specs?: Maybe<Array<HealthabilitySpec>>;
};

/** Encapsulate information regarding a specific type of technical debt */
export type HealthabilitySpec = {
  __typename?: 'HealthabilitySpec';
  /** Name of the HealthabilitySpec */
  name: Scalars['String'];
  /** Human-readable title of the HealthabilitySpec */
  title: Scalars['String'];
  /** Indicates whether the HealthabilitySpec is scored or unscored */
  scored: Scalars['Boolean'];
  /** Maximum points possible for the given HealthabilitySpec */
  maxPoints: Scalars['Int'];
  /** Points achieved by the repo for the given HealthabilitySpec */
  points: Scalars['Int'];
  /** Indicates whether the results of the HealthabilitySpec is displayed to console, and on PR comments */
  disabled: Scalars['Boolean'];
  /** Detailed feedback surfacing detected technical debt and suggested improvements for the given HealthabilitySpec */
  comments: Scalars['String'];
  /** Indicates whether the HealthabilitySpec errored during execution */
  errored: Scalars['Boolean'];
  /** Optional summary of the comments for the spec */
  summary?: Maybe<Scalars['String']>;
};

/** The `HomeOwnershipAddress` type represents the address of the user's current home. */
export type HomeOwnershipAddress = {
  __typename?: 'HomeOwnershipAddress';
  /**
   * The first line of the user's home address
   * 
   * Example: `875 STEVENSON ST`
   */
  addressLine1: Scalars['String'];
  /**
   * The apartment number of the user's address
   * 
   * Example: `APT 810`
   */
  aptNumber?: Maybe<Scalars['String']>;
  /**
   * The city of the user's address
   * 
   * Example: `SAN FRANCISCO`
   */
  city: Scalars['String'];
  /**
   * The state abbreviation of the user's address
   * 
   * Example: `CA`
   */
  state: Scalars['String'];
  /**
   * The ZIP code of the user's address
   * 
   * Example: `94103`
   */
  zipCode: Scalars['String'];
  /**
   * The ID of the corresponding Zillow listing
   * 
   * Example: `241585150`
   */
  zillowId?: Maybe<Scalars['String']>;
  /**
   * The ID of the corresponding Redfin listing
   * 
   * Example: `1234564`
   */
  redfinId?: Maybe<Scalars['String']>;
};

/**
 * The `HomeOwnershipDetails` type contains all information required by the Home Profile feature
 * of the NerdWallet membership experience.
 */
export type HomeOwnershipDetails = {
  __typename?: 'HomeOwnershipDetails';
  address?: Maybe<HomeOwnershipAddress>;
  homeValueDetails?: Maybe<HomeOwnershipValueDetails>;
  mortgage?: Maybe<HomeOwnershipMortgage>;
  mortgageSavings?: Maybe<HomeOwnershipMortgageSavings>;
};

/**
 * The `HomeOwnershipMortgage` type represents the user's mortgage.  Savings estimates and product
 * recommendations are derived from this.
 */
export type HomeOwnershipMortgage = {
  __typename?: 'HomeOwnershipMortgage';
  /**
   * The start date of the user's mortgage, as indicated by the user
   * 
   * Example: `2014-01-01T00:00:00.000000Z`
   */
  originationDate: Scalars['DateTime'];
  /**
   * The interest rate of the user's mortgage, as indicated by the user
   * 
   * Example: `2014-01-01T00:00:00.000000Z`
   */
  annualInterestRate: Scalars['Float'];
  /**
   * The total loan amount of the user's mortgage, as indicated by the user
   * 
   * Example: `2014-01-01T00:00:00.000000Z`
   */
  loanAmount: Scalars['Float'];
  /**
   * The loan program of the user's mortgage, as indicated by the user.
   * 
   * Example: `THIRTY_YEAR_FIXED`
   */
  loanProgram: HomeOwnershipMortgageLoanProgram;
  /**
   * The loan type of the user's mortgage, as indicated by the user.
   * 
   * Example: `CONVENTIONAL`
   */
  loanType: HomeOwnershipMortgageLoanType;
};

export enum HomeOwnershipMortgageLoanProgram {
  ThirtyYearFixed = 'THIRTY_YEAR_FIXED',
  TwentyYearFixed = 'TWENTY_YEAR_FIXED',
  FifteenYearFixed = 'FIFTEEN_YEAR_FIXED',
  TenYearFixed = 'TEN_YEAR_FIXED',
  SevenOneArm = 'SEVEN_ONE_ARM',
  FiveOneArm = 'FIVE_ONE_ARM',
  ThreeOneArm = 'THREE_ONE_ARM'
}

export enum HomeOwnershipMortgageLoanType {
  Conventional = 'CONVENTIONAL',
  Fha = 'FHA',
  Va = 'VA',
  Usda = 'USDA'
}

/**
 * The `HomeOwnershipMortgageSavings` type contains NerdWallet's estimation of how much the user might be able
 * to save on their mortgage payments, based on the mortgage details they've provided.
 */
export type HomeOwnershipMortgageSavings = {
  __typename?: 'HomeOwnershipMortgageSavings';
  /**
   * The number of dollars the user could save per month on their mortgage payment
   * 
   * Example: `1538.2300000000005`
   */
  monthlySaving: Scalars['Float'];
  /**
   * The number of dollars the user could save over the duration of their mortgage
   * 
   * Example: `168198.33000000007`
   */
  totalCostSaving: Scalars['Float'];
  /**
   * Whether we should surface the HomeOwnershipMortgageSavings to the user
   * 
   * Example: `true`
   */
  canShowSavings: Scalars['Boolean'];
};

/** The `HomeOwnershipValueDetails` type contains all information relevant to the value of the user's home. */
export type HomeOwnershipValueDetails = {
  __typename?: 'HomeOwnershipValueDetails';
  /**
   * The current estimate of the user's home
   * 
   * Example: `354719.32`
   */
  homeValue?: Maybe<Scalars['Float']>;
  /**
   * The date at which the home value estimate was created by the third-party provider.
   * 
   * Example: `2014-01-01T00:00:00.000000Z`
   */
  updatedDate?: Maybe<Scalars['DateTime']>;
  /**
   * The third-party provider of the home value estimate.  Note that this field will not be present
   * if isSelfReported is true.
   */
  provider?: Maybe<HomeOwnershipValueProvider>;
  /** Whether the current home value estimate was self-reported by the user */
  isSelfReported: Scalars['Boolean'];
  /** An array of data points representing the user's home value over time */
  timeSeries?: Maybe<Array<HomeOwnershipValueTimeSeriesDataPoint>>;
};

/**
 * The `HomeOwnershipValueProvider` type represents the third-party provider of the home value estimate
 * that we surface to users.  Currently, Zillow and Redfin are supported.
 */
export type HomeOwnershipValueProvider = {
  __typename?: 'HomeOwnershipValueProvider';
  /**
   * The URL of the provider's homepage
   * 
   * Example: `https://www.zillow.com`
   */
  providerUrl: Scalars['String'];
  /**
   * The URL of the user's home on the provider's website
   * 
   * Example: `https://www.zillow.com/homedetails/1400-Mission-St-APT-810-San-Francisco-CA-94103/241585150_zpid`
   */
  providerListing?: Maybe<Scalars['String']>;
  /**
   * The URL of the provider's logo
   * 
   * Example: `https://nerdwallet.com/cdn/img/home/icons/Zillowlogo_200x50.gif`
   */
  providerLogoUrl: Scalars['String'];
  /**
   * The label to display in reference to the home value provider in the UI
   * 
   * Example: `Zestimate`
   */
  providerLabel: Scalars['String'];
};

/**
 * The `HomeOwnershipValueTimeSeriesDataPoint` type represents a single point on the home value history
 * chart
 */
export type HomeOwnershipValueTimeSeriesDataPoint = {
  __typename?: 'HomeOwnershipValueTimeSeriesDataPoint';
  /**
   * The provider-estimated value of the user's home at a particular point in time.
   * 
   * Example: `1252833.54`
   */
  homeValue: Scalars['Float'];
  /**
   * The date at which the home value estimate was created by the third-party provider.
   * 
   * Example: `2014-01-01T00:00:00.000000Z`
   */
  updatedDate: Scalars['DateTime'];
  /**
   * The date at which NerdWallet obtained this home value estimate from the third-party provider.
   * 
   * Example: `2014-01-01T00:00:00.000000Z`
   */
  pulledDate: Scalars['DateTime'];
};

/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAd = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'HouseAd';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text for the house ad. */
  body?: Maybe<Scalars['String']>;
  /** The auth link for the house ad CTA. */
  ctaAuthLink?: Maybe<Scalars['StructuredContentDocument']>;
  /** CTA text for the house ad. */
  ctaText?: Maybe<Scalars['String']>;
  /** The type of CTA for the house ad. Either web link or auth link. */
  ctaType?: Maybe<HouseAdCtaTypeEnum>;
  /** The web url for the house ad CTA link. */
  ctaUrl?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The headline to use for the house ad. */
  headline?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** Which template to use for the house ad. */
  template?: Maybe<HouseAdTemplateEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HouseAdConnectionResponse = {
  __typename?: 'HouseAdConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The HouseAd returned for the connection. */
  items?: Maybe<Array<HouseAd>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for ctaType field on HouseAd type. */
export enum HouseAdCtaTypeEnum {
  AuthLink = 'AUTH_LINK',
  WebLink = 'WEB_LINK'
}

/** Query to fetch a collection of HouseAd objects. */
export type HouseAdFilterInput = {
  /** Limit collection to HouseAds published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to HouseAds with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
};

/** Enum values for template field on HouseAd type. */
export enum HouseAdTemplateEnum {
  EntryBanner = 'ENTRY_BANNER',
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type Hub = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Hub';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The custom content to display below the featured boxes. */
  customContentBelowFeaturedBoxes?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The boxes to display on the Hub. */
  featuredBoxes?: Maybe<Array<HubFeaturedBox>>;
  /** Represents each of the content sections on the page. */
  featuredContent?: Maybe<Array<HubFeaturedContent>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The content to display in the header of the hub below the title. */
  headerSubtitle?: Maybe<Scalars['StructuredContentDocument']>;
  /** Whether this is a Topic hub or Category hub. */
  hubType?: Maybe<HubTypeEnum>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The categories to display the latest content from. */
  latestContentCategories?: Maybe<Array<Scalars['String']>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The marketplace entities to display for this hub. */
  marketplaceEntities?: Maybe<Array<HubMarketplaceEntity>>;
  /** The title of the Marketplace section. */
  marketplaceSectionTitle?: Maybe<Scalars['String']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The post types to display the latest content from. */
  postTypes?: Maybe<Array<PostTypeEnum>>;
  /** The Q&A to display on this Hub. */
  questions?: Maybe<Array<HubQuestion>>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The curated list of reviews to display. */
  reviews?: Maybe<Array<Review>>;
  /** The section title for the reviews section. */
  reviewSectionTitle?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HubConnectionResponse = {
  __typename?: 'HubConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Hub returned for the connection. */
  items?: Maybe<Array<Hub>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Type modeling the data within the featuredBoxes group of fields on the Hub type. */
export type HubFeaturedBox = {
  __typename?: 'HubFeaturedBox';
  /** The description text for the featured box. */
  description?: Maybe<Scalars['String']>;
  /** The icon to display within the featured box. */
  icon?: Maybe<Scalars['String']>;
  /** The label text for the featured box. */
  iconLabel?: Maybe<Scalars['String']>;
  /** The post entity the featured box should link to. */
  link?: Maybe<HubLinkUnion>;
  /** The content this featured box should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The title text for the featured box. */
  title?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the featuredContent group of fields on the Hub type. */
export type HubFeaturedContent = {
  __typename?: 'HubFeaturedContent';
  /** The category the latest content in this section should be displayed from. */
  category?: Maybe<Category>;
  /** The content to display in this section. */
  content?: Maybe<Array<ContentSearchResult>>;
  /** The selected display layout for the section */
  layout?: Maybe<HubLayoutEnum>;
  title?: Maybe<Scalars['String']>;
  /** Whether to display a curated list of content for the section or a latest list of content in a particular category. */
  whatToShow?: Maybe<HubWhatToShowEnum>;
};

/** Query to fetch a collection of Hub objects. */
export type HubFilterInput = {
  /** Limit collection to Hubs published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to Hubs with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Limit collection to Hubs with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** Enum values for layout field on Hub type. */
export enum HubLayoutEnum {
  Default = 'DEFAULT',
  FeatureVertical = 'FEATURE_VERTICAL',
  ThreeInline = 'THREE_INLINE',
  TwoInline = 'TWO_INLINE'
}

/** The union containing the Type members that can be returned by the link field on the Hub type. */
export type HubLinkUnion = Article | Hub | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** Type modeling the data within the marketplaceEntities group of fields on the Hub type. */
export type HubMarketplaceEntity = {
  __typename?: 'HubMarketplaceEntity';
  /** The entity id. */
  id?: Maybe<Scalars['String']>;
  /** The entity title. */
  title?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the questions group of fields on the Hub type. */
export type HubQuestion = {
  __typename?: 'HubQuestion';
  /** The answer for the question prompt. */
  answer?: Maybe<Scalars['StructuredContentDocument']>;
  /** The content this question should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The question prompt. */
  question?: Maybe<Scalars['String']>;
};

/** Enum values for hubType field on Hub type. */
export enum HubTypeEnum {
  Category = 'CATEGORY',
  Topic = 'TOPIC'
}

/** Enum values for whatToShow field on Hub type. */
export enum HubWhatToShowEnum {
  Default = 'DEFAULT',
  LatestContent = 'LATEST_CONTENT',
  Manual = 'MANUAL'
}

export type IavDetailsResponse = {
  __typename?: 'IAVDetailsResponse';
  accountNumber: Scalars['String'];
  holderNames: Array<Scalars['String']>;
  routingNumber: Scalars['String'];
};

/** The `IdentityAddress` type represents the address for a global identity profile */
export type IdentityAddress = {
  __typename?: 'IdentityAddress';
  city: Scalars['String'];
  longitude?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  isValidated?: Maybe<Scalars['Boolean']>;
  validatedAt?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  validatedBy?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** The `IdentityAddressInput` input defines the ingress Address model. */
export type IdentityAddressInput = {
  city: Scalars['String'];
  longitude?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  latitude?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** The input for filtering results by ID. */
export type IdFilterInput = {
  /** Exclude items with specific IDs from the collection. */
  exclude?: Maybe<Array<Scalars['Int']>>;
  /** Limit collection to items with specific IDs. */
  include?: Maybe<Array<Scalars['Int']>>;
};

export enum InstitutionCountryCode {
  Ca = 'CA',
  Us = 'US'
}

/** Institution contains the common base fields for all institutions. */
export type InstitutionInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  canonicalInstitutionId?: Maybe<Scalars['String']>;
};

/** A Insurance institution */
export type InsuranceInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & {
  __typename?: 'InsuranceInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The overall editorial rating for the institution */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Insurance offer */
export type InsuranceOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'InsuranceOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  product: InsuranceProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The URL to the NerdWallet review of this offer's product. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The tooltip value that should be displayed alongside the entity name */
  displayNameTooltip?: Maybe<Scalars['String']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** A Insurance product */
export type InsuranceProductV2 = MarketplaceEntityInterface & MarketplaceEntityWithReviewInterface & MarketplaceProductInterface & {
  __typename?: 'InsuranceProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: InsuranceInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The URL to the NerdWallet review of this product. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Investing institution */
export type InvestingInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & {
  __typename?: 'InvestingInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The overall, editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Investing offer */
export type InvestingOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'InvestingOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** Short description of what the offer is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']>>;
  /** A list of brokerage features for this offer such as promotion, low cost, advisor, etc. */
  brokerageFeatures?: Maybe<Array<Scalars['String']>>;
  /** Brokerage feature for this offer such as self or robo management. */
  brokerageManagement?: Maybe<Scalars['String']>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  product: InvestingProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer's product */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short sentence summary of the Investing Offer */
  summaryShort?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** Trading frequency such as weekly, monthly or occasionally. */
  tradingFrequency?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * Renders an Investing Offer Driver in non structured content format.
   * TODO: We eventually want to be consistent and use structured content
   * formatting going forward.  However this most likely will not be implemented
   * until we have our Currency OfferCard completed
   */
  legacyDrivers: Array<LegacyDriver>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Investing product */
export type InvestingProductV2 = MarketplaceEntityInterface & MarketplaceEntityWithReviewInterface & MarketplaceProductInterface & {
  __typename?: 'InvestingProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: InvestingInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The URL to the NerdWallet review of this product. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type InvestmentAccountInstitution = InstitutionInterface & {
  __typename?: 'InvestmentAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type InvestmentAccountOffer = OfferInterface & AccountOfferInterface & {
  __typename?: 'InvestmentAccountOffer';
  advisorFee?: Maybe<Scalars['String']>;
  applyLink?: Maybe<Scalars['URL']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  flatTradePrice?: Maybe<Scalars['Float']>;
  institution?: Maybe<InvestmentAccountInstitution>;
  details?: Maybe<InvestmentAccountOfferDetails>;
  imageUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  isMonetizing?: Maybe<Scalars['Boolean']>;
};

export type InvestmentAccountOfferDetails = {
  __typename?: 'InvestmentAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

export type InvestmentAccountOffersResponse = {
  __typename?: 'InvestmentAccountOffersResponse';
  offers: Array<InvestmentAccountOffer>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'LandingPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /**
   * The topic that should be used as the 'Attribution Topic' for this piece of
   * content. This value is used for attributing metrics related to this piece of
   * content in analytics reports.
   */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the LandingPage object. */
  categories?: Maybe<Array<Category>>;
  /** The content clusters for this piece of content. Content clusters are meant to be arbitrary groupings of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LandingPageConnectionResponse = {
  __typename?: 'LandingPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The LandingPage returned for the connection. */
  items?: Maybe<Array<LandingPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of LandingPage objects. */
export type LandingPageFilterInput = {
  /** Limit collection to LandingPages published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: Maybe<Scalars['String']>;
  /** Limit collection to LandingPages with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit collection to LandingPages with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** Type modeling the data within a particular column in the layout */
export type LayoutColumn = {
  __typename?: 'LayoutColumn';
  /** Name of the column within the row. This will be used for analytics purposes and debugging */
  name: Scalars['String'];
  /** The structured content document to render within this column */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The width properties for the column */
  width?: Maybe<LayoutColumnWidth>;
  /** How the contents within the column should be aligned vertically */
  verticalAlign?: Maybe<LayoutVerticalAlignEnum>;
};

/** Type containing the width settings for the column. */
export type LayoutColumnWidth = {
  __typename?: 'LayoutColumnWidth';
  /** The width of the column within the desktop breakpoint */
  desktop?: Maybe<Scalars['Int']>;
  /** The width of the column within the mobile breakpoint */
  mobile?: Maybe<Scalars['Int']>;
};

/** Type modelling the fields for a row within a page layout */
export type LayoutRow = {
  __typename?: 'LayoutRow';
  /** The name of the section in the layout. This will be used for analytics purposes */
  name: Scalars['String'];
  /** The columns to display within the row. */
  columns?: Maybe<Array<LayoutColumn>>;
};

/** The vertical alignment options for a column */
export enum LayoutVerticalAlignEnum {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Top = 'TOP'
}

export type LegacyDriver = {
  __typename?: 'LegacyDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /** The driver label */
  label: Scalars['String'];
  /** The value of the driver */
  value?: Maybe<Scalars['String']>;
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLender = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'LegacyLender';
  applyDisclaimerText?: Maybe<Scalars['String']>;
  applyText?: Maybe<Scalars['String']>;
  applyUrl?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the LegacyLender object. */
  categories?: Maybe<Array<Category>>;
  /** The negative bullet points about the product. */
  cons?: Maybe<Array<Scalars['String']>>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  lenderId?: Maybe<Scalars['String']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** Field connecting to the LegacyLenderMaxLTV Type and all of its nested fields. */
  maxLTV?: Maybe<LegacyLenderMaxLtv>;
  /** Field connecting to the LegacyLenderMinCreditScore Type and all of its nested fields. */
  minCreditScore?: Maybe<LegacyLenderMinCreditScore>;
  /** Field connecting to the LegacyLenderMinDownPayment Type and all of its nested fields. */
  minDownPayment?: Maybe<LegacyLenderMinDownPayment>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Field connecting to the LegacyLenderNationalRegional Type and all of its nested fields. */
  nationalRegional?: Maybe<LegacyLenderNationalRegional>;
  personalizedRatesEnabled?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  /** The positive bullet points about the product. */
  pros?: Maybe<Array<Scalars['String']>>;
  /** The NerdWallet rating for the product. */
  rating?: Maybe<Scalars['Float']>;
  /** Reviews associated with this content. */
  review?: Maybe<LegacyLenderReviewUnion>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  whyWeLikeIt?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LegacyLenderConnectionResponse = {
  __typename?: 'LegacyLenderConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The LegacyLender returned for the connection. */
  items?: Maybe<Array<LegacyLender>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of LegacyLender objects. */
export type LegacyLenderFilterInput = {
  /** Limit collection to LegacyLenders published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to LegacyLenders within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit collection to LegacyLenders with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit collection to LegacyLenders with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

export type LegacyLenderMaxLtv = {
  __typename?: 'LegacyLenderMaxLTV';
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type LegacyLenderMinCreditScore = {
  __typename?: 'LegacyLenderMinCreditScore';
  conventional?: Maybe<Scalars['String']>;
  fha?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  hel?: Maybe<Scalars['String']>;
  heloc?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  usda?: Maybe<Scalars['String']>;
  va?: Maybe<Scalars['String']>;
};

export type LegacyLenderMinDownPayment = {
  __typename?: 'LegacyLenderMinDownPayment';
  conventional?: Maybe<Scalars['String']>;
  fha?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  va?: Maybe<Scalars['String']>;
};

export type LegacyLenderNationalRegional = {
  __typename?: 'LegacyLenderNationalRegional';
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** The union containing the Type members that can be returned by the review field on the LegacyLender type. */
export type LegacyLenderReviewUnion = Post | Review;

export type LogInUserResponse = AuthenticationResponseInterface & {
  __typename?: 'LogInUserResponse';
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
  /** The A/B experiments associated with the current user */
  abExperiments?: Maybe<Array<Experiment>>;
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type LogOutUserResponse = {
  __typename?: 'LogOutUserResponse';
  /** Determines whether user log out was successful */
  success: Scalars['Boolean'];
};

/** The aggregator type should only be one of a subset of all marketplace institution types */
export enum MarketplaceAggregatorType {
  Plaid = 'plaid',
  Yodlee = 'yodlee',
  Unknown = 'unknown'
}

/** Interface for all Marketplace entity types (Institution, Product, and Offer) */
export type MarketplaceEntityInterface = {
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** Enum values for entityType field on Roundup type. */
export enum MarketplaceEntityTypeEnum {
  Default = 'DEFAULT',
  Institutions = 'INSTITUTIONS',
  Offers = 'OFFERS',
  Products = 'PRODUCTS'
}

/** Common interface for marketplace entities that can be used in a placement */
export type MarketplaceEntityWithPlacementInterface = {
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /** The drivers associated with the entity */
  placementDrivers: Array<Maybe<EntityPlacementDriverInterface>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** Common interface for marketplace entities with qualification bullets */
export type MarketplaceEntityWithQualificationsInterface = {
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
};

/** Common interface for marketplace entities with review links */
export type MarketplaceEntityWithReviewInterface = {
  reviewLink?: Maybe<Scalars['URL']>;
};

/** Common interface for marketplace entities with a star rating */
export type MarketplaceEntityWithStarRatingInterface = {
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** Interface for all Marketplace Offer types */
export type MarketplaceOfferInterface = {
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** The parent Product of this Offer */
  product: MarketplaceProductInterface;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
};

/** Interface for all Marketplace Product types */
export type MarketplaceProductInterface = {
  /** The parent Institution of this Product */
  institution: MarketplaceEntityInterface;
};

/** Enum values for marketplaceProductType field on Roundup type. */
export enum MarketplaceProductTypeEnum {
  AutoLoans = 'AUTO_LOANS',
  Banking = 'BANKING',
  CreditCards = 'CREDIT_CARDS',
  Default = 'DEFAULT',
  EducationLoans = 'EDUCATION_LOANS',
  FirstTimeHomeBuyerPrograms = 'FIRST_TIME_HOME_BUYER_PROGRAMS',
  Insurance = 'INSURANCE',
  Investing = 'INVESTING',
  Mortgages = 'MORTGAGES',
  PersonalLoans = 'PERSONAL_LOANS',
  SmallMediumBusinessLoans = 'SMALL_MEDIUM_BUSINESS_LOANS',
  Software = 'SOFTWARE'
}

/** Input for marketplace query */
export type MarketplaceQueryInput = {
  field: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['JSON'];
};

/** marketplaceSearch query response */
export type MarketplaceSearchResponse = {
  __typename?: 'MarketplaceSearchResponse';
  /** The total number of marketplace entities that match your query. */
  total: Scalars['Int'];
  /** List of marketplace entities that match your query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
};

/** Input for marketplace sort */
export type MarketplaceSortInput = {
  field: Scalars['String'];
  order: OrderDirectionEnum;
};

export enum MarketplaceStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/**
 * A summary of a user's credit card spending behavior along with recommendations based on the various products
 * a user has activated within the membership experience either on web or in native
 */
export type MaximizeSummary = {
  __typename?: 'MaximizeSummary';
  /** A user's average monthly credit card spending over a supplied time frame */
  averageSpending?: Maybe<Scalars['Float']>;
  /**
   * A list of recommended credit cards from recommendation-serivce based on a user's credit score and
   * their top rewards spending category via their credit cards
   */
  recommendedCards?: Maybe<Array<RecommendedRewardsCreditCard>>;
  /** A user's top rewards spending category data via credit card purchases */
  topCategory?: Maybe<MaximizeSummaryTopCategorySummary>;
};

export type MaximizeSummaryTopCategorySummary = {
  __typename?: 'MaximizeSummaryTopCategorySummary';
  amount: Scalars['Float'];
  category: TopCategory;
};

/** The media details type for media items. */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /**
   * The file path to the image within the uploads directory.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']>;
  /**
   * The height of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']>;
  /**
   * All of the different image crop sizes for a particular media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sizes?: Maybe<Array<MediaSize>>;
  /**
   * The width of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']>;
  /**
   * A unique ID. A hash of the 'file' key.
   * This is necessary in order for ApolloClient 3 to cache the object
   */
  id: Scalars['ID'];
  /**
   * A srcSet string including the image sizes requested
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  srcSet?: Maybe<Scalars['String']>;
};


/** The media details type for media items. */
export type MediaDetailsSizesArgs = {
  sizes?: Maybe<Array<Scalars['String']>>;
};


/** The media details type for media items. */
export type MediaDetailsSrcSetArgs = {
  sizes?: Maybe<Array<Scalars['String']>>;
};

/** The WordPress media item type. */
export type MediaItem = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'MediaItem';
  /** The alt text for the image. */
  altText?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The caption for the image. */
  caption?: Maybe<Scalars['String']>;
  /** The cropped version of an image filtered by size. */
  croppedImage?: Maybe<CroppedImageSize>;
  /** An array of cropped versions of an image filtered by size. */
  croppedImages?: Maybe<Array<CroppedImageSize>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The height of the original image in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /**
   * Details about the media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mediaDetails?: Maybe<MediaDetails>;
  /** The type of media. */
  mediaType?: Maybe<Scalars['String']>;
  /** The mime type of media item. */
  mimeType?: Maybe<Scalars['String']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The permalink for where the image lives. */
  sourceUrl?: Maybe<Scalars['URL']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The width of the original image in pixels. */
  width?: Maybe<Scalars['Int']>;
  /** A srcSet string including the image sizes requested */
  srcSet?: Maybe<Scalars['String']>;
};


/** The WordPress media item type. */
export type MediaItemCaptionArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** The WordPress media item type. */
export type MediaItemCroppedImageArgs = {
  size?: Maybe<MediaItemImageSizeEnum>;
};


/** The WordPress media item type. */
export type MediaItemCroppedImagesArgs = {
  sizes?: Maybe<Array<MediaItemImageSizeEnum>>;
};


/** The WordPress media item type. */
export type MediaItemDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** The WordPress media item type. */
export type MediaItemModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** The WordPress media item type. */
export type MediaItemTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** The WordPress media item type. */
export type MediaItemSrcSetArgs = {
  sizes?: Maybe<Array<MediaItemImageSizeEnum>>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MediaItemConnectionResponse = {
  __typename?: 'MediaItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The MediaItem returned for the connection. */
  items?: Maybe<Array<MediaItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of MediaItem objects. */
export type MediaItemFilterInput = {
  /** Limit collection to MediaItems published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to MediaItems with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit collection to MediaItems with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** Image crop sizes supported by WP */
export enum MediaItemImageSizeEnum {
  BbArticle = 'BB_ARTICLE',
  Full = 'FULL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  MediumLarge = 'MEDIUM_LARGE',
  PrimaryL = 'PRIMARY_L',
  PrimaryLUncropped = 'PRIMARY_L_UNCROPPED',
  PrimaryM = 'PRIMARY_M',
  PrimaryMUncropped = 'PRIMARY_M_UNCROPPED',
  PrimaryS = 'PRIMARY_S',
  PrimarySUncropped = 'PRIMARY_S_UNCROPPED',
  PrimaryXl = 'PRIMARY_XL',
  PrimaryXlUncropped = 'PRIMARY_XL_UNCROPPED',
  PrimaryXs = 'PRIMARY_XS',
  PrimaryXsUncropped = 'PRIMARY_XS_UNCROPPED',
  PrimaryXxl = 'PRIMARY_XXL',
  PrimaryXxs = 'PRIMARY_XXS',
  PrimaryXxsUncropped = 'PRIMARY_XXS_UNCROPPED',
  PrimaryXxxl = 'PRIMARY_XXXL',
  Square = 'SQUARE',
  Square_160 = 'SQUARE_160',
  Square_350 = 'SQUARE_350'
}

/** The media size type for media details. */
export type MediaSize = {
  __typename?: 'MediaSize';
  /**
   * The file name for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']>;
  /**
   * The height of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']>;
  /**
   * The mime type for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mimeType?: Maybe<Scalars['String']>;
  /**
   * The name of the crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  size?: Maybe<Scalars['String']>;
  /**
   * The full url path to the crop of this image.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sourceUrl?: Maybe<Scalars['URL']>;
  /**
   * The width of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']>;
};

/** The expected payload for the `updateMembershipAppActivity` mutation. */
export type MembershipAppActivityInput = {
  valuePropTakeoverDismissedAt: Scalars['DateTime'];
};

/**
 * The `MembershipAppActivityResponse` type records "activity" within the app,
 * such as feature dismissal, or flow progress.
 */
export type MembershipAppActivityResponse = {
  __typename?: 'MembershipAppActivityResponse';
  valuePropTakeoverDismissedAt?: Maybe<Scalars['DateTime']>;
};

/** This enum represents the possible activation statuses of a particular feature */
export enum MembershipFeatureActivationStatusEnum {
  Unactivated = 'UNACTIVATED',
  Degraded = 'DEGRADED',
  Blocked = 'BLOCKED',
  Activated = 'ACTIVATED'
}

export type MembershipFeatureActivationStatusInterface = {
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

/**
 * The set of NerdWallet features.  This enum should be a superset of the _enrollable_ features, which are defined in
 * the feature_enrollment_changed analytics event:
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/feature_enrollment_changed.yaml
 */
export enum MembershipFeatureEnum {
  AppLock = 'APP_LOCK',
  AutoValue = 'AUTO_VALUE',
  Bills = 'BILLS',
  Billshark = 'BILLSHARK',
  CardLinkedOffers = 'CARD_LINKED_OFFERS',
  CashFlow = 'CASH_FLOW',
  CreditScore = 'CREDIT_SCORE',
  Debt = 'DEBT',
  EmailNotifications = 'EMAIL_NOTIFICATIONS',
  FinancialAccountAggregation = 'FINANCIAL_ACCOUNT_AGGREGATION',
  HomeEquity = 'HOME_EQUITY',
  HomeValue = 'HOME_VALUE',
  GeolocationBrowser = 'GEOLOCATION_BROWSER',
  GeolocationNative = 'GEOLOCATION_NATIVE',
  Membership = 'MEMBERSHIP',
  MoneyTransfer = 'MONEY_TRANSFER',
  NetWorth = 'NET_WORTH',
  PlayYourCardsRight = 'PLAY_YOUR_CARDS_RIGHT',
  PushNotifications = 'PUSH_NOTIFICATIONS'
}

export type MigrateFinancialPortalResponse = {
  __typename?: 'MigrateFinancialPortalResponse';
  portal?: Maybe<FinancialPortal>;
};

/** The `MobileAppIdentityProfile` type represents the user's registered devices */
export type MobileAppIdentityProfile = {
  __typename?: 'MobileAppIdentityProfile';
  id?: Maybe<Scalars['String']>;
  devices: Array<MobileAppProfileDevice>;
  newestAppVersionUsed?: Maybe<Scalars['String']>;
  newestAppVersionUsedOnDeviceType?: Maybe<Scalars['String']>;
};

/** The `MobileAppProfileDevice` type represents a device a user has */
export type MobileAppProfileDevice = {
  __typename?: 'MobileAppProfileDevice';
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  pushNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  appVersion: Scalars['String'];
  deviceLastLogin?: Maybe<Scalars['String']>;
};

/** The expected payload for the `addMobileAppDevice` mutations */
export type MobileAppProfileDeviceInput = {
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  pushNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  appVersion: Scalars['String'];
  deviceLastLogin?: Maybe<Scalars['String']>;
};

export type MoneyTransferAccount = {
  __typename?: 'MoneyTransferAccount';
  /** The unique identifier for this linked-account in money-management */
  id: Scalars['ID'];
  /** The computed status for this account (combination of money-management + ach statuses) */
  computedStatus?: Maybe<MoneyTransferAccountStatusEnum>;
  /** The identifier found in FDP or legacy-Yodlee */
  financialAccountId: Scalars['ID'];
  /** The type of this account (CHECKING or SAVINGS) */
  financialAccountType: MoneyTransferFinancialAccountTypeEnum;
  /** The last four digits of the account number */
  financialAccountLastFour?: Maybe<Scalars['String']>;
  /** The institution name (e.g. Wells Fargo) */
  institutionName?: Maybe<Scalars['String']>;
  /** Indicates whether the account passed the holder name match check */
  nameMatchSuccess?: Maybe<Scalars['Boolean']>;
};

export type MoneyTransferAccountEligibility = {
  __typename?: 'MoneyTransferAccountEligibility';
  eligibility: MoneyTransferAccountEligibilityStatusEnum;
  id: Scalars['ID'];
  financialAccountType?: Maybe<MoneyTransferFinancialAccountTypeEnum>;
};

export type MoneyTransferAccountEligibilityResponse = {
  __typename?: 'MoneyTransferAccountEligibilityResponse';
  accounts: Array<MoneyTransferAccountEligibility>;
};

export enum MoneyTransferAccountEligibilityStatusEnum {
  Eligible = 'ELIGIBLE',
  AccountDetailsUnavailable = 'ACCOUNT_DETAILS_UNAVAILABLE',
  AccountNotVerified = 'ACCOUNT_NOT_VERIFIED',
  InsufficientIavData = 'INSUFFICIENT_IAV_DATA',
  AccountNameNotMatching = 'ACCOUNT_NAME_NOT_MATCHING',
  Unknown = 'UNKNOWN',
  UnsupportedAccountType = 'UNSUPPORTED_ACCOUNT_TYPE',
  UnsupportedMoneyMarketAccount = 'UNSUPPORTED_MONEY_MARKET_ACCOUNT'
}

export type MoneyTransferAccountsResponse = {
  __typename?: 'MoneyTransferAccountsResponse';
  maxAccountsPerUser: Scalars['Int'];
  numAccountsLeftToAdd: Scalars['Int'];
  accounts: Array<MoneyTransferAccount>;
};

export enum MoneyTransferAccountStatusEnum {
  AccountAchUnverified = 'ACCOUNT_ACH_UNVERIFIED',
  AccountInactive = 'ACCOUNT_INACTIVE',
  AccountNameMatchFailed = 'ACCOUNT_NAME_MATCH_FAILED',
  AccountNotInAchSystem = 'ACCOUNT_NOT_IN_ACH_SYSTEM',
  AccountReady = 'ACCOUNT_READY',
  AccountRemovedInAch = 'ACCOUNT_REMOVED_IN_ACH',
  AccountUninitialized = 'ACCOUNT_UNINITIALIZED',
  AccountUnlinked = 'ACCOUNT_UNLINKED',
  Unknown = 'UNKNOWN'
}

export type MoneyTransferCancelTransferResponse = {
  __typename?: 'MoneyTransferCancelTransferResponse';
  success: Scalars['Boolean'];
};

export type MoneyTransferCreateUserInput = {
  address: Scalars['String'];
  birthdate: Scalars['String'];
  city: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullSsn?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  postalCode: Scalars['String'];
  shortSsn: Scalars['String'];
  state: Scalars['String'];
};

export type MoneyTransferCreateUserResponse = {
  __typename?: 'MoneyTransferCreateUserResponse';
  user?: Maybe<MoneyTransferUser>;
};

export type MoneyTransferDefaultTransferLimits = {
  __typename?: 'MoneyTransferDefaultTransferLimits';
  userDailyLimit: Scalars['Int'];
  checkingAccountDailyLimit: Scalars['Int'];
  savingsAccountDailyLimit: Scalars['Int'];
  userWeeklyLimit: Scalars['Int'];
  checkingAccountWeeklyLimit: Scalars['Int'];
  savingsAccountWeeklyLimit: Scalars['Int'];
  userMonthlyLimit: Scalars['Int'];
  checkingAccountMonthlyLimit: Scalars['Int'];
  savingsAccountMonthlyLimit: Scalars['Int'];
  maxMonthlyTransferAmountDollars: Scalars['Int'];
  minSingleTransferAmountDollars: Scalars['Int'];
  maxSingleTransferAmountDollars: Scalars['Int'];
  balanceCheckBufferAmountDollars: Scalars['Int'];
  balanceCheckBufferAmountDollarsWarning: Scalars['Int'];
};

export type MoneyTransferFinancialAccountTransferLimits = {
  __typename?: 'MoneyTransferFinancialAccountTransferLimits';
  id: Scalars['ID'];
  dayLimit: Scalars['Int'];
  maxTransferAmountDollars: Scalars['Int'];
  weekLimit: Scalars['Int'];
  monthLimit: Scalars['Int'];
};

export enum MoneyTransferFinancialAccountTypeEnum {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type MoneyTransferKbaAnswer = {
  __typename?: 'MoneyTransferKbaAnswer';
  text: Scalars['String'];
  id: Scalars['ID'];
};

export type MoneyTransferKbaQuestion = {
  __typename?: 'MoneyTransferKbaQuestion';
  text: Scalars['String'];
  id: Scalars['ID'];
  answers: Array<MoneyTransferKbaAnswer>;
};

export type MoneyTransferKbaQuestionsResponse = {
  __typename?: 'MoneyTransferKbaQuestionsResponse';
  questions: Array<MoneyTransferKbaQuestion>;
};

export type MoneyTransferTransfer = {
  __typename?: 'MoneyTransferTransfer';
  /** The unique identifier for this transfer in money-management */
  id: Scalars['ID'];
  /** The current (high-level) status for this transfer (combination of money-management + ach statuses) */
  status: MoneyTransferTransferStatusEnum;
  /** The transfer amount in USD */
  amount: Scalars['Float'];
  /** The source account from where the money is retrieved */
  sourceAccount: MoneyTransferAccount;
  /** The destination account to where the money is deposited */
  destinationAccount: MoneyTransferAccount;
  /** Indicates the speed of the transfer */
  type?: Maybe<MoneyTransferTransferTypeEnum>;
  /** Timestamp indicating when the user attempted to initiate the transfer */
  userInitiatedAt: Scalars['DateTime'];
  /** Timestamp indicating when the (high-level) status was last updated */
  lastStatusUpdatedAt: Scalars['DateTime'];
  /** A JSON blob with additional transfer details */
  achData?: Maybe<Scalars['JSON']>;
  /** Indicates if the user can still cancel this transfer */
  canCancel?: Maybe<Scalars['Boolean']>;
  /**
   * The status histories define when and what state changes occurred over the lifecycle
   * of the transfer
   */
  statusHistory: Array<MoneyTransferTransferStatusHistory>;
};

export type MoneyTransferTransferLimits = {
  __typename?: 'MoneyTransferTransferLimits';
  defaultLimits: MoneyTransferDefaultTransferLimits;
  userLimits: MoneyTransferUserTransferLimits;
  financialAccountLimits: Array<MoneyTransferFinancialAccountTransferLimits>;
};

export type MoneyTransferTransferLimitsResponse = {
  __typename?: 'MoneyTransferTransferLimitsResponse';
  transferLimits: MoneyTransferTransferLimits;
};

export type MoneyTransferTransfersResponse = {
  __typename?: 'MoneyTransferTransfersResponse';
  /** List of all money transfer made for this user */
  transfers: Array<MoneyTransferTransfer>;
};

export enum MoneyTransferTransferStatusEnum {
  Created = 'CREATED',
  Cancelled = 'CANCELLED',
  CancelInitiatedBySecurity = 'CANCEL_INITIATED_BY_SECURITY',
  CancelInitiatedByUser = 'CANCEL_INITIATED_BY_USER',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedDuringActivation = 'FAILED_DURING_ACTIVATION',
  MockTransfer = 'MOCK_TRANSFER',
  Pending = 'PENDING',
  PendingBalanceCheck = 'PENDING_BALANCE_CHECK',
  Uninitialized = 'UNINITIALIZED'
}

export type MoneyTransferTransferStatusHistory = {
  __typename?: 'MoneyTransferTransferStatusHistory';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  status: MoneyTransferTransferStatusEnum;
  transferId: Scalars['ID'];
};

export enum MoneyTransferTransferTypeEnum {
  NextDay = 'NEXT_DAY',
  Standard = 'STANDARD'
}

export type MoneyTransferUser = {
  __typename?: 'MoneyTransferUser';
  /** KYC first name */
  firstName: Scalars['String'];
  /** KYC last name */
  lastName: Scalars['String'];
  /** Computed status for this user (combination of money-management + ach statuses) */
  computedStatus: MoneyTransferUserStatus;
};

export enum MoneyTransferUserStatus {
  Unknown = 'UNKNOWN',
  UserAchDisabled = 'USER_ACH_DISABLED',
  UserAchEnabled = 'USER_ACH_ENABLED',
  UserAchKba = 'USER_ACH_KBA',
  UserAchRetryWithFullSsn = 'USER_ACH_RETRY_WITH_FULL_SSN',
  UserInactive = 'USER_INACTIVE',
  UserNotInAchSystem = 'USER_NOT_IN_ACH_SYSTEM',
  UserReady = 'USER_READY',
  UserUninitialized = 'USER_UNINITIALIZED'
}

export type MoneyTransferUserTransferLimits = {
  __typename?: 'MoneyTransferUserTransferLimits';
  userDailyLimit: Scalars['Int'];
  userWeeklyLimit: Scalars['Int'];
  userMonthlyLimit: Scalars['Int'];
  maxMonthlyTransferAmountDollars: Scalars['Int'];
  maxSingleTransferAmountDollars: Scalars['Int'];
};

/** Employment type */
export enum MortgageEmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Unemployed = 'UNEMPLOYED'
}

/** Inputs for Mortgage lender match logic.  Subset of Mortgage OSX inputs */
export type MortgageLenderMatchInput = {
  /** Amount of cash-out the user wants */
  cashout?: Maybe<Scalars['Int']>;
  /** User's credit score */
  creditScore?: Maybe<Scalars['Int']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: Maybe<Scalars['Int']>;
  /** Employment type */
  employmentType?: Maybe<MortgageEmploymentTypeEnum>;
  /** Should we match FHA loans? */
  fha?: Maybe<Scalars['Boolean']>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: Maybe<Scalars['Boolean']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: Maybe<MortgageLoanPurposeEnum>;
  /** Offer loan_type */
  loanType?: Maybe<MortgagesOfferV2LoanTypeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: Maybe<Scalars['Int']>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: Maybe<Scalars['Int']>;
  /** US state abbrieviation */
  state?: Maybe<Scalars['String']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: Maybe<Scalars['Boolean']>;
};

export type MortgageLicensed = {
  __typename?: 'MortgageLicensed';
  /** State looked up from user's zipCode */
  state?: Maybe<Scalars['String']>;
  /** Whether NerdWallet a licensed mortgage broker */
  isLicensed: Scalars['Boolean'];
};

/** FIXME: this violates enum best practices by having lowercase values */
export enum MortgageLoanPurposeEnum {
  Purchase = 'purchase',
  Refinance = 'refinance'
}

/** The `MortgageProduct` type contains mortgage specific fields from marketplace */
export type MortgageProduct = ProductInterface & {
  __typename?: 'MortgageProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  details?: Maybe<MortgageProductDetails>;
};

export type MortgageProductDetails = {
  __typename?: 'MortgageProductDetails';
  logo?: Maybe<Scalars['String']>;
  lenderId?: Maybe<Scalars['String']>;
};

export type MortgageSavedLeadMatchInput = {
  id?: Maybe<Scalars['ID']>;
};

/** A Mortgages institution */
export type MortgagesInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'MortgagesInstitutionV2';
  /** Lender name to display */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** Loan programs and types to feature for the lender */
  featuredLoanAttributes?: Maybe<Array<Scalars['String']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL to logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** Are personalized rates enabled? */
  isRatesEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** NMLS Unique Identifier */
  nmlsId?: Maybe<Scalars['String']>;
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Mortgages offer */
export type MortgagesOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'MortgagesOfferV2';
  /** Long-form text about the lender, each item is a paragraph */
  aboutLender?: Maybe<Array<Scalars['String']>>;
  applyLink?: Maybe<Scalars['URL']>;
  /** Short description of what the lender is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']>>;
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Coverage area for the lender */
  coverageArea?: Maybe<Scalars['String']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** Which drivers should be highlighted for this offer */
  drivers?: Maybe<Array<Scalars['String']>>;
  /** Entity type */
  entityType: Scalars['String'];
  /** US States that the lender will not service */
  excludedStates?: Maybe<Array<Scalars['String']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Used to determine if placement is monetizing */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Loan type this offer represents */
  loanType?: Maybe<MortgagesOfferV2LoanTypeEnum>;
  /** Display value for maximum loan-to-value */
  maxLtv?: Maybe<Scalars['String']>;
  /** Overrides tooltip value for maximum loan-to-value */
  maxLtvTooltip?: Maybe<Scalars['String']>;
  /** Display value for minimum credit score */
  minCreditScore?: Maybe<Scalars['String']>;
  /** Overrides tooltip value for minimum credit score */
  minCreditScoreTooltip?: Maybe<Scalars['String']>;
  /** Display value for minimum down payment. Only applicable to PURCHASE loans */
  minDownPayment?: Maybe<Scalars['String']>;
  /** Overrides tooltip value for minimum down payment */
  minDownPaymentTooltip?: Maybe<Scalars['String']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** NMLS (Nationwide Mortgage Licensing System and Registry) Unique Identifier */
  nmlsId?: Maybe<Scalars['String']>;
  /** Bullet points providing an overview of the lender */
  overview?: Maybe<Array<Scalars['String']>>;
  product: MortgagesProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** Disclaimer for the NerdWallet rating */
  ratingDisclaimer?: Maybe<Scalars['String']>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this lender */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

export enum MortgagesOfferV2LoanTypeEnum {
  Cashout = 'CASHOUT',
  Conventional = 'CONVENTIONAL',
  Fha = 'FHA',
  Hel = 'HEL',
  Heloc = 'HELOC',
  Jumbo = 'JUMBO',
  Usda = 'USDA',
  Va = 'VA'
}

/** A Mortgages product */
export type MortgagesProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'MortgagesProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: MortgagesInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** The lender's phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The type of loan */
  type?: Maybe<MortgagesProductV2TypeEnum>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export enum MortgagesProductV2TypeEnum {
  HomeEquity = 'HOME_EQUITY',
  Purchase = 'PURCHASE',
  Refinance = 'REFINANCE'
}

/** Partial address, currently only supports zipCode */
export type MortgageUserAddressInput = {
  zipCode: Scalars['String'];
};

/** Empty field. Not to be used. */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  /** Registers a new user via first party credentials */
  registerUser?: Maybe<RegisterUserResponse>;
  /** Logs out the current user */
  logOutUser?: Maybe<LogOutUserResponse>;
  /** Log in an existing user via first party credentials */
  logInUser?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Google credentials */
  logInUserViaGoogle?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Apple credentials */
  logInUserViaApple?: Maybe<LogInUserResponse>;
  /** Log in an existing user via a refresh token */
  logInUserViaRefreshToken?: Maybe<LogInUserResponse>;
  /** Updates the current user's password */
  updatePassword?: Maybe<Scalars['Boolean']>;
  /** Resets the current user's password */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Send a password reset email to the provided email */
  sendPasswordResetEmail?: Maybe<Scalars['Boolean']>;
  /** Sets the user's security question and answer */
  setSecurityQuestion?: Maybe<Scalars['Boolean']>;
  /** Deactivates the current user's account */
  deactivateUser?: Maybe<Scalars['Boolean']>;
  /** Generate a one-time login token for the current user */
  generateOneTimeLoginToken?: Maybe<Scalars['Boolean']>;
  /** Generate a one-time transfer token for a cookie id */
  generateOneTimeCookieIdTransferToken?: Maybe<Scalars['Boolean']>;
  /** Initializes a CSRF session for the current user */
  initializeCsrfSession?: Maybe<Scalars['Boolean']>;
  /**
   * Accepts the users details and attempts to initialize their TU profile.
   * If this is successful, TU will return security questions to present to
   * the user and put the user in status = PENDING.
   */
  initializeCreditProfile: CreditProfileAuthStatusProfile;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   * If this is successful, the user will be put in status = AUTHENTICATED.
   * Next it will attempt to enroll the user. If this is successful, then
   * the user will be put in status = ACTIVE and the credit report will
   * be returned.
   */
  authenticateCreditProfile: TuCreditReportIdentityProfile;
  /**
   * This is only needed if authenticateCreditProfile left the user in
   * status = AUTHENTICATED (instead of ACTIVE).
   */
  enrollCreditProfile: TuCreditReportIdentityProfile;
  /**
   * Publish a simple CRM event (CRM events that just have identity_id in its payload)
   * publishSimpleCRMEvent will be deprecated and replaced by publishCRMEvent,
   * which can handle payloads with just identity_id, and payloads with identity_id
   * and other custom fields.
   * 
   * Publish messages to a private Yak exchange.
   * If message fails to publish due to an error, the mutation will result in an error located at
   * `errors[0].message` indicating why the message failed.
   */
  publishSimpleCRMEvent: PublishYakMessageResult;
  /**
   * Publish a CRM Event
   * 
   * Publish messages to a private Yak exchange.
   * If message fails to publish due to an error, the mutation will result in an error located at
   * `errors[0].message` indicating why the message failed.
   */
  publishCRMEvent: PublishYakMessageResult;
  /**
   * Dismisses opt-in CTAs for the user.
   * This expects the user to be in the ELIGIBLE state before dismissing,
   * and sets them to DISMISSED
   */
  dismissFdpOptIn?: Maybe<FdpOptInStateResponse>;
  /**
   * Opts an eligible user into FDP by:
   * 1. Removing their Yodlee accounts so that they can link with FDP
   * 2. Setting the user's opt-in state to OPTED_IN
   */
  optInToFdp?: Maybe<FdpOptInStateResponse>;
  updateFinancialAccountVisibility?: Maybe<FinancialAccount>;
  createManualTransactionAccount?: Maybe<CreateManualTransactionAccountResponse>;
  /** Create a portal for a particular institution */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /** Reinitialize a portal for fixing a broken link */
  reinitializeFinancialPortal?: Maybe<ReinitializeFinancialPortalResponse>;
  /** Initializes the migration of a portal to a new primary source */
  migrateFinancialPortal?: Maybe<MigrateFinancialPortalResponse>;
  /** Finishes the migration of a portal to a new primary source despite data loss */
  finishPortalMigration?: Maybe<FinishPortalMigrationResponse>;
  /** Delete a financial portal (for unlinking) */
  deleteFinancialPortal?: Maybe<DeleteFinancialPortalResponse>;
  /** Attempt to trigger a refresh of the data associated with a financial portal */
  refreshFinancialPortal?: Maybe<FinancialPortal>;
  /**
   * Sends information to the appropriate plugin for the financial portal. Typically used for
   * facilitating and sending progress on the linking flow.
   * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event
   */
  publishFinancialDataLinkEvent?: Maybe<FinancialPortalMessageResponse>;
  /** Creates a FinancialTransaction and links it to the account given by accountId. */
  createFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Attempts to delete a FinancialTransaction by id. */
  deleteFinancialTransaction?: Maybe<DeleteFinancialTransactionResponse>;
  /**
   * Updates the visibility of a transaction.
   * Transactions that are hidden are excluded from transaction calculations and aggregations.
   */
  updateFinancialTransactionVisibility?: Maybe<FinancialTransaction>;
  /**  Updates the category of a transaction.  */
  updateFinancialTransactionCategory?: Maybe<FinancialTransaction>;
  /**
   * Updates the category of a merchant.
   * All transactions for that merchant will be given the category of the merchant, unless they have their
   * own respective transaction category override specified.
   * @deprecated replaced in the product with the Edit feature that uses updateFinancialTransaction. Can be removed once all clients are on the latest release
   */
  updateFinancialMerchantTransactionCategory?: Maybe<UpdateFinancialMerchantTransactionCategoryResponse>;
  /** Updates the amount, category, and date fields of the transaction given by transactionId. */
  updateFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Update subscription_profile_v2 of the user. Only changed fields are required. */
  updateSubscriptionProfile?: Maybe<SubscriptionIdentityProfile>;
  /** Update subscription settings for a user via a one time use token path. */
  updateSubscriptionWithoutIdentity?: Maybe<SubscriptionIdentityProfile>;
  /** Unsubscribes from a specific notification type */
  unsubscribeFromNotification?: Maybe<SubscriptionIdentityProfile>;
  addMobileAppDevice?: Maybe<MobileAppIdentityProfile>;
  updateMembershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  /** Update the user's income information. */
  updateIncome: UpdateIncomeResponse;
  /** Update the user's name. */
  updateName: UpdateNameResponse;
  /** Creates a money transfer account to be used in a money transfer */
  moneyTransferCreateAccount?: Maybe<CreateMoneyTransferAccountResponse>;
  /** Cancels a transfer */
  moneyTransferCancelTransfer?: Maybe<MoneyTransferCancelTransferResponse>;
  /** Creates a transfer */
  moneyTransferCreateTransfer?: Maybe<CreateMoneyTransferResponse>;
  moneyTransferCreateUser?: Maybe<MoneyTransferCreateUserResponse>;
  /**
   * Accepts the account hidden value and attempts to patch the account in Wealth Recommender.
   * If this is successful, the response will return with the updated account object.
   */
  updateNetWorthAccountVisibility?: Maybe<UpdateNetWorthAccountVisibilityResponse>;
  /**
   * Accepts the data object representing a linked Real Asset of type Home in Wealth Recommender and attempts to add it.
   * If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthHomeIntegrated?: Maybe<AddNetWorthHomeIntegratedResponse>;
  /**
   * Accepts an asset type, nickname, and amount and attempts to add it.
   * If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthRealAssetSelfReported?: Maybe<AddNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the new real asset isHiddenFromNetWorth value and attempts to update it.
   * If this is successful, the response will return with the updated asset object.
   */
  updateNetWorthRealAssetIsHiddenFromNetWorth?: Maybe<UpdateNetWorthRealAssetResponse>;
  /**
   * Accepts a new nickname and/or amount and attempts to update the asset with
   * id netWorthRealAssetId.
   * If this is successful, the response will return with the updated asset object.
   */
  editNetWorthRealAssetSelfReported?: Maybe<EditNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the id of the real asset in Wealth Recommender and attempts to delete it.
   * If this is successful, the response will be an object containing a boolean "success"
   * property.
   */
  deleteNetWorthRealAsset?: Maybe<DeleteNetWorthRealAssetResponse>;
  /**
   * Initiate prequal jobs, which can be polled by ID, from user input to personal
   * loans prequal service. The underlying service adds any personal loan offers
   * to the user profile.
   */
  initiatePersonalLoansPrequalRequest: Array<PrequalJob>;
  /**
   * Initiate prequal jobs, which can be polled by ID, from user input to student
   * loans prequal service. The underlying service adds any student loan offers
   * to the user profile.
   */
  initiateStudentLoansPrequalRequest?: Maybe<Array<PrequalJob>>;
  /** Update the primary card for the user. */
  activateRewardsOffer: RewardsMutationSuccessResponse;
  setPrimaryRewardsCard: RewardsSetPrimaryCardResponse;
  setRewardsCardLinked: Scalars['String'];
  unlinkRewardsCard: Scalars['String'];
  /** Add new credit cards to a list of self-reported cards a user owns. */
  addUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /**
   * Update in full, the list of self-reported cards a user owns.
   * This will replace the current list of cards a user has reported owning.
   */
  setUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Remove an individual card from the list of self-reported credit cards a user owns. */
  removeUserReportedCreditCard?: Maybe<RemoveUserReportedCreditCardResult>;
  /** Remove all self-reported credit cards from the user profile */
  removeAllUserReportedCreditCards: RewardsMutationSuccessResponse;
  triggerOnlineOfferMerchantLinkEmail?: Maybe<RewardsMutationSuccessResponse>;
  publishViewedPYCRExperience: Scalars['String'];
  /**
   * Publish messages to a Yak exchange.
   * 
   * If any message fails to publish due to an error, the mutation will result in an error with an
   * array of results (of equal length as the messages input) located at
   * `errors[0].extensions.exception.results` indicating which message(s) failed and why.
   */
  publishYakMessages: Array<PublishYakMessageResult>;
  recategorizeTransaction?: Maybe<TransactionTagRule>;
};


/** Empty field. Not to be used. */
export type MutationRegisterUserArgs = {
  registerInfo: NwRegisterInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserArgs = {
  loginInfo: NwLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaGoogleArgs = {
  loginInfo: GoogleLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaAppleArgs = {
  loginInfo: AppleLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaRefreshTokenArgs = {
  loginInfo: RefreshTokenLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationUpdatePasswordArgs = {
  passwordInfo: UpdatePasswordInfoInput;
};


/** Empty field. Not to be used. */
export type MutationResetPasswordArgs = {
  resetInfo: ResetPasswordInfoInput;
};


/** Empty field. Not to be used. */
export type MutationSendPasswordResetEmailArgs = {
  resetInfo: SendResetPasswordEmailInfoInput;
};


/** Empty field. Not to be used. */
export type MutationSetSecurityQuestionArgs = {
  securityInfo: SecurityQuestionInfoInput;
};


/** Empty field. Not to be used. */
export type MutationInitializeCreditProfileArgs = {
  customer: CreditProfileAuthCustomerInput;
  trustSessionId?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
};


/** Empty field. Not to be used. */
export type MutationPublishSimpleCrmEventArgs = {
  eventName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationPublishCrmEventArgs = {
  eventName: Scalars['String'];
  customPayload?: Maybe<Scalars['JSON']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialAccountVisibilityArgs = {
  financialAccountId: Scalars['ID'];
  isHidden: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationReinitializeFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMigrateFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationFinishPortalMigrationArgs = {
  financialPortalId: Scalars['ID'];
  shouldMigrate?: Maybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationRefreshFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  isAutoRefresh?: Maybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type MutationPublishFinancialDataLinkEventArgs = {
  event: ProxyEventType;
  eventBody?: Maybe<Scalars['JSON']>;
  financialPortalId?: Maybe<Scalars['ID']>;
  sourceEntityId?: Maybe<Scalars['ID']>;
  source?: Maybe<FinancialDataSource>;
  sourceInstitutionId?: Maybe<Scalars['ID']>;
  migrationMarketplaceInstitutionId?: Maybe<Scalars['ID']>;
  isMigrate?: Maybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type MutationCreateFinancialTransactionArgs = {
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  category: FinancialTransactionCategory;
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  merchantName: Scalars['String'];
  type: FinancialTransactionType;
};


/** Empty field. Not to be used. */
export type MutationDeleteFinancialTransactionArgs = {
  transactionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionVisibilityArgs = {
  transactionId: Scalars['ID'];
  isHidden: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionCategoryArgs = {
  transactionId: Scalars['ID'];
  category: FinancialTransactionCategory;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialMerchantTransactionCategoryArgs = {
  transactionId: Scalars['ID'];
  category: FinancialTransactionCategory;
  merchantName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionArgs = {
  transactionId: Scalars['ID'];
  amount: Scalars['Int'];
  category: FinancialTransactionCategory;
  date: Scalars['DateTime'];
  merchantName?: Maybe<Scalars['String']>;
  type?: Maybe<FinancialTransactionType>;
};


/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionProfileArgs = {
  subscriptionProfile: UpdateSubscriptionProfileInput;
  identityId: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionWithoutIdentityArgs = {
  subscriptionSettings: UpdateSubscriptionProfileInput;
};


/** Empty field. Not to be used. */
export type MutationUnsubscribeFromNotificationArgs = {
  subscriptionField: SubscriptionTypeEnum;
  unsubscribeToken: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationAddMobileAppDeviceArgs = {
  device: MobileAppProfileDeviceInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateMembershipAppActivityArgs = {
  membershipAppActivity: MembershipAppActivityInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateIncomeArgs = {
  input: UpdateIncomeInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateNameArgs = {
  input: UpdateNameInput;
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateAccountArgs = {
  financialAccountId: Scalars['ID'];
  moneyTransferAccountType: MoneyTransferFinancialAccountTypeEnum;
  financialAccountSource: FinancialDataSource;
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCancelTransferArgs = {
  transferId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateTransferArgs = {
  amount: Scalars['Int'];
  sourceMoneyTransferAccountId: Scalars['ID'];
  destinationMoneyTransferAccountId: Scalars['ID'];
  idempotencyKey: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateUserArgs = {
  userInput: MoneyTransferCreateUserInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateNetWorthAccountVisibilityArgs = {
  netWorthAccountId: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationAddNetWorthHomeIntegratedArgs = {
  address: NetWorthHomeIntegratedAddressInput;
  externalInfo: NetWorthHomeIntegratedExternalInfoInput;
};


/** Empty field. Not to be used. */
export type MutationAddNetWorthRealAssetSelfReportedArgs = {
  type: NetWorthRealAssetTypeEnum;
  nickname: Scalars['String'];
  amount: Scalars['Float'];
};


/** Empty field. Not to be used. */
export type MutationUpdateNetWorthRealAssetIsHiddenFromNetWorthArgs = {
  netWorthRealAssetId: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationEditNetWorthRealAssetSelfReportedArgs = {
  amount?: Maybe<Scalars['Float']>;
  netWorthRealAssetId: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationInitiatePersonalLoansPrequalRequestArgs = {
  userInput: PersonalLoansPrequalOfferInput;
  providerIds: Array<Maybe<PersonalLoansPrequalProviderIdEnum>>;
};


/** Empty field. Not to be used. */
export type MutationInitiateStudentLoansPrequalRequestArgs = {
  userInput: StudentLoansPrequalOfferInput;
};


/** Empty field. Not to be used. */
export type MutationActivateRewardsOfferArgs = {
  offerId: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type MutationSetPrimaryRewardsCardArgs = {
  cardId: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type MutationSetRewardsCardLinkedArgs = {
  lastFour: Scalars['String'];
  cardType: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationUnlinkRewardsCardArgs = {
  cardId: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type MutationAddUserReportedCreditCardsArgs = {
  cards: Array<UserReportedCreditCardInput>;
};


/** Empty field. Not to be used. */
export type MutationSetUserReportedCreditCardsArgs = {
  cards?: Maybe<Array<UserReportedCreditCardInput>>;
};


/** Empty field. Not to be used. */
export type MutationRemoveUserReportedCreditCardArgs = {
  cardId: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type MutationTriggerOnlineOfferMerchantLinkEmailArgs = {
  merchantId: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationPublishYakMessagesArgs = {
  messages: Array<YakMessageInput>;
};


/** Empty field. Not to be used. */
export type MutationRecategorizeTransactionArgs = {
  transactionId: Scalars['String'];
  category: Scalars['String'];
  categoryVersion?: Maybe<Scalars['Int']>;
};

export type MyCardsActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'MyCardsActivationVisualization';
  /** This will always be MY_CARDS_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/** A user insight sourced from my-cards-service */
export type MyCardsInsight = UserInsightInterface & {
  __typename?: 'MyCardsInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   * 
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   * 
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   * 
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   * 
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   * 
   * For exmaple, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   * 
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   * 
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   * 
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   * 
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

/** The data shape of an account in Wealth Recommender. This is not an exhaustive set of properties. */
export type NetWorthAccount = {
  __typename?: 'NetWorthAccount';
  id: Scalars['ID'];
  /**
   * Note: Id is used here instead of a GQL relation because of the current state of how clients
   * source and access financial accounts. In future it would be better practice to resolve the
   * financial account along with these annotation fields in the same query.
   */
  financialAccountId: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};

/** Wraps the net worth account API response for flexibility in future property expansion */
export type NetWorthAccountResponse = {
  __typename?: 'NetWorthAccountResponse';
  account: NetWorthAccount;
};

/**
 * Wraps the set of net worth accounts and leaves the schema open for the addition of metadata or
 * other supplemental data fields in the future
 */
export type NetWorthAccountsResponse = {
  __typename?: 'NetWorthAccountsResponse';
  accounts: Array<NetWorthAccount>;
};

export type NetWorthActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'NetWorthActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type NetWorthBalances = {
  __typename?: 'NetWorthBalances';
  /**
   * The sum of all balances in asset accounts (checking, savings, investment, retirement)
   * (based on the account's nw_type) for a user. This sum excludes the sum of the user's
   * home assets.
   * Null if a user does not have any linked asset accounts.
   */
  totalAssets?: Maybe<Scalars['Float']>;
  /**
   * The updated sum of all total monetary assets as well as home asset values.
   * Null if a user does not have any linked asset accounts nor home assets.
   */
  totalAssetsIncludingHomeValues?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in debt accounts (loans, credit cards) (based on the account's
   * nw_type) for a user. This sum includes the sum of the user's mortgage account balances.
   * Null if a user does not have any linked debt accounts.
   */
  totalDebts?: Maybe<Scalars['Float']>;
  /**
   * The updated sum of all total debts, subtracting the balances of mortgage accounts. This is
   * for the product scenario where we want to display mortgages alongside their associated home
   * values, while still showing non-mortgage debts elsewhere.
   * Null if a user does not have any linked non-mortgage debt accounts.
   */
  totalDebtsExcludingMortgages?: Maybe<Scalars['Float']>;
  /**
   * The total value of homes subtract mortgage debts.
   * Null if a user does not have any home assets nor linked mortgage accounts.
   */
  totalHomeEquity?: Maybe<Scalars['Float']>;
  /**
   * Defined as totalAssets - totalDebts. This does not include the value of the user's home
   * equity.
   * Null if a user does not have any linked accounts.
   */
  totalNetWorth?: Maybe<Scalars['Float']>;
  /**
   * The updated net worth value, which includes home asset values.
   * Null if a user does not have any linked accounts nor homes.
   */
  totalNetWorthIncludingHomeEquity?: Maybe<Scalars['Float']>;
  /** An object containing the sums of balances in each asset account type */
  assetSums: NetWorthBalancesAssetSums;
  /** An object containing the sums of balances in each debt account type */
  debtSums: NetWorthBalancesDebtSums;
};

export type NetWorthBalancesAssetSums = {
  __typename?: 'NetWorthBalancesAssetSums';
  /**
   * The sum of all balances in checking accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked checking accounts.
   */
  checkingSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in savings accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked savings accounts.
   */
  savingsSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in investment accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked investment accounts.
   */
  investmentSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in retirement accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked retirement accounts.
   */
  retirementSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all home asset values.
   * Null if a user does not have any linked home assets.
   */
  homeValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all auto asset values.
   * Null if a user does not have any auto assets.
   */
  autoValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all personal property asset values.
   * Null if a user does not have any personal property assets.
   */
  personalPropertyValueSum?: Maybe<Scalars['Float']>;
};

export type NetWorthBalancesDebtSums = {
  __typename?: 'NetWorthBalancesDebtSums';
  /**
   * The sum of all balances in loan accounts for a user.
   * Null if a user does not have any linked loan accounts.
   */
  loanSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in credit card accounts for a user.
   * Null if a user does not have any linked credit card accounts.
   */
  creditCardSum?: Maybe<Scalars['Float']>;
  /**
   * The updated loan sum, excluding mortgage accounts.
   * Null if a user does not have any linked non-mortgage loan accounts.
   */
  nonMortgageLoanSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in mortgage accounts for a user.
   * Null if a user does not have any linked mortgage accounts.
   */
  mortgageSum?: Maybe<Scalars['Float']>;
};

export type NetWorthContribution = {
  __typename?: 'NetWorthContribution';
  amount: Scalars['Float'];
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
  destinationFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  sourceFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  status?: Maybe<NetWorthContributionStatus>;
  transferId?: Maybe<Scalars['ID']>;
  type?: Maybe<NetWorthContributionType>;
};

export type NetWorthContributionFinancialAccount = {
  __typename?: 'NetWorthContributionFinancialAccount';
  financialAccountId?: Maybe<Scalars['ID']>;
  financialAccount?: Maybe<FinancialAccount>;
  financialAccountLastFour?: Maybe<Scalars['String']>;
  financialAccountName?: Maybe<Scalars['String']>;
  financialAccountTransactionDate?: Maybe<Scalars['Date']>;
  financialAccountTransactionId?: Maybe<Scalars['ID']>;
  financialAccountType?: Maybe<NetWorthContributionFinancialAccountType>;
};

export enum NetWorthContributionFinancialAccountType {
  Checking = 'CHECKING',
  Investment = 'INVESTMENT',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS'
}

export enum NetWorthContributionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type NetWorthContributionSummaries = {
  __typename?: 'NetWorthContributionSummaries';
  contributionSummaries: Array<NetWorthContributionSummary>;
};

export type NetWorthContributionSummary = {
  __typename?: 'NetWorthContributionSummary';
  completedContributionSum?: Maybe<Scalars['Float']>;
  contributions: Array<NetWorthContribution>;
  date?: Maybe<Scalars['Date']>;
  month?: Maybe<Scalars['String']>;
  pendingContributionSum?: Maybe<Scalars['Float']>;
  totalContributionSum?: Maybe<Scalars['Float']>;
};

export enum NetWorthContributionType {
  Contribution = 'CONTRIBUTION',
  Deposit = 'DEPOSIT',
  Invalid = 'INVALID',
  Rebalance = 'REBALANCE'
}

export type NetWorthHistoryDataPoint = {
  __typename?: 'NetWorthHistoryDataPoint';
  date: Scalars['DateTime'];
  value: Scalars['Int'];
};

export enum NetWorthHistoryFiltersEnum {
  Total = 'TOTAL',
  Cash = 'CASH',
  Investments = 'INVESTMENTS',
  Property = 'PROPERTY',
  CreditCards = 'CREDIT_CARDS',
  Loans = 'LOANS'
}

export type NetWorthHistoryResponse = {
  __typename?: 'NetWorthHistoryResponse';
  netWorthFilter: NetWorthHistoryFiltersEnum;
  history: Array<Maybe<NetWorthHistoryDataPoint>>;
};

export type NetWorthHistorySnapshotNotificationResponse = {
  __typename?: 'NetWorthHistorySnapshotNotificationResponse';
  showSnapshotNotification: Scalars['Boolean'];
};

/**
 * The data shape of a Home — integrated with Redfin, in Wealth Recommender. "Integrated"
 * describes the fact that this asset's data is sourced from a 3rd-party integration with a data
 * provider, e.g. Redfin. This is meant to be a differentiator for self-reported Home values.
 */
export type NetWorthHomeIntegrated = NetWorthRealAsset & {
  __typename?: 'NetWorthHomeIntegrated';
  id: Scalars['ID'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  address: NetWorthHomeIntegratedAddress;
  externalInfo?: Maybe<NetWorthHomeIntegratedExternalInfo>;
  isSelfReported: Scalars['Boolean'];
};

export type NetWorthHomeIntegratedAddress = {
  __typename?: 'NetWorthHomeIntegratedAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type NetWorthHomeIntegratedAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeIntegratedExternalInfo = {
  __typename?: 'NetWorthHomeIntegratedExternalInfo';
  source: NetWorthHomeValueResultSourceEnum;
  value?: Maybe<Scalars['Float']>;
};

/**
 * These fields are the same as the fields in the NetWorthHomeValueResultResponse type. The client
 * takes these values from the search response and pipes them into the addNetWorthHomeIntegrated
 * mutation.
 */
export type NetWorthHomeIntegratedExternalInfoInput = {
  source: NetWorthHomeValueResultSourceEnum;
  propertyId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type NetWorthHomeValuePossibilityResponseData = NetWorthHomeValueResultResponseDataInterface & {
  __typename?: 'NetWorthHomeValuePossibilityResponseData';
  /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Possibility. */
  type: NetWorthHomeValueResultTypeEnum;
  /** The list of possible home values for ambiguous cases */
  possibilities?: Maybe<Array<NetWorthHomeValueResultResponseData>>;
};

export type NetWorthHomeValueResultAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeValueResultByPropertyIdResponse = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponse';
  /**
   * The data shape for this query will not return "type", "address", nor "url" unlike the other
   * queries that POST to the same data source endpoint. This is because Redfin's API doesn't
   * return these fields when querying by "property_id".
   */
  data: NetWorthHomeValueResultByPropertyIdResponseData;
};

export type NetWorthHomeValueResultByPropertyIdResponseData = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponseData';
  /**
   * This field denotes which data provider is associated with the search result that is returned
   * to the client. This is a no-cost schema addition that grants us flexibility for a future
   * where we may have multiple providers with different prioritizations (e.g. Zillow search
   * result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   * home values for snapshotting.
   */
  propertyId: Scalars['String'];
  /** The value of the home related to the provided address. */
  value: Scalars['Float'];
};

export type NetWorthHomeValueResultResponse = {
  __typename?: 'NetWorthHomeValueResultResponse';
  /**
   * The response from the search data source is actually an array of results, but for the current
   * iteration of our clients we only support 1 set of search results. This schema represents the
   * highest priority search result from the array.
   */
  data?: Maybe<NetWorthHomeValueResultResponseData>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   * is to be handled gracefully. It contains the error data that the client needs in order to
   * make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

export type NetWorthHomeValueResultResponseAddress = {
  __typename?: 'NetWorthHomeValueResultResponseAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeValueResultResponseData = NetWorthHomeValueResultResponseDataInterface & {
  __typename?: 'NetWorthHomeValueResultResponseData';
  /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Result. */
  type: NetWorthHomeValueResultTypeEnum;
  /**
   * This field denotes which data provider is associated with the search result that is returned
   * to the client. This is a no-cost schema addition that grants us flexibility for a future
   * where we may have multiple providers with different prioritizations (e.g. Zillow search
   * result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   * home values for snapshotting.
   */
  propertyId?: Maybe<Scalars['String']>;
  /** The browser URL that maps to the property's posting. */
  url?: Maybe<Scalars['String']>;
  /** The value of the home related to the provided address. */
  value?: Maybe<Scalars['Float']>;
  address?: Maybe<NetWorthHomeValueResultResponseAddress>;
};

export type NetWorthHomeValueResultResponseDataInterface = {
  type: NetWorthHomeValueResultTypeEnum;
};

/**
 * The representation of the error data that the client will need in order to make UX decisions.
 * Currently only contains the error type.
 */
export type NetWorthHomeValueResultResponseError = {
  __typename?: 'NetWorthHomeValueResultResponseError';
  errorType: NetWorthHomeValueResultResponseErrorTypeEnum;
};

/**
 * The set of canonicalized error types that WR handles.
 * FIXME: this violates enum best practices by having lowercase values
 */
export enum NetWorthHomeValueResultResponseErrorTypeEnum {
  /** These enums represent error types that return from WR */
  HomeSourceApiRetryError = 'HomeSourceApiRetryError',
  HomeSourceApiInputError = 'HomeSourceApiInputError',
  HomeSourceApiNoResultError = 'HomeSourceApiNoResultError',
  HomeSourceApiFatalError = 'HomeSourceApiFatalError',
  InvalidInputError = 'InvalidInputError',
  HomeSourceApiServiceError = 'HomeSourceApiServiceError',
  HomeAlreadyExistsError = 'HomeAlreadyExistsError',
  /**
   * This is an error that is created within the resolver based on more specific error fields.
   * In the future if we support the ability to present users with ambiguous address options,
   * we should get rid of this error.
   */
  HomeSourceApiMultipleResultsError = 'HomeSourceApiMultipleResultsError'
}

/**
 * This enum represents the set of supported home value data source providers. Currently we only
 * support Redfin but our schemas are meant to be shaped for extensibility.
 */
export enum NetWorthHomeValueResultSourceEnum {
  Redfin = 'REDFIN'
}

/** The two types of results that may return from an address search */
export enum NetWorthHomeValueResultTypeEnum {
  /** Denotes that an exact home value match has been found based on the provided address */
  Result = 'RESULT',
  /**
   * Denotes that one or more low-confidence possible results have been found based on the
   * provided address
   */
  Possibility = 'POSSIBILITY'
}

export type NetWorthHomeValueResultWithPossibilitiesResponse = {
  __typename?: 'NetWorthHomeValueResultWithPossibilitiesResponse';
  data?: Maybe<NetWorthHomeValueResultResponseDataInterface>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   * is to be handled gracefully. It contains the error data that the client needs in order to
   * make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

/**
 * This interface will represent the amalgamation of the various asset types supported by Wealth
 * Recommender.
 */
export type NetWorthRealAsset = {
  id: Scalars['ID'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  /** For helping the client determine if the home is self-reported or not */
  isSelfReported: Scalars['Boolean'];
};

/** Wraps the Net Worth Real Asset API response, which allows for adding fields at a later date */
export type NetWorthRealAssetResponse = {
  __typename?: 'NetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

/**
 * The data shape of a Real Asset — self-reported by the user, in Wealth Recommender. This is a
 * different data model from the "Integrated" version of homes, which are synced with Redfin and
 * have their own set of requirements.
 */
export type NetWorthRealAssetSelfReported = NetWorthRealAsset & {
  __typename?: 'NetWorthRealAssetSelfReported';
  id: Scalars['ID'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The unique identifier for a self-reported asset in the UX. For contrast, NetWorthIntegrated
   * we use the address fields for uniqueness.
   */
  nickname: Scalars['String'];
  isSelfReported: Scalars['Boolean'];
};

/** Wraps the set of Net Worth Real Assets, which allows for adding fields at a later date */
export type NetWorthRealAssetsResponse = {
  __typename?: 'NetWorthRealAssetsResponse';
  assets: Array<NetWorthRealAsset>;
};

/** This enum represents the set of Real Asset types that the backend, WR, currently supports. */
export enum NetWorthRealAssetTypeEnum {
  Home = 'HOME',
  Auto = 'AUTO',
  PersonalProperty = 'PERSONAL_PROPERTY'
}

export type NetWorthRecommendation = {
  __typename?: 'NetWorthRecommendation';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  secureDetails?: Maybe<Scalars['JSON']>;
  status: NetWorthRecommendationStatus;
  type: NetWorthRecommendationType;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export enum NetWorthRecommendationCategory {
  All = 'ALL',
  BigPictureMoves = 'BIG_PICTURE_MOVES',
  Iao = 'IAO',
  QuickWins = 'QUICK_WINS'
}

export type NetWorthRecommendations = {
  __typename?: 'NetWorthRecommendations';
  recommendations: Array<NetWorthRecommendation>;
};

export type NetWorthRecommendationsFilterInput = {
  category: NetWorthRecommendationCategory;
};

export enum NetWorthRecommendationStatus {
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export enum NetWorthRecommendationType {
  CheckingToSavings = 'CHECKING_TO_SAVINGS',
  IntegratedAccountOpening = 'INTEGRATED_ACCOUNT_OPENING',
  LeftoverIncome = 'LEFTOVER_INCOME',
  NewDeposit = 'NEW_DEPOSIT',
  Refund = 'REFUND',
  SavingsToInvestment = 'SAVINGS_TO_INVESTMENT'
}

export type NwLoginInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress'];
  /** The password used to register an account */
  password: Scalars['String'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type NwRegisterInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress'];
  /** The password used to register an account */
  password: Scalars['String'];
  /** The tracking metadata to include with registration */
  trackingMetadata?: Maybe<RegistrationTrackingMetadata>;
};

/** OfferInterface contains the common base fields for all offers. */
export type OfferInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  endsAt?: Maybe<Scalars['DateTime']>;
};

export type OfflineCardLinkedOffer = {
  __typename?: 'OfflineCardLinkedOffer';
  address?: Maybe<RewardsOfflineAddress>;
  /** Is the business currently closed */
  closed?: Maybe<Scalars['Boolean']>;
  /** Business description */
  description?: Maybe<Scalars['String']>;
  /** Distance from user's search location */
  distance?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  localDay?: Maybe<Scalars['String']>;
  localTime?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  /** Name of the business establishment where people do business things */
  name?: Maybe<Scalars['String']>;
  /** A list of offers available */
  offers?: Maybe<Array<RewardsOfflineSubOffer>>;
  phone?: Maybe<Scalars['String']>;
  priceRange?: Maybe<Scalars['String']>;
  primaryCategory?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  ratingCount?: Maybe<Scalars['Int']>;
  simpleHours?: Maybe<RewardsOfflineSimpleHours>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type OffsetPaginationInput = {
  /** The maximum number of results to return. */
  limit?: Maybe<Scalars['Int']>;
  /** The start index of the results to return. Useful for pagination. */
  offset?: Maybe<Scalars['Int']>;
};

/** An online card linked offer from a retailer */
export type OnlineCardLinkedOffer = {
  __typename?: 'OnlineCardLinkedOffer';
  /**
   * List of actions (formerly commissions)
   * An 'action' is something a user needs to do to get a discount like 'Shop at walgreens.com'.
   * Sometimes, an 'action' has qualifiers, thus the items property of 'RewardsAction'.
   * In the past these were called 'commissions' and 'offers' due to an insufficient understanding of the CJ API.
   */
  actions?: Maybe<Array<RewardsAction>>;
  /** Brand Assets: image-related data for the UI */
  brandAssets?: Maybe<Array<Maybe<RewardsBrandAsset>>>;
  /**
   * List of commissions which may contain a list of RewardsOffer objects
   * @deprecated Use 'actions'
   */
  commissions?: Maybe<Array<RewardsCommission>>;
  /** Brand description */
  description: Scalars['String'];
  /** UID */
  id: Scalars['Int'];
  /** Language */
  language?: Maybe<Scalars['String']>;
  /** Display name of retailer */
  name: Scalars['String'];
  /** Network rank */
  networkRank?: Maybe<Scalars['String']>;
  /** Summary of min and max for easy display of possible range of earnings */
  summary: RewardsSummary;
  /** Redirect URL to retailer's website */
  referralLink?: Maybe<Scalars['String']>;
  /** Company URL */
  url: Scalars['String'];
};

export type OnlineCardLinkedOfferSearchResult = {
  __typename?: 'OnlineCardLinkedOfferSearchResult';
  /** Total number of results for a given search */
  totalMatches: Scalars['Int'];
  results?: Maybe<Array<OnlineCardLinkedOffer>>;
  hasMoreResults: Scalars['Boolean'];
};

/** Enum values to express which field to order collection query results by. */
export enum OrderByFieldEnum {
  Date = 'DATE',
  Id = 'ID',
  Include = 'INCLUDE',
  ModifiedDate = 'MODIFIED_DATE',
  Slug = 'SLUG'
}

/** The direction in which to order query results. */
export enum OrderDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The input type for ordering results. */
export type OrderInput = {
  /** Sort collection by object attribute. */
  field: OrderByFieldEnum;
  /** Order sort attribute ascending or descending. */
  sortDirection: OrderDirectionEnum;
};

/** Type modeling the data for posts within the page post type from WordPress. */
export type Page = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'Page';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Page object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The Page object for the parent of this entity. */
  parent?: Maybe<Page>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** Layout information for Structured Content Client to use */
export type PageLayout = {
  __typename?: 'PageLayout';
  /** The name of the template the page is using. This will be used for analytics purposes */
  name: Scalars['String'];
  /** The row config for the page layout */
  rows?: Maybe<Array<LayoutRow>>;
};

/** Personal Loan Institutions */
export type PersonalLoanInstitution = InstitutionInterface & {
  __typename?: 'PersonalLoanInstitution';
  /** There were no details when this schema was constructed. */
  details: EmptyObject;
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Personal Loan Offers */
export type PersonalLoanOffer = OfferInterface & {
  __typename?: 'PersonalLoanOffer';
  details: PersonalLoanOfferDetails;
  derivedDetails: PersonalLoanOfferDerivedDetails;
  endsAt?: Maybe<Scalars['DateTime']>;
  product: PersonalLoanProduct;
  startsAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  isMonetizing?: Maybe<Scalars['Boolean']>;
};

/**
 * Derived details about the personal loan offer.
 * Note: This are dependent on having the following query variables supplied:
 * - annualIncome
 * - loanAmount
 * - minCreditScore
 * - maxCreditScore
 * - zipCode
 */
export type PersonalLoanOfferDerivedDetails = {
  __typename?: 'PersonalLoanOfferDerivedDetails';
  applyLink?: Maybe<Scalars['URL']>;
  avgNarrowApr?: Maybe<Scalars['Float']>;
  isAllowedForZipCode?: Maybe<Scalars['Boolean']>;
  maxNarrowApr?: Maybe<Scalars['Float']>;
  minNarrowApr?: Maybe<Scalars['Float']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
};

/** Details about the personal loan offer */
export type PersonalLoanOfferDetails = {
  __typename?: 'PersonalLoanOfferDetails';
  aprTooltip?: Maybe<Scalars['String']>;
  consBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  delinquencies?: Maybe<Array<Scalars['String']>>;
  disclaimer?: Maybe<Scalars['String']>;
  excludedCitizenshipStatus: Array<Scalars['String']>;
  excludedHousing: Array<Scalars['String']>;
  excludedLoanPurpose: Array<PersonalLoanPurpose>;
  feesBullets?: Maybe<Array<Scalars['String']>>;
  imageAltText?: Maybe<Scalars['String']>;
  imageIsPortrait: Scalars['Boolean'];
  imageSource?: Maybe<Scalars['URL']>;
  imageSourceLarge?: Maybe<Scalars['URL']>;
  imageSourceMedium?: Maybe<Scalars['URL']>;
  keyFactsBullets?: Maybe<Array<Scalars['String']>>;
  legacyId?: Maybe<Scalars['String']>;
  loanTermList: Array<Scalars['Int']>;
  loanTermType: Scalars['String'];
  maxApr: Scalars['Int'];
  maxFico: Scalars['Int'];
  maxHardInquiries?: Maybe<Scalars['Int']>;
  /** This time unit is months. */
  maxHardInquiriesTimeSpanMonths?: Maybe<Scalars['Int']>;
  maxLoanAmount?: Maybe<Scalars['Int']>;
  maxLoanTerm?: Maybe<Scalars['Int']>;
  maxNumberBankruptcies?: Maybe<Scalars['Int']>;
  /** The time unit is months. */
  maxNumberBankruptciesTimeSpanMonths?: Maybe<Scalars['Int']>;
  minApr: Scalars['Int'];
  /** The time unit is months. */
  minCreditHistoryMonths?: Maybe<Scalars['Int']>;
  minFico: Scalars['Int'];
  minFicoAnnotation?: Maybe<Scalars['String']>;
  minFicoDisplayed: Scalars['Int'];
  minFicoTooltip?: Maybe<Scalars['String']>;
  minIncome: Scalars['Int'];
  minLoanAmount?: Maybe<Scalars['Int']>;
  /** This time unit is months. */
  phoneNumberDesktop?: Maybe<Scalars['String']>;
  phoneNumberMobile?: Maybe<Scalars['String']>;
  minLoanTermMonths?: Maybe<Scalars['Int']>;
  primaryOffer: Scalars['Boolean'];
  prosBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualificationsBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  ratingStars?: Maybe<Scalars['Float']>;
  reviewLink?: Maybe<Scalars['String']>;
  reviewTitle?: Maybe<Scalars['String']>;
  simplifyApr?: Maybe<Scalars['Boolean']>;
  timeToFund?: Maybe<Scalars['Float']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

/**
 * Query variables for the personal loan queries.
 * Note that some of these are required for the
 * query to work, since this query retrieves all
 * fields from the Offer API.
 */
export type PersonalLoanOffersParameters = {
  annualIncome: Scalars['Int'];
  loanAmount: Scalars['Int'];
  loanPurpose?: Maybe<PersonalLoanPurpose>;
  maxCreditScore: Scalars['Int'];
  minCreditScore: Scalars['Int'];
  /**
   * The zipCode variable is required if requesting the
   * isAllowedForZipCode field.
   */
  zipCode?: Maybe<Scalars['String']>;
};

/** The response from a personal loan offer query. */
export type PersonalLoanOffersResponse = {
  __typename?: 'PersonalLoanOffersResponse';
  /** The total number of offers that match your query. */
  total: Scalars['Int'];
  offers: Array<PersonalLoanOffer>;
  offset: Scalars['Int'];
};

/** Personal Loan Products */
export type PersonalLoanProduct = ProductInterface & {
  __typename?: 'PersonalLoanProduct';
  details: PersonalLoanProductDetails;
  institution: PersonalLoanInstitution;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Details about the personal loan product */
export type PersonalLoanProductDetails = {
  __typename?: 'PersonalLoanProductDetails';
  allowsPrequal: Scalars['Boolean'];
};

/** Valid options for the personal loan's purpose */
export enum PersonalLoanPurpose {
  Business = 'BUSINESS',
  ConsolidateDebt = 'CONSOLIDATE_DEBT',
  EmergencyExpense = 'EMERGENCY_EXPENSE',
  HomeImprovement = 'HOME_IMPROVEMENT',
  Moving = 'MOVING',
  Other = 'OTHER',
  RefinanceCreditCard = 'REFINANCE_CREDIT_CARD',
  Vacation = 'VACATION'
}

/** Aside from the marketplaceOffer field, other fields are retrieved from the user's profile */
export type PersonalLoansApiOffer = {
  __typename?: 'PersonalLoansApiOffer';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The apply link is generated based on the marketplace offer ID, the prequal ID, and the offer's redirect URL */
  applyLink: Scalars['URL'];
  /** Date and time indicating when the offer was created */
  createdAt: Scalars['String'];
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The value of expanded marketplace category is "null" if the offer is not an expanded marketplace offer */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** Date and time indicating when the offer expires */
  expiredAt?: Maybe<Scalars['String']>;
  /** Unique prequal identifier */
  id: Scalars['ID'];
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer: Scalars['Boolean'];
  /** Flag indicating whether the APR rate is variable */
  isVariableRate: Scalars['Boolean'];
  /** Offered loan amount */
  loanAmount: Scalars['Float'];
  /** The loan APR is calculated as the offer's APR divided by 100 */
  loanApr: Scalars['Float'];
  /** Includes principal loan balance and interest each month over the life of the loan */
  loanMonthlyPayment: Scalars['Float'];
  /** The offer's origination fee */
  loanTotalFees: Scalars['Float'];
  /** Total interest on the loan */
  loanTotalInterest: Scalars['Float'];
  /** Length of time it will take for the user to pay off the loan in months */
  loanTermMonths: Scalars['Int'];
  /** Type of residency ownership */
  residencyOwnership: PrequalResidencyOwnershipEnum;
};

/** A Personal Loans institution */
export type PersonalLoansInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'PersonalLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Personal Loans offer */
export type PersonalLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'PersonalLoansOfferV2';
  /** Apply link for the offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** Average narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  avgNarrowApr?: Maybe<Scalars['Float']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** Category used to group offers on the expanded marketplace */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** List of fees associated with the offer */
  feesBullets?: Maybe<Array<Scalars['String']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Provider's logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** Provider's logo (large) */
  imageSourceLarge?: Maybe<Scalars['URL']>;
  /** Provider's logo (medium) */
  imageSourceMedium?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer?: Maybe<Scalars['Boolean']>;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Maximum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
  maxApr?: Maybe<Scalars['Float']>;
  /** Maximum loan amount */
  maxLoanAmount?: Maybe<Scalars['Float']>;
  /** Maximum loan term */
  maxLoanTerm?: Maybe<Scalars['Int']>;
  /** Maximum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  maxNarrowApr?: Maybe<Scalars['Float']>;
  /** Minimum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
  minApr?: Maybe<Scalars['Float']>;
  /** Minimum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  minNarrowApr?: Maybe<Scalars['Float']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Estimated monthly payment */
  monthlyPayment?: Maybe<Scalars['Float']>;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /**
   * Phone number that users can call to reach out to the partner on desktop, in
   * place of the CTA on lender card. Enter value as 1231231234 to represent a
   * phone number like (123) 123 - 1234.
   */
  phoneNumberDesktop?: Maybe<Scalars['String']>;
  /**
   * Phone number that users can call to reach out to the partner on mobile, in
   * place of the CTA on lender card. Enter value as 1231231234 to represent a
   * phone number like (123) 123 - 1234.
   */
  phoneNumberMobile?: Maybe<Scalars['String']>;
  product: PersonalLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Star rating */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** Available term lengths for the entity */
  availableTermLengths?: Maybe<Scalars['String']>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

export enum PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum {
  Bankruptcy = 'BANKRUPTCY',
  CoSignLoans = 'CO_SIGN_LOANS',
  Contingent = 'CONTINGENT',
  CreditBuilderLoans = 'CREDIT_BUILDER_LOANS',
  DebtManagementPlans = 'DEBT_MANAGEMENT_PLANS',
  FriendsFamilyLoans = 'FRIENDS_FAMILY_LOANS',
  HighInterestPersonalLoans = 'HIGH_INTEREST_PERSONAL_LOANS',
  HomeEquityLoans = 'HOME_EQUITY_LOANS',
  PaycheckAdvance = 'PAYCHECK_ADVANCE',
  SecuredLoans = 'SECURED_LOANS'
}

export enum PersonalLoansPrequalLoanPurposeEnum {
  ConsolidateDebt = 'CONSOLIDATE_DEBT',
  RefinanceCreditCard = 'REFINANCE_CREDIT_CARD',
  Vacation = 'VACATION',
  Business = 'BUSINESS',
  Moving = 'MOVING',
  HomeImprovement = 'HOME_IMPROVEMENT',
  EmergencyExpense = 'EMERGENCY_EXPENSE',
  Other = 'OTHER'
}

/** Input from the personal loans prequal interface to be sent to providers */
export type PersonalLoansPrequalOfferInput = {
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
  loanAmount: Scalars['Int'];
  degreeType: PrequalDegreeTypeEnum;
  annualIncome: Scalars['Int'];
  employmentType: PrequalEmploymentTypeEnum;
  residencyOwnership: PrequalResidencyOwnershipEnum;
  creditScoreRange: TuVantageScore3Buckets;
  name: PrequalUserNameInput;
  ssn: Scalars['String'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['EmailAddress'];
  address: PrequalUserAddressInput;
  loggerMetadata?: Maybe<Scalars['JSON']>;
  citizenshipStatus?: Maybe<PrequalCitizenshipStatusEnum>;
  hasCoApplicant?: Maybe<Scalars['Boolean']>;
  coApplicantIncome?: Maybe<Scalars['Int']>;
  discoverAB?: Maybe<Scalars['Boolean']>;
};

/** Provider IDs */
export enum PersonalLoansPrequalProviderIdEnum {
  Opploans = 'OPPLOANS'
}

/** A Personal Loans product */
export type PersonalLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'PersonalLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: PersonalLoansInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type PlaidAccountInput = {
  balances?: Maybe<Array<PlaidBalanceInput>>;
  id: Scalars['String'];
  mask?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /**
   * There are a huge number of possible subtypes, and it depends on which type it
   * is so for simplicity we're just accepting any string
   * See https://plaid.com/docs/#account-subtypes
   */
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<PlaidAccountType>;
  verificationStatus?: Maybe<PlaidVerificationStatus>;
};

/**  See https://plaid.com/docs/#account-types  */
export enum PlaidAccountType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER'
}

export type PlaidBalanceInput = {
  available?: Maybe<Scalars['Int']>;
  current?: Maybe<Scalars['Int']>;
};

export enum PlaidInstitutionHealthStatus {
  Degraded = 'DEGRADED',
  Down = 'DOWN',
  Healthy = 'HEALTHY'
}

export type PlaidInstitutionInput = {
  /** The plaid id of an institution, e.g. `ins_4` */
  institutionId: Scalars['String'];
  name: Scalars['String'];
};

/**  Documentation taken from Plaid docs: https://plaid.com/docs/#onsuccess-callback  */
export enum PlaidVerificationStatus {
  /**  an Item was successfully manually verified  */
  ManuallyVerified = 'MANUALLY_VERIFIED',
  /**  an Item is pending automated microdeposit verfication  */
  PendingAutomaticVerification = 'PENDING_AUTOMATIC_VERIFICATION',
  /**  an Item is pending manual microdeposit verification  */
  PendingManualVerification = 'PENDING_MANUAL_VERIFICATION'
}

/** Type modeling the data for posts within the post post type from WordPress. */
export type Post = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'Post';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Post object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The input for fetching a single forked post. */
export type PostForkItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier: Scalars['Int'];
  /** The security nonce for viewing the fork. */
  forkNonce?: Maybe<Scalars['String']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: Maybe<Scalars['Boolean']>;
  /** The slug for the entity this fork was created from or the WordPress ID. */
  identifier: Scalars['ID'];
  /** The security nonce for viewing the entity. */
  wpnonce?: Maybe<Scalars['String']>;
};

/** The Post interface for modeling other custom post types. */
export type PostInterface = {
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** The Post interface for modeling other custom post types. */
export type PostInterfaceDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** The Post interface for modeling other custom post types. */
export type PostInterfaceModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

/** The input for retrieving a single resource. */
export type PostItemInput = {
  /** The slug for the post or the WordPress ID. */
  identifier: Scalars['ID'];
  /** Whether or not to retrieve the preview of the post. */
  preview?: Maybe<Scalars['Boolean']>;
  /** The security nonce for viewing a preview. */
  wpnonce?: Maybe<Scalars['ID']>;
};

export enum PostType {
  Article = 'ARTICLE',
  Post = 'POST'
}

/** WordPress post types supported in GraphQL. */
export enum PostTypeEnum {
  Article = 'ARTICLE',
  Banner = 'BANNER',
  Block = 'BLOCK',
  BlockGroup = 'BLOCK_GROUP',
  ContentPack = 'CONTENT_PACK',
  EngPost = 'ENG_POST',
  HouseAd = 'HOUSE_AD',
  Hub = 'HUB',
  Landing = 'LANDING',
  Lender = 'LENDER',
  Page = 'PAGE',
  Post = 'POST',
  Review = 'REVIEW',
  Roundup = 'ROUNDUP',
  UrlRecord = 'URL_RECORD'
}

/** The interface for post types that support authors. */
export type PostWithAuthorsInterface = {
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
};

export type PostWithContentClassificationInterface = {
  /**
   * The topic that should be used as the 'Attribution Topic' for this piece of
   * content. This value is used for attributing metrics related to this piece of
   * content in analytics reports.
   */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The content clusters for this piece of content. Content clusters are meant to be arbitrary groupings of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};

/** The interface for post types that support the content field. */
export type PostWithContentInterface = {
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
};

/** The interface for post types that support excerpts. */
export type PostWithExcerptInterface = {
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
};


/** The interface for post types that support excerpts. */
export type PostWithExcerptInterfaceExcerptArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

export type PostWithFaQsInterface = {
  faqs?: Maybe<Array<ContentFaq>>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
};

/** The interface for post types that support featured images. */
export type PostWithFeaturedImageInterface = {
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
};

/** The interface for post types that support gms page taxonomy. */
export type PostWithPageTaxonomyInterface = {
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
};

export type PostWithSeoInterface = {
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
};

/** The interface for post types that support the title field. */
export type PostWithTitleInterface = {
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
};


/** The interface for post types that support the title field. */
export type PostWithTitleInterfaceTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

export enum PrequalCitizenshipStatusEnum {
  Citizen = 'CITIZEN',
  PermanentResident = 'PERMANENT_RESIDENT',
  Other = 'OTHER'
}

export enum PrequalDegreeTypeEnum {
  HighSchoolDiploma = 'HIGH_SCHOOL_DIPLOMA',
  Associate = 'ASSOCIATE',
  Bachelors = 'BACHELORS',
  Masters = 'MASTERS',
  Pharmd = 'PHARMD',
  Mba = 'MBA',
  Phd = 'PHD',
  Jd = 'JD',
  Dds = 'DDS',
  Md = 'MD'
}

export enum PrequalEmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Military = 'MILITARY',
  Retired = 'RETIRED',
  Unemployed = 'UNEMPLOYED',
  Other = 'OTHER'
}

export type PrequalJob = {
  __typename?: 'PrequalJob';
  jobId: Scalars['ID'];
  service: PrequalServiceIdEnum;
  path: Scalars['String'];
};

export type PrequalJobInput = {
  jobId: Scalars['ID'];
  service: PrequalServiceIdEnum;
  path: Scalars['String'];
};

export type PrequalJobStatusResponse = {
  __typename?: 'PrequalJobStatusResponse';
  status: PrequalOfferStatus;
  totalResults: Scalars['Int'];
};

/** Generic Prequal Offer interface */
export type PrequalOffer = {
  applyLink: Scalars['String'];
  institutionName: Scalars['String'];
  institutionLogo: Scalars['String'];
  nwRating?: Maybe<Scalars['Float']>;
  providerId?: Maybe<Scalars['ID']>;
};

/** Generic Prequal Offer Status object */
export type PrequalOfferStatus = {
  __typename?: 'PrequalOfferStatus';
  /** Overall status of fetching all offers */
  overall: PrequalOverallStatusTypesEnum;
};

/** Prequal offers overall status types */
export enum PrequalOverallStatusTypesEnum {
  /** Results are pending */
  Pending = 'PENDING',
  /** All results are resolved (regardless of success or error) */
  Resolved = 'RESOLVED',
  /**
   * An error occurred at the overall request level
   * If an error occurred for an individual provider, that will be reflected in status.providers
   */
  Error = 'ERROR'
}

export enum PrequalResidencyOwnershipEnum {
  Rent = 'RENT',
  OwnFully = 'OWN_FULLY',
  OwnMortgage = 'OWN_MORTGAGE'
}

export enum PrequalServiceIdEnum {
  PrequalService = 'PREQUAL_SERVICE',
  PersonalLoansService = 'PERSONAL_LOANS_SERVICE',
  StudentLoansService = 'STUDENT_LOANS_SERVICE',
  Homeownership = 'HOMEOWNERSHIP',
  CcPrequalService = 'CC_PREQUAL_SERVICE'
}

export type PrequalUserAddressInput = {
  streetAddress: Scalars['String'];
  streetAddress2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type PrequalUserNameInput = {
  firstName: Scalars['String'];
  middleInitial?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
};

/** Types of Product Cards for a Roundup */
export enum ProductCardComponentEnum {
  Institution = 'INSTITUTION',
  Keto = 'KETO',
  MarketplaceProductCard = 'MARKETPLACE_PRODUCT_CARD',
  Slim = 'SLIM'
}

/** ProductInterface contains the common base fields for all products. */
export type ProductInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type Provider = {
  __typename?: 'Provider';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The number of prequal offers provided by this provider is a calculated field */
  numOffers: Scalars['Int'];
};

/**  See https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event  */
export enum ProxyEventType {
  AuthenticationSuccess = 'AUTHENTICATION_SUCCESS',
  SourceEvent = 'SOURCE_EVENT',
  ResetLogin = 'RESET_LOGIN',
  FlowOpened = 'FLOW_OPENED',
  FlowClosed = 'FLOW_CLOSED',
  InstitutionSearched = 'INSTITUTION_SEARCHED',
  Exit = 'EXIT'
}

/** The return type of publish a single Yak message */
export type PublishYakMessageResult = {
  __typename?: 'PublishYakMessageResult';
  /** Whether the message was published successfully */
  success: Scalars['Boolean'];
};

/** Empty field. Not to be used. */
export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  /** Gets the current user's security questions */
  securityQuestions?: Maybe<Array<Scalars['String']>>;
  abExperiments?: Maybe<Array<Maybe<Experiment>>>;
  /**
   * The breakdown of cash flow this month from the first day to the current day in dollars.
   * Optionally, currentDate variable can be passed to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   */
  cashFlowBreakdown?: Maybe<CashFlowBreakdown>;
  cashFlowHistoryBreakdown: CashFlowHistoryBreakdown;
  /** A user's top takeaways with regards to their cash flow based on the current date */
  cashFlowTopTakeaways?: Maybe<Array<CashFlowTakeaway>>;
  /** Returns a list of content packs containing relevant content */
  memberHomeContentPacks?: Maybe<ContentPackResponse>;
  creditFactors?: Maybe<CreditFactors>;
  accountLinkingOpportunities?: Maybe<AccountLinkingOpportunitiesResponse>;
  debtSummary?: Maybe<DebtSummary>;
  /** Returns the user's current opt in state; one of FDPOptInState */
  fdpOptInState?: Maybe<FdpOptInStateResponse>;
  financialAccounts?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsByPortal?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsIAVDetails?: Maybe<FinancialAccountsIavDetailsResponse>;
  financialAccountTypeSums?: Maybe<FinancialAccountTypeSumsResponse>;
  /** Fetches a user's financial account by financial account ID. */
  financialAccountById?: Maybe<FinancialAccount>;
  financialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Fetches all portals that are not in the INIT state. This is useful for clients because
   * portals in the INIT state have not been fully linked by the user and should not be shown in the UI
   */
  linkedFinancialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Create a portal if one does not exist for a particular institution
   * @deprecated Moved to a mutation
   */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /** Retrieves a financial portal by the provided marketplace institution ID */
  financialPortalByInstitutionId?: Maybe<FinancialPortal>;
  /** Fetches a user's financial portal by financial portal ID. */
  financialPortalById?: Maybe<FinancialPortal>;
  /** Retrieves institution status health data for the financial portal ID and identity id specified. */
  institutionHealthDetailsByPortalId?: Maybe<GetInstitutionHealthDetailsResponse>;
  /**
   * Returns a user's spending and earning for a given month range.
   * Datasource endpoint: /api/v1/financial_accounts/transactions/cash_flow
   */
  financialTransactionsSpendingAndEarningForMonthRange?: Maybe<FinancialTransactionsSpendingAndEarningForMonthRangeResponse>;
  /**
   * Returns a user's spending totals by category for a target month.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/by_categories
   */
  financialTransactionsSpendingByCategoryForMonth?: Maybe<FinancialTransactionsSpendingByCategoryForMonth>;
  /**
   * Returns a user's spending totals by date for a target month and the month prior to that month.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/daily
   */
  financialTransactionsSpendingByDateForMonth?: Maybe<FinancialTransactionsSpendingByDayOfTheMonthForMonth>;
  /**
   * Returns a user's mean average spending by day of the month for the target month range.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/daily/average
   */
  financialTransactionsAverageSpendingByDayOfTheMonth?: Maybe<FinancialTransactionsAverageSpendingByDayOfTheMonth>;
  /**
   * Returns a user's spending by month in a target month range.
   * Datasource endpoint: financial_accounts/transactions/spending/monthly
   */
  financialTransactionsSpendingByMonth?: Maybe<FinancialTransactionsSpendingByMonth>;
  /**
   * Returns a user's projected earning for the target month.
   *  Datasource endpoint: financial_accounts/transactions/cash_flow/projection
   */
  financialTransactionsProjectionForMonth?: Maybe<FinancialTransactionsProjectionForMonth>;
  /**
   * Returns a user's top merchants by spending for the target month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopMerchantsBySpending?: Maybe<FinancialTransactionsTopMerchantsBySpending>;
  /**
   * Returns a user's top categories by spending for the target month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopCategoriesBySpending?: Maybe<FinancialTransactionsTopCategoriesBySpending>;
  /**  A generic query to fetch the transactions pre-filtered for what we expect  */
  financialTransactions?: Maybe<GetTransactionsResponse>;
  /**  Returns a transaction for a user by transaction ID.  */
  financialTransactionById?: Maybe<FinancialTransaction>;
  /** Returns the activation status of the CardLinkedOffers feature */
  cardLinkedOffersActivationStatus?: Maybe<CardLinkedOffersActivationStatusResponse>;
  /** Returns the activation status of the CashFLow feature */
  cashFlowActivationStatus?: Maybe<CashFlowActivationStatusResponse>;
  /** Returns the activation status of the CreditScore feature */
  creditScoreActivationStatus?: Maybe<CreditScoreActivationStatusResponse>;
  /** Returns the activation status of the NetWorth feature */
  netWorthActivationStatus?: Maybe<NetWorthActivationStatusResponse>;
  /** Query to get the feature discovery for web membership experience */
  webFeatureDiscovery?: Maybe<FeatureDiscoveryResponse>;
  /**
   * The appName argument is not being used. The "X-Caller-Client-ID" request header is being used
   * to fetch the feature flags for the appropriate platform.
   * Update: I made the 'appName' input arg not required so that we can safely deprecate it's usage
   * in the native app startup queries
   */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  featureFlag?: Maybe<FeatureFlag>;
  /** The `statementIndexedFeed` query types the JSON response from feed. */
  statementIndexedFeed: Array<StatementIndexedFeedItem>;
  /** Returns a flat list of all feed cards that are not considered modern user insights */
  nonInsightFeedCards?: Maybe<Array<FeedCard>>;
  greenhouseDepartments?: Maybe<Array<GreenhouseDepartment>>;
  /**
   * Accepts an id, name, or kebabName field to filter for a GreenhouseDepartment.
   * If multiple fields are present, the priority is id -> name -> kebabName.
   */
  greenhouseDepartment?: Maybe<GreenhouseDepartment>;
  greenhouseJob?: Maybe<GreenhouseJob>;
  /** Fetch the user's home ownership profile */
  homeOwnershipDetails?: Maybe<HomeOwnershipDetails>;
  /**
   * The `authCookies` query returns the cookies returned when querying auth info. This could include cookies
   * such as csrf_token, access_token, jwt_access_token, refresh_token
   */
  authCookies: Array<Cookie>;
  rawIdentity?: Maybe<RawIdentity>;
  rawIdentityProfile?: Maybe<RawIdentityProfile>;
  /**
   * The `subscriptionIdentityProfile` query returns subscription_profile_v2, the query/type is not versioned
   * because of recommended GraphQL best practices
   */
  subscriptionIdentityProfile?: Maybe<SubscriptionIdentityProfile>;
  globalIdentityProfile?: Maybe<GlobalIdentityProfile>;
  mobileAppIdentityProfile?: Maybe<MobileAppIdentityProfile>;
  financialIdentityProfile?: Maybe<FinancialIdentityProfile>;
  tuAuthenticationStatusProfile?: Maybe<CreditProfileAuthStatusProfile>;
  tuCreditReportIdentityProfile?: Maybe<TuCreditReportIdentityProfile>;
  hasLinkedFinancialAccounts: Scalars['Boolean'];
  membershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  /** Return a list of UserInsights to be surfaced in a particular UX context (as expressed via the filter param) */
  userInsights: UserInsightsResponse;
  /** Query to get the info banner details from the feature flag service */
  sitewideInfoBanner: SitewideInfoBannerResponse;
  /**
   * Search for account aggregation institutions by keyword, with the use case of an autocomplete input for users
   * linking accounts in mind
   */
  institutionsForAccountLinkingByKeyword?: Maybe<AccountAggregationInstitutionsResponse>;
  /** Get a list of the top institutions used for account linking */
  topInstitutionsForAccountLinking?: Maybe<TopInstitutionsForLinkingResponse>;
  accountAggregationInstitutionById?: Maybe<AccountAggregationInstitutionByIdResponse>;
  /** Search for canonical institution by keyword, with the use case of an autocomplete input in mind */
  canonicalInstitutionsByKeyword?: Maybe<CanonicalInstitutionsResponse>;
  /**
   * Get a single credit card offer by its legacy ID
   * Returns null if it cannot be found
   */
  creditCardOfferByLegacyId?: Maybe<CreditCardOffer>;
  creditCardOffersByLegacyIds?: Maybe<CreditCardOffersResponse>;
  /**
   * Search for credit card offers by keyword,
   * with the use case of an autocomplete input in mind
   */
  creditCardOffersByKeyword?: Maybe<CreditCardOffersResponse>;
  creditCardOffersByNamedQuery?: Maybe<CreditCardOffersResponse>;
  recommendedRewardsCreditCards?: Maybe<RecommendedRewardsCreditCardsResponse>;
  /** Search for all active Personal Loan Offers. */
  personalLoanOffers?: Maybe<PersonalLoanOffersResponse>;
  /** Request a single personal loan offer by providing the offer's id. */
  personalLoanOffer?: Maybe<PersonalLoanOffer>;
  /** Returns recommended credit card offer bundles for the user. */
  recommendedCreditCardOfferBundles: CreditCardOfferBundlesResponse;
  recommendedInvestmentAccountOffers: InvestmentAccountOffersResponse;
  recommendedSavingsAccountOffers: SavingsAccountOffersResponse;
  recommendedCreditCardOffers: CreditCardOffersNamedQueriesResponse;
  savingsAccountOfferBySlug?: Maybe<SavingsAccountOffer>;
  savingsAccountOffersByNamedQuery: SavingsAccountOffersByNamedQueryResponse;
  marketplaceEntityV2?: Maybe<MarketplaceEntityInterface>;
  marketplaceEntitiesV2: Array<Maybe<MarketplaceEntityInterface>>;
  /**
   * Search for Marketplace entities by keyword
   * using Marketplace's Autocomplete endpoint.
   * https://docs.nerdwallet.io/marketplace/branches/master/api.full_text.html
   */
  marketplaceAutocompleteSearch?: Maybe<Array<MarketplaceEntityInterface>>;
  /**
   * Search for Marketplace entities
   * using Marketplace's product search endpoint.
   */
  marketplaceSearch: MarketplaceSearchResponse;
  /**
   * Returns the following for the target month range:
   *   - Average credit card spending
   *   - Top category for credit card spending
   *   - Recommended credit cards from recommendation-service for MCFY
   * Datasource endpoints:
   *   - /financial_accounts/transactions/spending/monthly
   *   - /financial_accounts/transactions/cash_flow/top
   *   - /recommendation-service/offers/products?category={?}
   */
  maximizeSummary?: Maybe<MaximizeSummary>;
  /**
   * Returns the money management eligibility for a financial portal's accounts. AS part of
   * determining the eligibility, the money management service goes through the process of attempting
   * to IAV verify the accounts.
   */
  moneyTransferAccountEligibility?: Maybe<MoneyTransferAccountEligibilityResponse>;
  /** Get all linked accounts on-boarded for money transfer */
  moneyTransferAccounts?: Maybe<MoneyTransferAccountsResponse>;
  /** Return all the transfers for this user */
  moneyTransferTransfers?: Maybe<MoneyTransferTransfersResponse>;
  /** Return the transfer limits for the user */
  moneyTransferTransferLimits?: Maybe<MoneyTransferTransferLimitsResponse>;
  /**
   * Returns the KBA questions used by an onboarding money transfer user
   * to identify themselves if we weren't able to from SSN alone:
   * // https://nerdwallet.atlassian.net/wiki/spaces/PRODUCT/pages/620134583/KBA+in+Money+Management
   */
  moneyTransferKbaQuestions?: Maybe<MoneyTransferKbaQuestionsResponse>;
  /** Returns the details of a money transfer on-boarded user. */
  moneyTransferUser?: Maybe<MoneyTransferUser>;
  /** Retrieve Home Lead Match offer based on offerId or legacy productId */
  mortgageSavedLeadMatch?: Maybe<MortgagesOfferV2>;
  /** Find matching offers based on Mortgage OSX inputs */
  mortgageLenderMatch: Array<MortgagesOfferV2>;
  /** Checks if the user is in a state where NerdWallet is a licensed mortgage broker */
  isNerdWalletMortgageLicensed: MortgageLicensed;
  /**
   * Net worth breakdown balances, with account grouping logic based upon "nw_type"
   * @deprecated the new UI should use netWorthBalancesByFinancialAccountCategorization
   */
  netWorthBalances?: Maybe<NetWorthBalances>;
  /** Net worth breakdown balances, with account grouping logic based upon FDP account type/subtype */
  netWorthBalancesByFinancialDataCategorization?: Maybe<NetWorthBalances>;
  /**
   * Returns the user's net worth contributions summary.
   * Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthContributionSummaries?: Maybe<NetWorthContributionSummaries>;
  /**
   * Returns the user's net worth recommendations.
   * Datasource endpoint: wealth-recommender/recommendations/v1/identities/me/recommendations
   */
  netWorthRecommendations?: Maybe<NetWorthRecommendations>;
  /**
   * Returns the user's net worth accounts. The fields provided by Wealth Recommender are
   * annotations on the accounts supplied by Identity/FDP.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccounts?: Maybe<NetWorthAccountsResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided financial account ID.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccountByFinancialAccountId?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided net worth account ID.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts/<net_worth_account_id>
   */
  netWorthAccountById?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth real assets, which depicts their non-monetary assets
   * Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets
   */
  netWorthRealAssets?: Maybe<NetWorthRealAssetsResponse>;
  /**
   * Returns the user's net worth real asset, which depicts their non-monetary assets
   * Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets/<net_worth_real_asset_id>
   */
  netWorthRealAsset?: Maybe<NetWorthRealAssetResponse>;
  /**
   * Returns the provider home value pertaining to the specified address. Currently only
   * returns the Redfin home value, but could potentially be extended to include Zillow.
   * Datasource endpoint: wealth-recommender/home/v1/home_value
   * @deprecated the new UI should be using netWorthHomeValueResultWithPossibilitiesByAddress
   */
  netWorthHomeValueResultByAddress?: Maybe<NetWorthHomeValueResultResponse>;
  /**
   * Returns the provider home value pertaining to the specified property_id. Currently only
   * returns the Redfin home value, but could potentially be extended to include Zillow.
   * Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultByPropertyId?: Maybe<NetWorthHomeValueResultByPropertyIdResponse>;
  /**
   * Returns the provider home value result pertaining to the specified address, or a list of
   * possible home value results. Currently only returns Redfin home values, but could potentially
   * be extended to include Zillow. This query effectively replaces
   * netWorthHomeValueResultByAddress.
   * Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultWithPossibilitiesByAddress?: Maybe<NetWorthHomeValueResultWithPossibilitiesResponse>;
  /**
   * Returns the user's net worth contributions summary.
   * Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthHistory?: Maybe<NetWorthHistoryResponse>;
  /**
   * Returns boolean that denotes whether or not to show the snapshot notification.
   * Show the notification to users who linked accounts or assets before the respective cutoff dates.
   */
  netWorthHistorySnapshotNotification?: Maybe<NetWorthHistorySnapshotNotificationResponse>;
  /** Get status of prequal jobs by specifiying a job ID, the prequal serivce, and the path */
  prequalJobStatus: PrequalJobStatusResponse;
  /** Get auto insurance prequal offers */
  autoInsurancePrequalOffers?: Maybe<AutoInsurancePrequalOffersResponse>;
  creditCardPrequalOffers: CreditCardPrequalOffersResponse;
  /** Return saved personal loans prequal offer data for the given user */
  savedPersonalLoansPrequalOffers?: Maybe<SavedPersonalLoansPrequalOffers>;
  recommendedGuidance: Array<RecommendationGuidance>;
  /**
   * Search for offers from online retailers that offer cashback on purchases
   * Keywords can be any number of search terms; passed directly to partner API
   */
  offlineCardLinkedOffers?: Maybe<Array<OfflineCardLinkedOffer>>;
  onlineCardLinkedOffers?: Maybe<OnlineCardLinkedOfferSearchResult>;
  rewardsFeaturedOffers?: Maybe<Array<RewardsFeaturedOffers>>;
  rewardsFilteredFeaturedOffers?: Maybe<RewardsFilteredFeaturedOffers>;
  rewardsOffersCategories?: Maybe<Array<RewardsOffersCategory>>;
  rewardsTransactions?: Maybe<Array<RewardsTransaction>>;
  rewardsUser?: Maybe<RewardsUser>;
  rewardsUserSummary?: Maybe<RewardsUserSummary>;
  rewardsUserCards?: Maybe<Array<RewardsUserCard>>;
  rewardsUserPayments?: Maybe<Array<RewardsUserPayment>>;
  rewardsGroupCategories?: Maybe<Array<RewardsCategoryGroup>>;
  rewardAccounts?: Maybe<Array<RewardAccount>>;
  userReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /**
   * The total amount of a user's cash back balance in dollars.
   * Example: Return value is `6000.56`
   */
  rewardsCashBackBalance?: Maybe<Scalars['Float']>;
  /**
   * The total amount of cash back last month from the first day to the same current day last month in dollars.
   * Example: Return value is `6000.56`
   */
  rewardsCashBackLast30Days?: Maybe<Scalars['Float']>;
  /** Retrieve content related to the given keywords from WP via the search service */
  rewardsContent: SearchServiceContentSearchResults;
  getContent: SearchServiceContentSearchResults;
  /**
   * The total amount of money spent this month from the first day to the current day in dollars.
   * Optionally, currentDate variable can be pass to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   * Example: Return value is `6000.56`
   */
  totalAmountSpentCurrentMonth?: Maybe<Scalars['Float']>;
  /**
   * The total amount of money spent last month from the first day to the same current day last month in dollars.
   * Optionally, currentDate variable can be pass to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   * Example: Return value is `6000.56`
   */
  totalAmountSpentPreviousMonthToDate?: Maybe<Scalars['Float']>;
  /**
   * Total sum of a user checking, investing, savings, retirement account balances on the passed-in date.
   * Example: Return value is `86000.56`
   */
  csirBalanceOnDate?: Maybe<Scalars['Float']>;
  /** Query for the data to render a page with structured content client */
  structuredContentPage: StructuredContentPageInterface;
  getUserOpsFDPLinkingErrorEvents: Array<UserOpsPaoEventDetails>;
  /** Query to fetch a single Article object. */
  article?: Maybe<Article>;
  /** Query to fetch a single Article object. */
  articleFork?: Maybe<Article>;
  /** Query to fetch multiple Article objects. */
  articles?: Maybe<ArticleConnectionResponse>;
  /** Query to fetch a single Author object. */
  author?: Maybe<Author>;
  /** Query to fetch a single Banner object. */
  banner?: Maybe<Banner>;
  /** Query to fetch multiple Banner objects. */
  banners?: Maybe<BannerConnectionResponse>;
  /** Query to fetch a single Block object. */
  block?: Maybe<Block>;
  /** Query to fetch a single BlockGroup object. */
  blockGroup?: Maybe<BlockGroup>;
  /** Query to fetch multiple BlockGroup objects. */
  blockGroups?: Maybe<BlockGroupConnectionResponse>;
  /** Query to fetch multiple Block objects. */
  blocks?: Maybe<BlockConnectionResponse>;
  /** Query to fetch a single Category object. */
  category?: Maybe<Category>;
  /** Query to fetch a single ContentPack object. */
  contentPack?: Maybe<ContentPack>;
  /** Query to fetch multiple ContentPack objects. */
  contentPacks?: Maybe<ContentPackConnectionResponse>;
  /** Query to fetch a collection of content search results. */
  contentSearch?: Maybe<ContentSearchResultConnectionResponse>;
  /** Query to fetch a single EngineeringPost object. */
  engineeringPost?: Maybe<EngineeringPost>;
  /** Query to fetch multiple EngineeringPost objects. */
  engineeringPosts?: Maybe<EngineeringPostConnectionResponse>;
  /** Query to fetch a single HouseAd object. */
  houseAd?: Maybe<HouseAd>;
  /** Query to fetch multiple HouseAd objects. */
  houseAds?: Maybe<HouseAdConnectionResponse>;
  /** Query to fetch a single Hub object. */
  hub?: Maybe<Hub>;
  /** Query to fetch a single Hub object. */
  hubFork?: Maybe<Hub>;
  /** Query to fetch multiple Hub objects. */
  hubs?: Maybe<HubConnectionResponse>;
  /** Query to fetch a single LandingPage object. */
  landingPage?: Maybe<LandingPage>;
  /** Query to fetch a single LandingPage object. */
  landingPageFork?: Maybe<LandingPage>;
  /** Query to fetch multiple LandingPage objects. */
  landingPages?: Maybe<LandingPageConnectionResponse>;
  /** Query to fetch a single LegacyLender object. */
  legacyLender?: Maybe<LegacyLender>;
  /** Query to fetch multiple LegacyLender objects. */
  legacyLenders?: Maybe<LegacyLenderConnectionResponse>;
  /** Query to fetch a single MediaItem object. */
  mediaItem?: Maybe<MediaItem>;
  /** Query to fetch multiple MediaItem objects. */
  mediaItems?: Maybe<MediaItemConnectionResponse>;
  /** Query to fetch a single Page object. */
  page?: Maybe<Page>;
  /** Query to fetch a single Post object. */
  post?: Maybe<Post>;
  /** Query to fetch a single Review object. */
  review?: Maybe<Review>;
  /** Query to fetch a single Review object. */
  reviewFork?: Maybe<Review>;
  /** Query to fetch multiple Review objects. */
  reviews?: Maybe<ReviewConnectionResponse>;
  /** Query to fetch a single Roundup object. */
  roundup?: Maybe<Roundup>;
  /** Query to fetch a single Roundup object. */
  roundupFork?: Maybe<Roundup>;
  /** Query to fetch multiple Roundup objects. */
  roundups?: Maybe<RoundupConnectionResponse>;
  /** Query to fetch a single UrlRecord object. */
  urlRecord?: Maybe<UrlRecord>;
  /** Query to fetch multiple UrlRecord objects. */
  urlRecords?: Maybe<UrlRecordConnectionResponse>;
  /**
   * Query to fetch a collection of related articles.
   * This query is meant to be a temporary implementation to support a use-case
   * in article-client. The intention is to replace it with a more robust solution
   * and remove it entirely soon after.
   */
  relatedArticles?: Maybe<Array<Article>>;
  transactionData?: Maybe<TransactionFetchResponse>;
  /** Retrieve array of HealthabilityReports from the trunk branch of all repos */
  healthability?: Maybe<Array<Maybe<HealthabilityReport>>>;
};


/** Empty field. Not to be used. */
export type QueryAbExperimentsArgs = {
  uuid?: Maybe<Scalars['String']>;
  testNames: Array<Maybe<Scalars['String']>>;
};


/** Empty field. Not to be used. */
export type QueryCashFlowBreakdownArgs = {
  currentDate: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowHistoryBreakdownArgs = {
  currentDate: Scalars['Date'];
  numPreviousMonthsToInclude: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowTopTakeawaysArgs = {
  currentDate: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryMemberHomeContentPacksArgs = {
  options?: Maybe<ContentPacksOptionsInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsByPortalArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsIavDetailsArgs = {
  financialAccountIds: Array<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountTypeSumsArgs = {
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountByIdArgs = {
  financialAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalsArgs = {
  pagination?: Maybe<OffsetPaginationInput>;
  filters?: Maybe<FinancialPortalFilterInput>;
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryLinkedFinancialPortalsArgs = {
  pagination?: Maybe<OffsetPaginationInput>;
  filters?: Maybe<FinancialPortalFilterInput>;
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalByInstitutionIdArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalByIdArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryInstitutionHealthDetailsByPortalIdArgs = {
  financialPortalId: Scalars['ID'];
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingAndEarningForMonthRangeArgs = {
  dateInStartMonth: Scalars['Date'];
  dateInEndMonth: Scalars['Date'];
  filter?: Maybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByCategoryForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByDateForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsAverageSpendingByDayOfTheMonthArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByMonthArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
  pagination?: Maybe<AdvancedOffsetPaginationInput>;
  filter?: Maybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsProjectionForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopMerchantsBySpendingArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
  pagination?: Maybe<AdvancedOffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopCategoriesBySpendingArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsArgs = {
  pagination?: Maybe<AdvancedOffsetPaginationInput>;
  filter?: Maybe<FinancialTransactionsFilterInput>;
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionByIdArgs = {
  transactionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFeatureFlagsArgs = {
  appName?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryFeatureFlagArgs = {
  featureFlagName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryStatementIndexedFeedArgs = {
  onlyTemplates: Array<Scalars['String']>;
  clientPlatform: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryNonInsightFeedCardsArgs = {
  onlyTemplates: Array<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryGreenhouseDepartmentArgs = {
  kebabName?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryGreenhouseJobArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryRawIdentityProfileArgs = {
  profileType: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryUserInsightsArgs = {
  filter?: Maybe<UserInsightsFilterInput>;
  effectiveDate?: Maybe<Scalars['String']>;
  rankingModelName?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryInstitutionsForAccountLinkingByKeywordArgs = {
  keyword: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  namedQuery?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryTopInstitutionsForAccountLinkingArgs = {
  productType?: Maybe<AccountAggregationProductType>;
  yodleeOnly?: Maybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type QueryAccountAggregationInstitutionByIdArgs = {
  accountAggregationInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryCanonicalInstitutionsByKeywordArgs = {
  isFuzzy?: Maybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  namedQuery?: Maybe<Scalars['String']>;
  queryFields?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<Array<Scalars['String']>>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOfferByLegacyIdArgs = {
  input?: Maybe<CreditCardOffersParameters>;
  id: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByLegacyIdsArgs = {
  input?: Maybe<CreditCardOffersParameters>;
  ids: Array<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByKeywordArgs = {
  namedQuery?: Maybe<Scalars['String']>;
  keyword: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByNamedQueryArgs = {
  input?: Maybe<CreditCardOffersParameters>;
  namedQuery: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryRecommendedRewardsCreditCardsArgs = {
  input?: Maybe<RecommendationTypeInput>;
};


/** Empty field. Not to be used. */
export type QueryPersonalLoanOffersArgs = {
  namedQuery?: Maybe<Scalars['String']>;
  input?: Maybe<PersonalLoanOffersParameters>;
};


/** Empty field. Not to be used. */
export type QueryPersonalLoanOfferArgs = {
  input?: Maybe<PersonalLoanOffersParameters>;
  namedQuery?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryRecommendedCreditCardOffersArgs = {
  creditTier?: Maybe<TuVantageScore3Buckets>;
  creditUtilization?: Maybe<Scalars['Float']>;
  topSpendingCategory?: Maybe<TopCategory>;
  isBestOf?: Maybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type QuerySavingsAccountOfferBySlugArgs = {
  slug: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QuerySavingsAccountOffersByNamedQueryArgs = {
  namedQuery: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntityV2Args = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntitiesV2Args = {
  ids?: Maybe<Array<Scalars['ID']>>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceAutocompleteSearchArgs = {
  isFuzzy?: Maybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  namedQuery?: Maybe<Scalars['String']>;
  productType: Scalars['String'];
  queryFields?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceSearchArgs = {
  entityType?: Maybe<Scalars['String']>;
  productType: Scalars['String'];
  namedQuery?: Maybe<Scalars['String']>;
  query?: Maybe<Array<MarketplaceQueryInput>>;
  sort?: Maybe<Array<MarketplaceSortInput>>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMaximizeSummaryArgs = {
  creditScoreOverride?: Maybe<Scalars['Int']>;
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryMoneyTransferAccountEligibilityArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryMoneyTransferAccountsArgs = {
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryMoneyTransferTransfersArgs = {
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryMoneyTransferUserArgs = {
  identityId?: Maybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchArgs = {
  input: MortgageSavedLeadMatchInput;
};


/** Empty field. Not to be used. */
export type QueryMortgageLenderMatchArgs = {
  input: MortgageLenderMatchInput;
  namedQuery?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryIsNerdWalletMortgageLicensedArgs = {
  address: MortgageUserAddressInput;
};


/** Empty field. Not to be used. */
export type QueryNetWorthRecommendationsArgs = {
  pagination?: Maybe<AdvancedOffsetPaginationInput>;
  filter?: Maybe<NetWorthRecommendationsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthAccountByFinancialAccountIdArgs = {
  financialAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthAccountByIdArgs = {
  netWorthAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: Maybe<NetWorthHomeValueResultSourceEnum>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByPropertyIdArgs = {
  propertyId: Scalars['ID'];
  source: NetWorthHomeValueResultSourceEnum;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultWithPossibilitiesByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: Maybe<NetWorthHomeValueResultSourceEnum>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHistoryArgs = {
  netWorthFilter: NetWorthHistoryFiltersEnum;
  effectiveDate: Scalars['DateTimeWithTimeOffset'];
};


/** Empty field. Not to be used. */
export type QueryPrequalJobStatusArgs = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: Maybe<AutoInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardPrequalOffersArgs = {
  userInput: CreditCardPrequalInput;
};


/** Empty field. Not to be used. */
export type QueryOfflineCardLinkedOffersArgs = {
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  resultsPerPage?: Maybe<Scalars['Int']>;
  queryLocation?: Maybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryOnlineCardLinkedOffersArgs = {
  query?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  resultsPerPage?: Maybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryRewardsTransactionsArgs = {
  numResults?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryRewardsContentArgs = {
  cardNames: Array<Scalars['String']>;
  cardPrograms: Array<Scalars['String']>;
  allowPosts?: Maybe<Scalars['Boolean']>;
  sortDir?: Maybe<ContentSortDirection>;
  numResults?: Maybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryGetContentArgs = {
  contentSearchFilter?: Maybe<ContentSearchInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryTotalAmountSpentCurrentMonthArgs = {
  currentDate?: Maybe<Scalars['Date']>;
};


/** Empty field. Not to be used. */
export type QueryTotalAmountSpentPreviousMonthToDateArgs = {
  currentDate?: Maybe<Scalars['Date']>;
};


/** Empty field. Not to be used. */
export type QueryCsirBalanceOnDateArgs = {
  date: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryStructuredContentPageArgs = {
  uri: Scalars['String'];
  urlParams?: Maybe<Array<UrlParamsInput>>;
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsFdpLinkingErrorEventsArgs = {
  identityId: Scalars['ID'];
  portalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryArticleArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryArticleForkArgs = {
  input?: Maybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryArticlesArgs = {
  filter?: Maybe<ArticleFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryAuthorArgs = {
  input?: Maybe<AuthorItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBannerArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBannersArgs = {
  filter?: Maybe<BannerFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockGroupArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockGroupsArgs = {
  filter?: Maybe<BlockGroupFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBlocksArgs = {
  filter?: Maybe<BlockFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryCategoryArgs = {
  input?: Maybe<TermItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentPackArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentPacksArgs = {
  filter?: Maybe<ContentPackFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryContentSearchArgs = {
  filter?: Maybe<ContentSearchFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryEngineeringPostArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryEngineeringPostsArgs = {
  filter?: Maybe<EngineeringPostFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryHouseAdArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHouseAdsArgs = {
  filter?: Maybe<HouseAdFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryHubArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHubForkArgs = {
  input?: Maybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHubsArgs = {
  filter?: Maybe<HubFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPageArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPageForkArgs = {
  input?: Maybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPagesArgs = {
  filter?: Maybe<LandingPageFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryLegacyLenderArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLegacyLendersArgs = {
  filter?: Maybe<LegacyLenderFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaItemArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaItemsArgs = {
  filter?: Maybe<MediaItemFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryPageArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPostArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewForkArgs = {
  input?: Maybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewsArgs = {
  filter?: Maybe<ReviewFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupForkArgs = {
  input?: Maybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupsArgs = {
  filter?: Maybe<RoundupFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordArgs = {
  input?: Maybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordsArgs = {
  filter?: Maybe<UrlRecordFilterInput>;
  order?: Maybe<OrderInput>;
  pagination?: Maybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryRelatedArticlesArgs = {
  input?: Maybe<RelatedArticlesInput>;
};


/** Empty field. Not to be used. */
export type QueryTransactionDataArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  resultsSetToken?: Maybe<Scalars['String']>;
};

/** Named credit score ranges accepted for creditScoreRange in AutoInsurancePrequalOfferInput */
export enum QuinStreetCreditScoreRangeEnum {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Fair = 'FAIR',
  Poor = 'POOR'
}

/** The `RawIdentity` type represents the cookies and any payload related to the logged in identity. */
export type RawIdentity = {
  __typename?: 'RawIdentity';
  authCookies: Array<Cookie>;
  data?: Maybe<Scalars['JSON']>;
};

/** The `RawIdentityProfile` type represents the given profile */
export type RawIdentityProfile = {
  __typename?: 'RawIdentityProfile';
  profileType: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
};

/** Describes the details of the recap list section of a roundup */
export type RecapListDetails = {
  __typename?: 'RecapListDetails';
  /** The title to use for the recap list section */
  title: Scalars['String'];
  recapItems?: Maybe<Array<RoundupSection>>;
};


/** Describes the details of the recap list section of a roundup */
export type RecapListDetailsRecapItemsArgs = {
  abTestPepIsActive?: Maybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: Maybe<Scalars['Boolean']>;
};

export type RecommendationGuidance = {
  __typename?: 'RecommendationGuidance';
  /**
   * Contains the information needed to display a CTA and details
   * to how to handle the action in mobile and web.
   */
  action?: Maybe<RecommendationGuidanceAction>;
  /** Suggested advice description to be shown for the particular guidance */
  advice: Scalars['String'];
  /**
   * Explanation about what we know from the user data that we believe this
   * particular guidance is surfaced to the user.
   */
  insight: Scalars['String'];
  /**
   * Source of the insight used for this recommendation, mostly used for tracking.
   * e.g. Credit Utilization, Age of Accounts.
   */
  insightSource: Scalars['String'];
  /** Cannonical name identifier for the particular guidance */
  name: Scalars['String'];
  /** Label used at the top of the guidance card. */
  tag?: Maybe<Scalars['String']>;
};

export type RecommendationGuidanceAction = {
  __typename?: 'RecommendationGuidanceAction';
  /**
   * Target used for the native app, most of the cases this will contain
   * a deep link.
   */
  mobileTarget: Scalars['String'];
  /** Cannonical name identifier for this action */
  name: Scalars['String'];
  /**
   * Target use for web, most of the cases will contain a url to open.
   * Also might be used as a fallback if the mobileTarget is not supported in the native app.
   */
  target: Scalars['String'];
  /** Enum for the target type to be used when handling the action targets. */
  targetType: RecommendationGuidanceTargetType;
  /** Friendly text displayed to the user as a CTA. */
  text: Scalars['String'];
};

export enum RecommendationGuidanceTargetType {
  WebLink = 'WEB_LINK'
}

/**
 * A user insight sourced from the recommendation-service and retrieved via Factory.
 * 
 * Note that the prefix "Recommendation" indicates only the origin of this insight -- not that it is semantically more
 * worthy of "recommendation" than insights from other sources.
 */
export type RecommendationInsight = UserInsightInterface & {
  __typename?: 'RecommendationInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   * 
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   * 
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   * 
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   * 
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   * 
   * For exmaple, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   * 
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   * 
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   * 
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   * 
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** Flag for whether generated user insight is stale compared to a user's new credit report pull */
  isStale?: Maybe<Scalars['Boolean']>;
};

export type RecommendationTypeInput = {
  recommendationType?: Maybe<RewardsCreditCardRecommendationType>;
  /** This will default to "FULL" if not set */
  recommendationLevel?: Maybe<RewardsCreditCardRecommendationLevel>;
};

/** Recommended card from the best card for you endpoints */
export type RecommendedRewardsCreditCard = {
  __typename?: 'RecommendedRewardsCreditCard';
  /** The likelihood of being approved for this card, given a user's credit score (if known) */
  approvalLikelihood?: Maybe<Scalars['Float']>;
  /** The rewards category of the recommended card, ex: overall, travel, gas, etc. */
  category: CreditCardOfferRewardCategoryType;
  /** The card's legacy ID as defined in marketplace */
  legacyId: Scalars['ID'];
  /** The card's name */
  name: Scalars['String'];
  /**
   * Total amount of rewards calculated based on the user's spending input over the
   * input time period (2 yr time horizon default)
   */
  netRewards?: Maybe<Scalars['Float']>;
  /** The category classification of the recommended card */
  recommendationType?: Maybe<RewardsCreditCardRecommendationType>;
  /** The details that determine why a card was recommended */
  recommendationDetails?: Maybe<RewardsCreditCardRecommendationDetails>;
  rewardsCreditCard: RewardsCreditCard;
  /** Marketplace UUID, offer.id */
  id: Scalars['ID'];
};

/** The response for a Best Card For Your query */
export type RecommendedRewardsCreditCardsResponse = {
  __typename?: 'RecommendedRewardsCreditCardsResponse';
  /** The user's spending facts by category as well as credit score */
  facts?: Maybe<UserSpendingByCategoryThreeMonthAverage>;
  /** A list of credit card offers from marketplace, designated by legacyId and extracted from recommended cards */
  cards?: Maybe<Array<RecommendedRewardsCreditCard>>;
  /** The user's credit card category spending over X months */
  creditCardSpendingByCategory?: Maybe<CreditCardCategorySpending>;
};

export type RefreshTokenLoginInfoInput = {
  /** The refresh token used to login */
  refreshToken: Scalars['String'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type RegisterUserResponse = AuthenticationResponseInterface & {
  __typename?: 'RegisterUserResponse';
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
  /** The A/B experiments associated with the current user */
  abExperiments?: Maybe<Array<Experiment>>;
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type RegistrationTrackingMetadata = {
  /** The tracking channel for the current user (e.g. 'mobile') */
  trackingChannel?: Maybe<Scalars['String']>;
  /** The tracking version for the current user */
  trackingVersion?: Maybe<Scalars['String']>;
  /** The tracking vertical for the current user (e.g. 'nw_native_app') */
  trackingVertical?: Maybe<Scalars['String']>;
  /** The page impression ID associated with the user registration event */
  pageImpressionId: Scalars['String'];
  /** The navigation source impression ID associated with the user registration event */
  navigationSourceImpressionId: Scalars['String'];
  /** The navigation source tracking code associated with the user registration event */
  navigationSourceTrackingCode?: Maybe<Scalars['String']>;
};

export type ReinitializeFinancialPortalResponse = {
  __typename?: 'ReinitializeFinancialPortalResponse';
  financialPortal?: Maybe<FinancialPortal>;
  details?: Maybe<ReinitializeFinancialPortalResponseDetails>;
};

export type ReinitializeFinancialPortalResponseDetails = {
  __typename?: 'ReinitializeFinancialPortalResponseDetails';
  /**  If there is an existing Plaid Item, use this token when opening Plaid Link to enter the fix flow  */
  publicToken?: Maybe<Scalars['ID']>;
  /**  For a portal that should be migrated, the suggested marketplace account aggregation institution id  */
  recommendedInstitutionId?: Maybe<Scalars['ID']>;
  /**  For a portal that should be migrated, the external (e.g. Plaid) id for the institution to link  */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']>;
};

/** The input for retrieving a collection of related articles. */
export type RelatedArticlesInput = {
  /** A WordPress ID to exclude from the query. */
  exclude: Scalars['ID'];
  /** The type of article to return. */
  articleType: Scalars['String'];
  /** Limit of number of results. Default: 6 */
  limit?: Maybe<Scalars['Int']>;
};

export type RemoveUserReportedCreditCardResult = {
  __typename?: 'RemoveUserReportedCreditCardResult';
  /** The legacy of the removed card */
  cardId: Scalars['Int'];
};

/** The enum for selecting the text formatting to return on rendered text fields. */
export enum RenderedTextFormatEnum {
  Html = 'HTML',
  PlainText = 'PLAIN_TEXT'
}

export type ResetPasswordInfoInput = {
  /** The password reset token used to reset the user's password */
  passwordResetToken: Scalars['String'];
  /** The user's existing password used to reset their password */
  password: Scalars['String'];
  /** The challenge answer associated with the user's password reset */
  challengeAnswer: Scalars['String'];
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type Review = PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithTitleInterface & {
  __typename?: 'Review';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Review object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The WP (not Marketplace) star rating for the product being reviewed. */
  rating?: Maybe<Scalars['Float']>;
  /** The Breadcrumb to be displayed on a review */
  breadcrumb?: Maybe<Breadcrumb>;
  /**
   * The legacy synopsis field for a review. Once reviews support structured
   * content the synopsis field will return a structured content document.
   */
  legacySynopsis?: Maybe<Scalars['String']>;
  /** The marketplace entity associated with this review */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewExcerptArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ReviewConnectionResponse = {
  __typename?: 'ReviewConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Review returned for the connection. */
  items?: Maybe<Array<Review>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Review objects. */
export type ReviewFilterInput = {
  /** Limit collection to Reviews published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to Reviews within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: Maybe<Scalars['String']>;
  /** Limit collection to Reviews with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Limit collection to Reviews with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** The reward data connected to an account */
export type RewardAccount = {
  __typename?: 'RewardAccount';
  id: Scalars['ID'];
  providerName: Scalars['String'];
  accountNumber?: Maybe<Scalars['String']>;
  providerId: Scalars['ID'];
  accountStatus: RewardAccountStatus;
  providerAccountId: Scalars['ID'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  rewardBalance?: Maybe<Array<RewardAccountBalance>>;
  dataset?: Maybe<Array<RewardAccountDataset>>;
};

export type RewardAccountBalance = {
  __typename?: 'RewardAccountBalance';
  /** Units of the account's balance */
  units?: Maybe<RewardAccountBalanceUnit>;
  /** The balance required to reach a reward level. */
  balanceToLevel?: Maybe<Scalars['String']>;
  balanceType?: Maybe<RewardAccountBalanceType>;
  balance: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['Date']>;
  balanceToReward?: Maybe<Scalars['String']>;
};

export enum RewardAccountBalanceType {
  Balance = 'BALANCE',
  BalanceToLevel = 'BALANCE_TO_LEVEL',
  BalanceToReward = 'BALANCE_TO_REWARD',
  ExpiringBalance = 'EXPIRING_BALANCE',
  TotalBalance = 'TOTAL_BALANCE'
}

export enum RewardAccountBalanceUnit {
  Miles = 'MILES',
  Points = 'POINTS',
  Segments = 'SEGMENTS',
  Dollars = 'DOLLARS',
  Credits = 'CREDITS'
}

export type RewardAccountDataset = {
  __typename?: 'RewardAccountDataset';
  lastUpdated?: Maybe<Scalars['DateTime']>;
  nextUpdateScheduled?: Maybe<Scalars['DateTime']>;
  lastUpdateAttempt?: Maybe<Scalars['DateTime']>;
};

/** The status a reward account can be in */
export enum RewardAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  ToBeClosed = 'TO_BE_CLOSED',
  Closed = 'CLOSED'
}

export type RewardCategoryCopyOverride = {
  __typename?: 'RewardCategoryCopyOverride';
  categoryName?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
};

/** Compliance mandated overrides for specific cards */
export type RewardCategoryCopyOverrides = {
  __typename?: 'RewardCategoryCopyOverrides';
  dining?: Maybe<RewardCategoryCopyOverride>;
  entertainment?: Maybe<RewardCategoryCopyOverride>;
  gas?: Maybe<RewardCategoryCopyOverride>;
  groceries?: Maybe<RewardCategoryCopyOverride>;
  shopping?: Maybe<RewardCategoryCopyOverride>;
  travel?: Maybe<RewardCategoryCopyOverride>;
};

export type RewardsAction = {
  __typename?: 'RewardsAction';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  name: Scalars['String'];
  /**
   * An 'item' is often a qualifer for a parent 'action' such as a discount on select products
   * in a particular category
   */
  items?: Maybe<Array<RewardsActionItem>>;
};

export type RewardsActionItem = {
  __typename?: 'RewardsActionItem';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  name: Scalars['String'];
};

export type RewardsBrandAsset = {
  __typename?: 'RewardsBrandAsset';
  /** User friendly name of the img size */
  name?: Maybe<Scalars['String']>;
  /** img src */
  sourceUrl?: Maybe<Scalars['String']>;
  /** img width */
  width?: Maybe<Scalars['Int']>;
  /** img height */
  height?: Maybe<Scalars['Int']>;
  /** WP filename */
  file?: Maybe<Scalars['String']>;
  /** MIME type */
  mimeType?: Maybe<Scalars['String']>;
};

/** A collection of RewardsOffersCategory */
export type RewardsCategoryGroup = {
  __typename?: 'RewardsCategoryGroup';
  /** Name of this group */
  name: Scalars['String'];
  /** List of categories that belong to this group */
  categories?: Maybe<Array<RewardsOffersCategory>>;
  /** Brand Assets: image-related data for the UI */
  brandAssets?: Maybe<Array<Maybe<RewardsBrandAsset>>>;
};

export type RewardsCommission = {
  __typename?: 'RewardsCommission';
  /** Amount, ex: '4.00%' */
  amountText?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Boolean flag to indicate included offers */
  hasOffers?: Maybe<Scalars['Boolean']>;
  /** List of RewardsOffers */
  offers?: Maybe<Array<Maybe<RewardsOffer>>>;
  /** The type of commission */
  type?: Maybe<Scalars['String']>;
};

/** A rewards credit card that is owned by the current user, as reported by that user. */
export type RewardsCreditCard = {
  __typename?: 'RewardsCreditCard';
  /** The Marketplace UUID for a CreditCardOffer, lifted up */
  id: Scalars['ID'];
  /** The currently-active offer that pertains to the credit card *product* */
  offer: CreditCardOffer;
  /** The earning rates by category of this credit card */
  rewardCategoryRates?: Maybe<CreditCardOfferRewardCategoryRates>;
  /** Override data to display instead of default values for compliance reasons */
  categoryCopyOverrides?: Maybe<RewardCategoryCopyOverrides>;
};

/** The various components of a credit card recommendation */
export type RewardsCreditCardRecommendationDetails = {
  __typename?: 'RewardsCreditCardRecommendationDetails';
  /** The reward category of the recommended card */
  categoryType?: Maybe<CreditCardOfferRewardCategoryType>;
  /** The user's current card's legacy ID in this category */
  currentBestCardLegacyId: Scalars['Int'];
  /** The user's current card's best rate in this category */
  currentBestRate?: Maybe<Scalars['Float']>;
  /** The user's current card's reward type */
  currentBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's recommended card's best rate in this category */
  newBestRate?: Maybe<Scalars['Float']>;
  /** The user's recommended card's reward type in this category */
  newBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's 30 day average spending over the previous 90 days in this rewards category */
  categorySpendingAmount?: Maybe<Scalars['Float']>;
  /** The user's estimated +/- in rewards over two years for the recommended card */
  rewardIncrease?: Maybe<Scalars['Float']>;
  /** The amount of bonus points/miles/rewards a user can expect to receive if they meet signup bonus */
  qualifiedSigningBonusAmount?: Maybe<Scalars['Float']>;
  /** The currency of bonus points/miles/rewards a user can expect to receive if they meet signing bonus */
  qualifiedSigningBonusAmountType?: Maybe<CreditCardOfferRewardType>;
};

export enum RewardsCreditCardRecommendationLevel {
  /**
   * A Full recommendation takes into account a user's credit score, spending habits, and
   * cards that are self-reported via the "Cards" experience in the native app
   */
  Full = 'FULL',
  /** A partial recommendation takes into account a user's credit score */
  Partial = 'PARTIAL'
}

export enum RewardsCreditCardRecommendationType {
  All = 'ALL',
  Complementary = 'COMPLEMENTARY',
  Entertainment = 'ENTERTAINMENT',
  Dining = 'DINING',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Travel = 'TRAVEL',
  Overall = 'OVERALL',
  Other = 'OTHER'
}

export type RewardsFeaturedOffers = {
  __typename?: 'RewardsFeaturedOffers';
  /** Brand assets: image-related data for the UI */
  brandAssets?: Maybe<Array<Maybe<RewardsBrandAsset>>>;
  /** Merchant group description */
  description?: Maybe<Scalars['String']>;
  /** List of offers */
  merchants?: Maybe<Array<Maybe<OnlineCardLinkedOffer>>>;
  /** Featured category name */
  name?: Maybe<Scalars['String']>;
  /** Featured offers type */
  type: Scalars['String'];
};

export type RewardsFilteredFeaturedOfferDetails = {
  __typename?: 'RewardsFilteredFeaturedOfferDetails';
  /** List of RewardsFeaturedOffers */
  offers?: Maybe<Array<RewardsFeaturedOffers>>;
  /** Total number of offers */
  numOffers: Scalars['Int'];
};

export type RewardsFilteredFeaturedOffers = {
  __typename?: 'RewardsFilteredFeaturedOffers';
  /** Default offers */
  topOffers?: Maybe<RewardsFilteredFeaturedOfferDetails>;
  /** Banner offers */
  curatedOffers?: Maybe<RewardsFilteredFeaturedOfferDetails>;
};

export type RewardsMutationSuccessResponse = {
  __typename?: 'RewardsMutationSuccessResponse';
  success: Scalars['Boolean'];
};

export type RewardsNextPayment = {
  __typename?: 'RewardsNextPayment';
  payoutAmount?: Maybe<Scalars['String']>;
  payoutDate?: Maybe<Scalars['String']>;
};

export type RewardsOffer = {
  __typename?: 'RewardsOffer';
  /** Amount, ex: '4.00%' */
  amountText?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
};

export type RewardsOffersCategory = {
  __typename?: 'RewardsOffersCategory';
  /** IMG assets */
  brandAssets?: Maybe<Array<Maybe<RewardsBrandAsset>>>;
  /** Category name */
  name?: Maybe<Scalars['String']>;
  /** Slug/search term */
  slugName?: Maybe<Scalars['String']>;
};

export type RewardsOfflineAddress = {
  __typename?: 'RewardsOfflineAddress';
  city?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type RewardsOfflineScheduleDetail = {
  __typename?: 'RewardsOfflineScheduleDetail';
  /** Indicates whether the offer is currently active */
  active?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the offer is the next active offer */
  nextActive?: Maybe<Scalars['Boolean']>;
  /** Reward value as % or $ */
  discount?: Maybe<Scalars['Int']>;
  /** When the deal ends */
  endsAt?: Maybe<Scalars['Int']>;
  /** Percent or dollar value based deal */
  rewardType?: Maybe<Scalars['String']>;
  /** When the deals kicks in */
  startsAt?: Maybe<Scalars['Int']>;
};

export type RewardsOfflineSimpleHours = {
  __typename?: 'RewardsOfflineSimpleHours';
  monday?: Maybe<Scalars['String']>;
  tuesday?: Maybe<Scalars['String']>;
  wednesday?: Maybe<Scalars['String']>;
  thursday?: Maybe<Scalars['String']>;
  friday?: Maybe<Scalars['String']>;
  saturday?: Maybe<Scalars['String']>;
  sunday?: Maybe<Scalars['String']>;
};

export type RewardsOfflineSubOffer = {
  __typename?: 'RewardsOfflineSubOffer';
  /** Indicates whether this is a basic offer */
  basic?: Maybe<Scalars['Boolean']>;
  /** Fine print text */
  finePrint?: Maybe<Scalars['String']>;
  /** Indicates whether a deal has been activated yet */
  hasBeenActivated?: Maybe<Scalars['Boolean']>;
  /** Indicates if a deal is available during certain days/times */
  hasSchedule?: Maybe<Scalars['Boolean']>;
  /** Offer ID */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether a deal needs to be activated for redemption */
  requiresActivation?: Maybe<Scalars['Boolean']>;
  /** The lifetime max paid to a user */
  rewardMax?: Maybe<Scalars['Int']>;
  /** Percent or dollar value based deal */
  rewardType?: Maybe<Scalars['String']>;
  /** Amount of the reward, either % or $ */
  rewardValue?: Maybe<Scalars['Int']>;
  /** A schedule of different deals based on day of week and time */
  schedule?: Maybe<RewardsOfflineSubOfferSchedule>;
};

export type RewardsOfflineSubOfferSchedule = {
  __typename?: 'RewardsOfflineSubOfferSchedule';
  monday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
  tuesday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
  wednesday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
  thursday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
  friday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
  saturday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
  sunday?: Maybe<Array<RewardsOfflineScheduleDetail>>;
};

export type RewardsSetPrimaryCardResponse = {
  __typename?: 'RewardsSetPrimaryCardResponse';
  cardId: Scalars['Int'];
};

export type RewardsSummary = {
  __typename?: 'RewardsSummary';
  /** Indicates whether this is a percentage based reward or dollar based */
  currency?: Maybe<Scalars['String']>;
  /** The minimum reward available */
  minAmount?: Maybe<Scalars['Float']>;
  /** The maximum reward available */
  maxAmount?: Maybe<Scalars['Float']>;
};

/** A transaction that occurred as a result of an user's action */
export type RewardsTransaction = {
  __typename?: 'RewardsTransaction';
  /** ID of transaction */
  id: Scalars['String'];
  /** Date of transaction */
  transactedAt?: Maybe<Scalars['String']>;
  /** Partner network */
  network: Scalars['String'];
  /** Venue that user transacted at */
  venue: RewardsTransactionVenue;
  /** Amount of cashback the user received */
  cashbackAmount: Scalars['Float'];
  /** Status of the transaction */
  status: Scalars['String'];
  /** Amount of the transaction */
  transactionAmount?: Maybe<Scalars['Float']>;
};

/** Venue in which a transaction occurred at */
export type RewardsTransactionVenue = {
  __typename?: 'RewardsTransactionVenue';
  /** ID of the venue */
  id: Scalars['String'];
  /** Name of the venue */
  name: Scalars['String'];
  /** URL of venue's logo */
  thumbnailUrl?: Maybe<Scalars['String']>;
};

/** A rewards user */
export type RewardsUser = {
  __typename?: 'RewardsUser';
  /** Empyr User ID, used for CJ as well */
  userId?: Maybe<Scalars['String']>;
  /** Signed Empyr user ID */
  signedUserToken?: Maybe<Scalars['String']>;
};

/** A rewards user's linked cards in Empyr */
export type RewardsUserCard = {
  __typename?: 'RewardsUserCard';
  /** Card status */
  cardState?: Maybe<Scalars['String']>;
  /** VISA, AMEX, Discover, MasterCard, etc */
  cardType?: Maybe<Scalars['String']>;
  /** Card expiration month */
  expirationMonth?: Maybe<Scalars['Int']>;
  /** Card expiration year */
  expirationYear?: Maybe<Scalars['Int']>;
  /** Card ID */
  id?: Maybe<Scalars['Int']>;
  /** Last 4 digits of card */
  lastFour?: Maybe<Scalars['String']>;
  /** Is this the primary card for the user? */
  primary?: Maybe<Scalars['Boolean']>;
};

/** A rewards user's payments */
export type RewardsUserPayment = {
  __typename?: 'RewardsUserPayment';
  /** Payment amount */
  amount?: Maybe<Scalars['Float']>;
  /** The associated card that the payment is made to */
  card?: Maybe<RewardsUserCard>;
  /** The payment date */
  date?: Maybe<Scalars['String']>;
  /** Payment ID */
  id?: Maybe<Scalars['Int']>;
  /** Payment account details, if any */
  paymentAccountDetails?: Maybe<Scalars['String']>;
  /** The description, sometimes indicates the amount that was paid and when, once completed */
  paymentDescription?: Maybe<Scalars['String']>;
  /** The current status of the payment, possibly null if COMPLETED */
  paymentStatus?: Maybe<Scalars['String']>;
  /** Payment UTC timestamp */
  utcTimestamp?: Maybe<Scalars['Int']>;
};

/** A rewards user summary */
export type RewardsUserSummary = {
  __typename?: 'RewardsUserSummary';
  /** The user's rewards balance */
  balance?: Maybe<Scalars['Float']>;
  /** The user's cashback balance for the current month */
  currentMonthCashback?: Maybe<Scalars['Float']>;
  /** The associated revenue for the current month */
  currentMonthRevenue?: Maybe<Scalars['Float']>;
  /** The current month's transactions */
  currentMonthTransactions?: Maybe<Scalars['Float']>;
  /** The cashback reward amount to be paid to a user */
  expectedPayout?: Maybe<Scalars['Float']>;
  /** Lifetime earnings */
  moneyEarned?: Maybe<Scalars['Float']>;
  /** The next pay period's balance */
  nextPayPeriodAmount?: Maybe<Scalars['Float']>;
  /** The next pay period due date */
  nextPayPeriodDate?: Maybe<Scalars['String']>;
  /** The next pay period due date in UTC */
  nextPayPeriodUtcTimestamp?: Maybe<Scalars['Int']>;
  /** Total cashback */
  totalCashback?: Maybe<Scalars['Float']>;
  /** Total number of unique places visited? */
  totalPlaces?: Maybe<Scalars['Float']>;
  /** Lifetime user revenue */
  totalRevenue?: Maybe<Scalars['Float']>;
  /** Lifetime user transactions */
  totalTransactions?: Maybe<Scalars['Float']>;
  nextPayment?: Maybe<RewardsNextPayment>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type Roundup = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Roundup';
  /** The custom content to display above the Roundup sections. */
  aboveSections?: Maybe<Scalars['StructuredContentDocument']>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /**
   * The topic that should be used as the 'Attribution Topic' for this piece of
   * content. This value is used for attributing metrics related to this piece of
   * content in analytics reports.
   */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The content to display below the Roundup sections. */
  belowSections?: Maybe<Scalars['StructuredContentDocument']>;
  /** A list of Category objects on the Roundup object. */
  categories?: Maybe<Array<Category>>;
  /** The content clusters for this piece of content. Content clusters are meant to be arbitrary groupings of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** Marketplace named query to use on marketing roundups. */
  crossSellNamedQuery?: Maybe<Scalars['String']>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether or not to include the number of Marketplace entities in the title. */
  excludeEntityCountFromTitle?: Maybe<Scalars['Boolean']>;
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** Posts to display in the footer of this Roundup. */
  footerPosts?: Maybe<Array<RoundupFooterPostsUnion>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** Whether or not to split the product cards by category name. */
  hideCategoriesInProductCardsSection?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** Whether or not to include the date in the SEO title. */
  includeDateInSeoTitle?: Maybe<Scalars['Boolean']>;
  /** Whether or not to include the date in the editorial title. */
  includeDateInTitle?: Maybe<Scalars['Boolean']>;
  includeExpandedProductDetails?: Maybe<Scalars['Boolean']>;
  /** The insurance component to use on the Roundup. */
  insuranceComponent?: Maybe<Scalars['StructuredContentDocument']>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The Marketplace product type. */
  marketplaceProductType?: Maybe<MarketplaceProductTypeEnum>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The Roundup product sections to display on this Roundup. */
  roundupSections?: Maybe<Array<RoundupSection>>;
  /** The type of roundup this piece of content is. */
  roundupType?: Maybe<RoundupTypeEnum>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** Whether or not to display the CTA at the bottom of the Roundup. */
  showFooterCta?: Maybe<Scalars['Boolean']>;
  /** Whether or not to display the CTA at the top of the Roundup. */
  showIntroCta?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the summary table. */
  showSummaryTable?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The quick facts to use in the summary list for banking roundups. */
  summaryListQuickFacts?: Maybe<Array<RoundupSummaryListQuickFactsEnum>>;
  /** The custom title to display for the Summary List on this Roundup. */
  summaryListTitle?: Maybe<Scalars['String']>;
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Whether or not to use ALPS for ordering the roundup sections. */
  useAlpOrderingForSections?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** Roundup sections to display in the Additional Recommendations section of the roundup */
  additionalRecommendations?: Maybe<Array<RoundupSection>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /** The Breadcrumb to display on a Roundup */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Contains display information for the cross sell section of a roundup */
  crossSellSection?: Maybe<RoundupCrossSellDetails>;
  /**
   * The DateTime in UTC to display for the roundup based on flags, custom dates,
   * and Marketplace entities set on the roundup
   */
  displayDate?: Maybe<Scalars['String']>;
  /** Eyebrow header text for a roundup. */
  eyebrowText: Scalars['String'];
  /** Boolean flag to indicate if the roundup has local offers to display */
  hasLocalOffers: Scalars['Boolean'];
  /** The vertical-specific methodology to display for the roundup */
  methodology?: Maybe<Scalars['StructuredContentDocument']>;
  /** The model execution ids used for ALPS ordering */
  modelExecutionIds?: Maybe<Array<Scalars['String']>>;
  /** Contains display information for the product cards section of a roundup */
  productCardsSection: RoundupProductCardsDetails;
  /**
   * The deduped list of raw marketplace entities that are eligible to be displayed on the page.
   *   - exists
   *   - active
   *   - contains the appropriate display page
   * Includes localized entities that will need to be filtered in the client.
   * TODO: replace with GraphQL Marketplace V2 Entities
   */
  rawMarketplaceEntitiesDisplayedOnPage?: Maybe<Array<Scalars['JSON']>>;
  /** Contains display information for the recap list section of a roundup */
  recapListSection: RecapListDetails;
  /** Boolean flag that determines if the first product card's details should be expanded on page load */
  shouldExpandFirstProductCard: Scalars['Boolean'];
  /** Boolean flag that determines if the CTA should be omitted throughout the roundup */
  shouldOmitCta: Scalars['Boolean'];
  /** Boolean flag that determines if ratings should be omitted throughout the roundup */
  shouldOmitRating: Scalars['Boolean'];
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Boolean flag to show/hide editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean'];
  /** The Fundera marketplace entity required for the SMB aggregator partnership banner */
  smbAggregatorPartnershipRawMarketplaceEntity: Scalars['JSON'];
  /** Contains display information for the summary table section of a roundup */
  summaryTableSection: RoundupSummaryTableDetails;
  /** Ordered template sections for a roundup. */
  templateSections?: Maybe<Array<RoundupTemplateSectionTypeEnum>>;
  /**
   * The page title without the entity count. This is meant to be used for
   * pages with localized entities.
   */
  titleWithoutEntityCount: Scalars['String'];
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupExcerptArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupAdditionalRecommendationsArgs = {
  abTestPepIsActive?: Maybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: Maybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDisplayDateArgs = {
  format?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModelExecutionIdsArgs = {
  abTestPepIsActive?: Maybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: Maybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupShouldExpandFirstProductCardArgs = {
  isDesktopUserAgent?: Maybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTemplateSectionsArgs = {
  isDesktopUserAgent?: Maybe<Scalars['Boolean']>;
};

/** Describes a category that contains a group of roundup sections to display */
export type RoundupCategorySection = {
  __typename?: 'RoundupCategorySection';
  /** The eyebrow text that prepends the category title in the Product Cards section of a roundup */
  eyebrowText?: Maybe<Scalars['String']>;
  /** The name of the roundup category to be displayed in the Product Cards section of a roundup */
  title?: Maybe<Scalars['String']>;
  /** The description of the roundup category to be displayed in the Product Cards section of a roundup */
  description?: Maybe<Scalars['String']>;
  /** The list of product cards to display for this roundup category */
  productCards?: Maybe<Array<RoundupSection>>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type RoundupConnectionResponse = {
  __typename?: 'RoundupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Roundup returned for the connection. */
  items?: Maybe<Array<Roundup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Describes the details of the cross sell section of a roundup */
export type RoundupCrossSellDetails = {
  __typename?: 'RoundupCrossSellDetails';
  productCards?: Maybe<Array<RoundupCrossSellSection>>;
  subtext: Scalars['String'];
};

/** Describes a card in the roundup's cross sell section */
export type RoundupCrossSellSection = {
  __typename?: 'RoundupCrossSellSection';
  /** The tracking params that should be appended to this cross sell section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The marketplace entity associated with this cross sell section */
  marketplaceEntity: MarketplaceEntityInterface;
  /**
   * The raw marketplace entity for this cross sell section
   * TODO: replace with a proper marketplaceEntity schema
   */
  rawMarketplaceEntity: Scalars['JSON'];
};

/** Query to fetch a collection of Roundup objects. */
export type RoundupFilterInput = {
  /** Limit collection to Roundups published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to Roundups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: Maybe<Scalars['String']>;
  /** Limit collection to Roundups with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Limit collection to Roundups with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/** The union containing the Type members that can be returned by the footerPosts field on the Roundup type. */
export type RoundupFooterPostsUnion = Article | Page | Post | Roundup;

/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetails = {
  __typename?: 'RoundupProductCardsDetails';
  /** The list of category sections to display in the Product Cards Section */
  categorySections?: Maybe<Array<RoundupCategorySection>>;
  /** The title to use for the product cards section. */
  title?: Maybe<Scalars['String']>;
};


/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsCategorySectionsArgs = {
  abTestPepIsActive?: Maybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: Maybe<Scalars['Boolean']>;
};

/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSection = {
  __typename?: 'RoundupSection';
  /** The benefits of this product. */
  benefits?: Maybe<Scalars['StructuredContentDocument']>;
  /**
   * The text to show in the Why We Like It section of a product card. Overrides
   * the bottomLine provided by the Marketplace Entity.
   */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
  /** The category description for the Roundup category. */
  categoryDescription?: Maybe<Scalars['String']>;
  /** The name of the Roundup category within this section. */
  categoryName?: Maybe<Scalars['String']>;
  /** Where to link the CTA to. */
  ctaDestination?: Maybe<Scalars['String']>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']>;
  /** The drawbacks of this product. */
  drawbacks?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Marketplace Entity type. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyId?: Maybe<Scalars['String']>;
  /** The lender associated with the roundup. */
  legacyLender?: Maybe<LegacyLender>;
  /** The Marketplace entity UUID. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyId?: Maybe<Scalars['String']>;
  /** The Marketplace product type. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** Whether or not to display this roundup section in more options instead of a product card. */
  showInAdditionalRecommendations?: Maybe<Scalars['Boolean']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyId?: Maybe<Scalars['String']>;
  /** The list of cons that will override this roundup section's marketplace entity's cons */
  cons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The CTA that will override this roundup section's marketplace entity's CTA */
  cta?: Maybe<EntityPlacementCta>;
  /** The tracking params that should be appended to this roundup section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /**
   * The driver group for a Product Card that will override this roundup section's default drivers
   * TODO: (SHOP-13277) After the Product Cards have been updated to accept drivers return override
   *   drivers directly instead of a group
   * @deprecated This field is only used while we migrate to using the drivers field.
   */
  driverGroup?: Maybe<Scalars['String']>;
  /** The driver overrides for a given roundup section. */
  drivers?: Maybe<Array<EntityPlacementDriverInterface>>;
  /** Boolean flag to indicate if model execution id should be excluded from impressions for this roundup section. */
  excludeModelExecutionIds: Scalars['Boolean'];
  /** The marketplace entity associated with this roundup section */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The product card Component to use for this roundup section */
  productCardComponent: ProductCardComponentEnum;
  /** The list of pros that will override this roundup section's marketplace entity's pros */
  pros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The raw JSON marketplace entity associated with this roundup section. */
  rawMarketplaceEntity?: Maybe<Scalars['JSON']>;
  /**
   * The raw JSON marketplace entity to use for 1-Year APY associated with this roundup section.
   * (Banking only)
   */
  rawMarketplaceEntity1YearApy?: Maybe<Scalars['JSON']>;
  /**
   * The raw JSON marketplace entity to use for 1-Year APY associated with this roundup section.
   * (Banking only)
   */
  rawMarketplaceEntity3YearApy?: Maybe<Scalars['JSON']>;
  /**
   * The raw JSON marketplace entity to use for 1-Year APY associated with this roundup section.
   * (Banking only)
   */
  rawMarketplaceEntity5YearApy?: Maybe<Scalars['JSON']>;
  /**
   * The description to show in the recap list for this roundup section - Note that this
   * field should only be used as a child of 'recapListSection.recapItems'
   */
  recapDescription?: Maybe<Scalars['String']>;
  /** Boolean flag to indicate if the "Add to Compare" button should be enabled */
  shouldEnableAddToCompare: Scalars['Boolean'];
  /** Boolean flag to indicate if the images should lazy load for this roundup section */
  shouldEnableImageLazyLoad: Scalars['Boolean'];
};


/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionProductCardComponentArgs = {
  isDesktopUserAgent?: Maybe<Scalars['Boolean']>;
};


/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionRawMarketplaceEntityArgs = {
  matchScoreParameters?: Maybe<Scalars['JSON']>;
};

/** Enum values for summaryListQuickFacts field on Roundup type. */
export enum RoundupSummaryListQuickFactsEnum {
  Apy = 'APY',
  Bonus = 'BONUS',
  Default = 'DEFAULT',
  MinimumBalance = 'MINIMUM_BALANCE',
  MonthlyFee = 'MONTHLY_FEE',
  OutOfNetworkAtmFee = 'OUT_OF_NETWORK_ATM_FEE'
}

/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetails = {
  __typename?: 'RoundupSummaryTableDetails';
  /** Whether to enable row truncation behavior */
  allowTruncatingRows: Scalars['Boolean'];
  /** Text to be added at the bottom of the summary table */
  disclaimerText?: Maybe<Scalars['String']>;
  /** Title that should be used as the header for each marketplace entity */
  marketplaceEntityHeader: Scalars['String'];
  /** The maximum number of rows that can be present before any truncation can be applied */
  maxRows: Scalars['Int'];
  /** The number of rows to show after applying truncation */
  numTruncatedRows: Scalars['Int'];
  /** The rows within the summary table */
  rows?: Maybe<Array<RoundupSection>>;
  /** The title to use for the Summary Table Section */
  title: Scalars['String'];
};


/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetailsRowsArgs = {
  abTestPepIsActive?: Maybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: Maybe<Scalars['Boolean']>;
};

/** Types of TemplateSections for a Roundup. */
export enum RoundupTemplateSectionTypeEnum {
  Header = 'HEADER',
  Insurance = 'INSURANCE',
  RecapWithAccordion = 'RECAP_WITH_ACCORDION',
  IntroContent = 'INTRO_CONTENT',
  GeodataDropdown = 'GEODATA_DROPDOWN',
  ProductCards = 'PRODUCT_CARDS',
  SummaryTablePretty = 'SUMMARY_TABLE_PRETTY',
  SmbAggregatorPartnership = 'SMB_AGGREGATOR_PARTNERSHIP',
  LearnContent = 'LEARN_CONTENT',
  CrossSellModule = 'CROSS_SELL_MODULE',
  UpdatedDate = 'UPDATED_DATE',
  Methodology = 'METHODOLOGY',
  Recap = 'RECAP',
  Faq = 'FAQ',
  AuthorBox = 'AUTHOR_BOX',
  FooterPosts = 'FOOTER_POSTS',
  CompareBar = 'COMPARE_BAR'
}

/** Enum values for roundupType field on Roundup type. */
export enum RoundupTypeEnum {
  MarketingRoundup = 'MARKETING_ROUNDUP',
  OrganicRoundup = 'ORGANIC_ROUNDUP'
}

/**
 * Saved personal loans prequal offers include expanded marketplace offers,
 * expanded marketplace static offers, and prequal offers
 */
export type SavedPersonalLoansPrequalOffers = {
  __typename?: 'SavedPersonalLoansPrequalOffers';
  /**
   * Expanded marketplace offers are displayed to the user if they do not
   * prequalify for any offers; one provider may offer multiple expanded
   * marketplace offers
   */
  expandedMarketplaceOffers: Array<PersonalLoansOfferV2>;
  /**
   * Expanded marketplace static offers are displayed to the user if they do not
   * prequalify for any offers; one provider will only offer one static offer
   */
  expandedMarketplaceStaticOffers: Array<ExpandedMarketplaceStaticOffer>;
  /** Set to true if there is at least one prequalified offer the user is qualified for; this is false otherwise */
  hasPrequalifiedOffers: Scalars['Boolean'];
  /** Flag indicating if the user is prequalified for personal loans offers */
  isUserPrequalified: Scalars['Boolean'];
  /** List of personal loans providers */
  providers: Array<Provider>;
  /** API offers include prequal, high interest, and conditional offers */
  apiOffers: Array<PersonalLoansApiOffer>;
  /** Personal loan amount requested by the user */
  requestedLoanAmount: Scalars['Float'];
};

export type SavingsAccountInstitution = InstitutionInterface & {
  __typename?: 'SavingsAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type SavingsAccountOffer = OfferInterface & AccountOfferInterface & {
  __typename?: 'SavingsAccountOffer';
  endsAt?: Maybe<Scalars['DateTime']>;
  applyLink?: Maybe<Scalars['URL']>;
  apy?: Maybe<Scalars['Float']>;
  institution?: Maybe<SavingsAccountInstitution>;
  details?: Maybe<SavingsAccountOfferDetails>;
  imageUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  isMonetizing?: Maybe<Scalars['Boolean']>;
};

export type SavingsAccountOfferDetails = {
  __typename?: 'SavingsAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

export type SavingsAccountOffersByNamedQueryResponse = {
  __typename?: 'SavingsAccountOffersByNamedQueryResponse';
  offers?: Maybe<Array<SavingsAccountOffer>>;
};

export type SavingsAccountOffersResponse = {
  __typename?: 'SavingsAccountOffersResponse';
  offers: Array<SavingsAccountOffer>;
};

export type SearchServiceContentSearchResults = {
  __typename?: 'SearchServiceContentSearchResults';
  /** The facets from the search result, see 'Facets' */
  facets?: Maybe<Facets>;
  /** A list of related content given the parameters of ContentSearchInput */
  searchResults?: Maybe<Array<PostInterface>>;
  /** The current offset in results */
  offset?: Maybe<Scalars['Int']>;
  /** The total number of related content */
  total: Scalars['Int'];
};


export type SearchServiceContentSearchResultsSearchResultsArgs = {
  sortDir?: Maybe<ContentSortDirection>;
};

export type SecurityQuestionInfoInput = {
  /** The user's security question */
  question: Scalars['String'];
  /** The user's answer to their security question */
  answer: Scalars['String'];
};

export type SendResetPasswordEmailInfoInput = {
  /** The email used to send the password reset */
  email: Scalars['EmailAddress'];
};

export type SeoSettings = {
  __typename?: 'SeoSettings';
  /** The meta description for the content, used for SEO purposes. */
  description?: Maybe<Scalars['String']>;
  /** The custom JSON-LD schema to add to the existing JSON-LD generated for the content. */
  extraJsonLd?: Maybe<Scalars['JSON']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  facebook?: Maybe<SocialSeoSettings>;
  /** The focus keyword for the content, used for SEO purposes. */
  keyword?: Maybe<Scalars['String']>;
  /** Whether to instruct search engines like Google to not follow links in this content. */
  nofollow?: Maybe<Scalars['Boolean']>;
  /** Whether or not the content should be indexed in search engines like Google. */
  noindex?: Maybe<Scalars['Boolean']>;
  /** The meta title for the content, used for SEO purposes. */
  title?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  twitter?: Maybe<SocialSeoSettings>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'link' field on the parent Type instead. */
  canonical?: Maybe<Scalars['URL']>;
};

/** The info banner details derived from the feature flag payload, all fields required */
export type SitewideInfoBannerDetails = {
  __typename?: 'SitewideInfoBannerDetails';
  bannerName: Scalars['String'];
  btnText: Scalars['String'];
  copy: Scalars['String'];
  link: Scalars['URL'];
  title: Scalars['String'];
};

export type SitewideInfoBannerResponse = {
  __typename?: 'SitewideInfoBannerResponse';
  isEnabled: Scalars['Boolean'];
  details?: Maybe<SitewideInfoBannerDetails>;
};

/** A Small Medium Business Loans institution */
export type SmallMediumBusinessLoansInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'SmallMediumBusinessLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Small Medium Business Loans offer */
export type SmallMediumBusinessLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'SmallMediumBusinessLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /**
   * Whether this Offer is monetizing. Client apps use this field to decide display
   * behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA
   */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  product: SmallMediumBusinessLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /**
   * The list of disadvantages this offer provides, each item is a separate bullet
   * as structured content. Usually chosen by the Content team.
   */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The list of advantages this offer provides, each item is a separate bullet as
   * structured content. Usually chosen by the Content team.
   */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** The drivers associated with the entity */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Small Medium Business Loans product */
export type SmallMediumBusinessLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'SmallMediumBusinessLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: SmallMediumBusinessLoansInstitutionV2;
  /**
   * Name of the entity. Varies with the product type. Examples: `Ally Clearlane -
   * Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer
   */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type SocialSeoSettings = {
  __typename?: 'SocialSeoSettings';
  /** The description for the content as it should appear when this content is shared on Facebook. */
  description?: Maybe<Scalars['String']>;
  /** The title for the content as it should appear when this content is shared on Facebook. */
  title?: Maybe<Scalars['String']>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'featuredMedia' field on the parent Type instead. */
  image?: Maybe<Scalars['URL']>;
};

export type SpendingByMonthsDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'SpendingByMonthsDataVisualization';
  /** This will always be SPENDING_BY_MONTHS */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /**
   * The user's total spending on each day of the current month to the current date, and each day of the _previous_
   * month (e.g. if today is 6/17, this field would include spending data for 5/1-5/30 and 6/1-6/17).
   * 
   * Note that SpendingByMonthsDataVisualization utilizes the same type as the existing manifestation of this data
   * visualization in the Cash Flow product experience.
   */
  spendingByDateForTargetAndPriorMonthToDate: FinancialTransactionsSpendingByDayOfTheMonthForMonth;
};


export type SpendingByMonthsDataVisualizationSpendingByDateForTargetAndPriorMonthToDateArgs = {
  effectiveDate?: Maybe<Scalars['String']>;
};

export type SpendingByTopCategoriesDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'SpendingByTopCategoriesDataVisualization';
  /** This will always be SPENDING_BY_TOP_CATEGORIES */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /**
   * The user's top spending categories for the current month, to date.
   * 
   * Note that SpendingByTopCategoriesDataVisualization utilizes the same type as the existing manifestation of this data
   * visualization in the Cash Flow product experience.
   */
  topCategoriesBySpending: FinancialTransactionsTopCategoriesBySpending;
};


export type SpendingByTopCategoriesDataVisualizationTopCategoriesBySpendingArgs = {
  effectiveDate?: Maybe<Scalars['String']>;
};

export enum StateAbbreviationsEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** The `StatementIndexedFeedItem` type represents a generically typed item in the user's feed. */
export type StatementIndexedFeedItem = {
  __typename?: 'StatementIndexedFeedItem';
  statement: FeedStatement;
  cards: Array<FeedCard>;
};


/** Common interface Type for all explicit structured content page Types to implement */
export type StructuredContentPageInterface = {
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<Scalars['JSON']>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/** Student loans returned from student loan lenders and formatted */
export type StudentLoansApiOffer = {
  __typename?: 'StudentLoansApiOffer';
  loan_type: StudentLoansPrequalLoanType;
};

export enum StudentLoansPrequalLoanType {
  Fixed = 'FIXED',
  Variable = 'VARIABLE'
}

/** Input from the student loans prequal interface to be sent to providers */
export type StudentLoansPrequalOfferInput = {
  annual_income: Scalars['Int'];
  citizenship_status: PrequalCitizenshipStatusEnum;
  city: Scalars['String'];
  credit_score_bucket: Scalars['Int'];
  dob: Scalars['Date'];
  email: Scalars['EmailAddress'];
  employment_type: PrequalEmploymentTypeEnum;
  first_name: Scalars['String'];
  highest_degree_type: PrequalDegreeTypeEnum;
  highest_school_attended_id: Scalars['String'];
  highest_school_graduation_date: Scalars['Date'];
  housing_payment: Scalars['Int'];
  last_name: Scalars['String'];
  loan_amount: Scalars['Int'];
  logger_metadata?: Maybe<Scalars['JSON']>;
  refinance_goal: StudentLoansPrequalRefinanceGoalEnum;
  residence_ownership_type: PrequalResidencyOwnershipEnum;
  savings_and_assets: Scalars['Int'];
  state: Scalars['String'];
  ssn: Scalars['String'];
  street: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zip_code: Scalars['String'];
};

export enum StudentLoansPrequalProviderIdEnum {
  Citizensbank = 'CITIZENSBANK',
  Commonbond = 'COMMONBOND',
  Earnest = 'EARNEST',
  Elfi = 'ELFI',
  Lendkey = 'LENDKEY',
  Purefy = 'PUREFY',
  Sofi = 'SOFI'
}

export enum StudentLoansPrequalRefinanceGoalEnum {
  ReduceInterestCost = 'REDUCE_INTEREST_COST',
  ReduceInterestRate = 'REDUCE_INTEREST_RATE'
}

/**
 * The `SubscriptionIdentityProfile` type currently represents subscription_profile_v2 as mapped from
 * Identity. Not versioned to support future evolution of this type.
 */
export type SubscriptionIdentityProfile = {
  __typename?: 'SubscriptionIdentityProfile';
  emailEnabled?: Maybe<Scalars['Boolean']>;
  emailCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  emailProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  emailProgressUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  emailProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  emailMarketingEnabled?: Maybe<Scalars['Boolean']>;
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  pushEnabled?: Maybe<Scalars['Boolean']>;
  pushProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  pushCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  pushProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
};

/** Each enum entry should be synced with each available field in SubscriptionIdentityProfile. */
export enum SubscriptionTypeEnum {
  EmailEnabled = 'EMAIL_ENABLED',
  EmailCashBackRewardsEnabled = 'EMAIL_CASH_BACK_REWARDS_ENABLED',
  EmailProfileUpdatesEnabled = 'EMAIL_PROFILE_UPDATES_ENABLED',
  EmailSpendingAlertsEnabled = 'EMAIL_SPENDING_ALERTS_ENABLED',
  EmailProgressUpdatesEnabled = 'EMAIL_PROGRESS_UPDATES_ENABLED',
  EmailProductAnnouncementsEnabled = 'EMAIL_PRODUCT_ANNOUNCEMENTS_ENABLED',
  EmailMarketingEnabled = 'EMAIL_MARKETING_ENABLED',
  EmailCreditMonitoringEnabled = 'EMAIL_CREDIT_MONITORING_ENABLED',
  PushEnabled = 'PUSH_ENABLED',
  PushProductAnnouncementsEnabled = 'PUSH_PRODUCT_ANNOUNCEMENTS_ENABLED',
  PushSpendingAlertsEnabled = 'PUSH_SPENDING_ALERTS_ENABLED',
  PushCreditMonitoringEnabled = 'PUSH_CREDIT_MONITORING_ENABLED',
  PushCashBackRewardsEnabled = 'PUSH_CASH_BACK_REWARDS_ENABLED',
  PushProfileUpdatesEnabled = 'PUSH_PROFILE_UPDATES_ENABLED'
}

/** The Term interface for modeling terms within custom taxonomies. */
export type TermInterface = {
  /** The WordPress ID for this resource. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

/** The input for retrieving a single resource. */
export type TermItemInput = {
  /** The slug for the term or the WordPress ID. */
  identifier: Scalars['ID'];
};

export enum TopCategory {
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Dining = 'DINING',
  Entertainment = 'ENTERTAINMENT',
  Shopping = 'SHOPPING',
  Travel = 'TRAVEL'
}

export type TopInstitutionsForLinkingResponse = {
  __typename?: 'TopInstitutionsForLinkingResponse';
  /** The list of top institutions for the selected product type */
  institutions: Array<AccountAggregationInstitution>;
};

export type TrackingParam = {
  __typename?: 'TrackingParam';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Transaction = {
  __typename?: 'Transaction';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  baseType: Scalars['String'];
  canonicalMerchantId?: Maybe<Scalars['String']>;
  canonicalMerchantName?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  categoryType: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
  descriptionConsumer?: Maybe<Scalars['String']>;
  descriptionOriginal: Scalars['String'];
  descriptionSimple?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interest?: Maybe<Scalars['Float']>;
  merchantId?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['String']>;
  postedOrder?: Maybe<Scalars['String']>;
  runningBalance?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  subtype?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  transactionDate: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  yodleeAccountType: Scalars['String'];
  yodleeCategory: Scalars['String'];
  yodleeCategoryId: Scalars['Int'];
};

export type TransactionFetchResponse = {
  __typename?: 'TransactionFetchResponse';
  resultsSetToken: Scalars['String'];
  transactionsRefreshed: Scalars['Boolean'];
  transactions?: Maybe<Array<Maybe<Transaction>>>;
};

export type TransactionTagRule = {
  __typename?: 'TransactionTagRule';
  id: Scalars['String'];
  transactionId: Scalars['String'];
  category: Scalars['String'];
  merchantId?: Maybe<Scalars['String']>;
};

export enum TuCreditFactorBucket {
  Poor = 'POOR',
  Fair = 'FAIR',
  Good = 'GOOD'
}

/**
 * The `TuCreditReportIdentityProfile` represents a TransUnion Credit Report.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type TuCreditReportIdentityProfile = {
  __typename?: 'TuCreditReportIdentityProfile';
  avgAgeOfCredit?: Maybe<Scalars['Float']>;
  currentAddress: IdentityAddress;
  id?: Maybe<Scalars['String']>;
  inquiryDate?: Maybe<Scalars['Date']>;
  /**
   * The timestamp that this credit report was pulled at.
   * Example: `2019-07-26T14:38:01.589307Z`
   */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /**
   * The iterable timestamp the credit report was pulled at.
   * Example: `2017-01-31T09:09:21.162125Z`
   */
  reportPulledAtIterableDatetime?: Maybe<Scalars['DateTime']>;
  nextReportPullAt?: Maybe<Scalars['DateTime']>;
  isStale?: Maybe<Scalars['Boolean']>;
  safetyCheckPassed?: Maybe<Scalars['Boolean']>;
  /**
   * Flag for when NW data validation calculations of summary data fields do not match TU values.
   * Example: `false`
   */
  hasReportErrors?: Maybe<Scalars['Boolean']>;
  /**
   * A user's numerical credit score.
   * Example value: `830`
   */
  vantageScore3?: Maybe<Scalars['Int']>;
  /**
   * A word describing the user's credit bucket, based on their score.
   * Example value: `EXCELLENT`
   */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * The credit score percentile.
   * Example: `95`
   */
  creditScorePopulationRank?: Maybe<Scalars['Int']>;
  /**
   * The current credit score bin (a 10 point credit score range indexed
   * at the bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin?: Maybe<Scalars['Int']>;
  /**
   * The credit score bin 7 days ago (a 10 point credit score range indexed at the
   * bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin7Days?: Maybe<Scalars['Int']>;
  /**
   * The credit score bin 28 days ago (a 10 point credit score range indexed at the
   * bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin28Days?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent prior score
   * Example value: `-1`
   */
  vantageScore3Delta?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent score that is at least 7 days old
   * Example value: `-1`
   */
  vantageScore3Delta7Days?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent score that is at least 28 days old
   * Example value: `-1`
   */
  vantageScore3Delta28Days?: Maybe<Scalars['Int']>;
  /**
   * Credit score change since registration.
   * Example: `51`
   */
  vantageScore3DeltaSinceReg?: Maybe<Scalars['Int']>;
  /**
   * The bucket in which a user's credit score delta is in
   * Example value: `NO_CHANGE`
   */
  vantageScore3DeltaBucket?: Maybe<TuVantageScore3DeltaBuckets>;
  /**
   * A description of the directional change in the user's credit score since
   * the most recent prior credit score pull
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   * most recent prior credit score pull at least 7 days ago
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection7Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   * most recent prior credit score pull at least 28 days ago
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection28Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * Average age of open tradelines, in months, only for tradelines where open date can
   * be inferred (`date_opened_at_normalized`).
   * Example: `13.8`
   */
  nwAvgAgeOfCreditOpenMonths?: Maybe<Scalars['Float']>;
  /**
   * A description of the average age of open credit.
   * Example: `FAIR`
   */
  nwAvgAgeOfCreditOpenBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Count of tradelines with "current" or "unknown" pay status, for non-derogatory tradelines
   * (both open and closed).
   * Example: `5`
   */
  nwNumOntimeAccounts?: Maybe<Scalars['Int']>;
  /**
   * Count of tradelines with late pay status (1,2,3,4,5) in latest credit report,
   * for open derogatory tradelines (both open and closed).
   * Example: `4`
   */
  nwNumMissedPaymentsRecent?: Maybe<Scalars['Int']>;
  /**
   * A description of number of missed payments.
   * Example: `POOR`
   */
  nwNumMissedPaymentsRecentBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Percent utilization based on open revolving tradelines and line of credit tradelines,
   * where credit limit can be inferred.
   * Example: `0.954`
   */
  nwPercentUtilization?: Maybe<Scalars['Float']>;
  /**
   * A description of the percent utilization.
   * Example: `GOOD`
   */
  nwPercentUtilizationBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Total balances for only open tradelines.
   * Example: `5400`
   */
  nwSumBalancesOpen?: Maybe<Scalars['Float']>;
  /**
   * Total balances for credit utilization calculation, based on open tradelines
   * "revolving" or "line of credit" type, where normalized credit limit is available.
   * Example: `4000`
   */
  nwSumBalancesOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']>;
  /**
   * Total credit limit for credit utilization calculation, based on open tradelines
   * with "revolving" or "line of credit" type.
   * Example: `100000`
   */
  nwSumCreditLimitOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']>;
  /**
   * The number of inquiries in the past 2 years.
   * Example: `6`
   */
  numInquiries?: Maybe<Scalars['Int']>;
  /**
   * The number of inquiries in the past 2 years.
   * Always the same as `numInquiries`
   * Example: `6`
   */
  numRecentInquiries?: Maybe<Scalars['Int']>;
  numPublicRecords?: Maybe<Scalars['Int']>;
  numAccounts?: Maybe<Scalars['Int']>;
  numOpenAccounts?: Maybe<Scalars['Int']>;
  /**
   * The delta between the two most recent `num_open_accounts` fields.
   * Example: `0`
   */
  numOpenAccountsDelta?: Maybe<Scalars['Int']>;
  numClosedAccounts?: Maybe<Scalars['Int']>;
  numDelinquentAccounts?: Maybe<Scalars['Int']>;
  numDerogatoryAccounts?: Maybe<Scalars['Int']>;
  numCreditCardAccounts?: Maybe<Scalars['Int']>;
  numAutoLoanAccounts?: Maybe<Scalars['Int']>;
  numPersonalLoanAccounts?: Maybe<Scalars['Int']>;
  numStudentLoanAccounts?: Maybe<Scalars['Int']>;
  numMissedPayments?: Maybe<Scalars['Int']>;
  numMortgageAccounts?: Maybe<Scalars['Int']>;
  numHelocAccounts?: Maybe<Scalars['Int']>;
  numOtherLoanAccounts?: Maybe<Scalars['Int']>;
  numUtilityAccounts?: Maybe<Scalars['Int']>;
  numOtherAccounts?: Maybe<Scalars['Int']>;
  sumAgeOfCredit?: Maybe<Scalars['Float']>;
  /**
   * The delta between the two most recent `sum_age_of_credit` fields.
   * Example: `0`
   */
  sumAgeOfCreditDelta?: Maybe<Scalars['Float']>;
  /**
   * Total balances for open and closed tradelines.
   * Example: `16577`
   */
  sumBalances?: Maybe<Scalars['Float']>;
  sumRevolvingDebtBalances?: Maybe<Scalars['Float']>;
  sumAssetBackedDebtBalances?: Maybe<Scalars['Float']>;
  sumCreditCardBalances?: Maybe<Scalars['Float']>;
  sumAutoLoanBalances?: Maybe<Scalars['Float']>;
  sumPersonalLoanBalances?: Maybe<Scalars['Float']>;
  sumStudentLoanBalances?: Maybe<Scalars['Float']>;
  sumMortgageBalances?: Maybe<Scalars['Float']>;
  sumHelocBalances?: Maybe<Scalars['Float']>;
  sumOtherLoanBalances?: Maybe<Scalars['Float']>;
  sumUtilityBalances?: Maybe<Scalars['Float']>;
  sumOtherBalances?: Maybe<Scalars['Float']>;
  sumCreditCardLimits?: Maybe<Scalars['Float']>;
  sumAvailableCredit?: Maybe<Scalars['Float']>;
  sumMonthlyPayments?: Maybe<Scalars['Float']>;
  /**
   * The percentage of tradelines that have perfect payment history
   * Example: `0.8543`
   */
  percentOnTimePayments?: Maybe<Scalars['Float']>;
  /**
   * The delta between the two most recent `percent_on_time_payments` fields.
   * Example: `0`
   */
  percentOnTimePaymentsDelta?: Maybe<Scalars['Float']>;
  percentUtilization?: Maybe<Scalars['Float']>;
  percentUtilizationDelta?: Maybe<Scalars['Float']>;
  nwPercentUtilization28Days?: Maybe<Scalars['Float']>;
  nwNumOntimeAccounts28Days?: Maybe<Scalars['Int']>;
  numAccounts28Days?: Maybe<Scalars['Int']>;
  numDerogatoryAccounts28Days?: Maybe<Scalars['Int']>;
  numOpenAccounts28Days?: Maybe<Scalars['Int']>;
  numClosedAccounts28Days?: Maybe<Scalars['Int']>;
  nwSumBalancesOpen28Days?: Maybe<Scalars['Float']>;
  nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: Maybe<Scalars['Float']>;
  numInquiries28Days?: Maybe<Scalars['Int']>;
  nwAvgAgeOfCreditOpenMonths28Days?: Maybe<Scalars['Float']>;
  nwPercentUtilizationDelta28Days?: Maybe<Scalars['Float']>;
  nwNumOntimeAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numDerogatoryAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numOpenAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numClosedAccountsDelta28Days?: Maybe<Scalars['Int']>;
  nwSumBalancesOpenDelta28Days?: Maybe<Scalars['Float']>;
  nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: Maybe<Scalars['Float']>;
  numInquiriesDelta28Days?: Maybe<Scalars['Int']>;
  nwAvgAgeOfCreditOpenMonthsDelta28Days?: Maybe<Scalars['Float']>;
  tradelines?: Maybe<Array<Maybe<TuTradeline>>>;
  inquiries?: Maybe<Array<Maybe<TuInquiry>>>;
  employers?: Maybe<Array<Maybe<TuEmployer>>>;
  publicRecords?: Maybe<Array<Maybe<TuPublicRecord>>>;
};

/**
 * Employer information used by TransUnion.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/employer.py
 */
export type TuEmployer = {
  __typename?: 'TuEmployer';
  name?: Maybe<Scalars['String']>;
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  dateUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * A credit inquiry.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/inquiry.py
 */
export type TuInquiry = {
  __typename?: 'TuInquiry';
  /**
   * The name of the Canonical Institution that corresponds to subscriberName based on known tu_synonyms.
   * Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']>;
  subscriberName?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<Scalars['String']>;
  bureau?: Maybe<Scalars['String']>;
  inquiredAt?: Maybe<Scalars['DateTime']>;
  industry?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
};

/**
 * A public record.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/public_record.py
 */
export type TuPublicRecord = {
  __typename?: 'TuPublicRecord';
  courtName?: Maybe<Scalars['String']>;
  filedAt?: Maybe<Scalars['DateTime']>;
  referenceNumber?: Maybe<Scalars['String']>;
  subscriberCode?: Maybe<Scalars['String']>;
  bureau?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * A tradeline used by TU.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/tradeline.py
 */
export type TuTradeline = {
  __typename?: 'TuTradeline';
  /**
   * The name of the Canonical Institution that corresponds to creditorName based on known tu_synonyms.
   * Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  accountTypeSymbol?: Maybe<Scalars['String']>;
  accountSubtype?: Maybe<Scalars['String']>;
  accountSubtypeSymbol?: Maybe<Scalars['String']>;
  accountNumberLast4?: Maybe<Scalars['String']>;
  accountDesignator?: Maybe<Scalars['String']>;
  accountCondition?: Maybe<Scalars['String']>;
  openClosed?: Maybe<TuTradelineOpenClosed>;
  openClosedSymbol?: Maybe<TuTradelineOpenClosedSymbol>;
  highBalance?: Maybe<Scalars['Float']>;
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  dateClosedAt?: Maybe<Scalars['DateTime']>;
  dateOpenedAt?: Maybe<Scalars['DateTime']>;
  dateVerifiedAt?: Maybe<Scalars['DateTime']>;
  dateAccountStatus?: Maybe<Scalars['DateTime']>;
  currentBalance?: Maybe<Scalars['Float']>;
  creditorName?: Maybe<Scalars['String']>;
  bureau?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['Float']>;
  disputeFlag?: Maybe<Scalars['String']>;
  payStatus?: Maybe<Scalars['String']>;
  payStatusDescription?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  paymentFrequency?: Maybe<Scalars['String']>;
  worstPayStatus?: Maybe<Scalars['String']>;
  worstPayStatusSymbol?: Maybe<Scalars['String']>;
  amountPastDue?: Maybe<Scalars['Float']>;
  collateral?: Maybe<Scalars['String']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  late30Count?: Maybe<Scalars['Int']>;
  late60Count?: Maybe<Scalars['Int']>;
  late90Count?: Maybe<Scalars['Int']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
  monthsReviewed?: Maybe<Scalars['Int']>;
  termMonths?: Maybe<Scalars['Int']>;
  worstPayStatusCount?: Maybe<Scalars['Int']>;
  payHistoryStatus?: Maybe<Scalars['String']>;
  payHistoryStartDate?: Maybe<Scalars['DateTime']>;
  payHistoryBreakDown?: Maybe<Array<TuTradelinePayment>>;
  subscriberCodeHash?: Maybe<Scalars['String']>;
  accountNumberHash?: Maybe<Scalars['String']>;
  creditType?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  nwCreditLimitNormalized?: Maybe<Scalars['Float']>;
  nwUtilizationPct?: Maybe<Scalars['Float']>;
  nwDateOpenedAtNormalized?: Maybe<Scalars['DateTime']>;
  nwMonthsOpened?: Maybe<Scalars['Int']>;
  derogatoryTradelineReason?: Maybe<Scalars['String']>;
  payStatusSymbol?: Maybe<Scalars['String']>;
  nwPayStatusBucket?: Maybe<Scalars['String']>;
  nwLastMissedPaymentDate?: Maybe<Scalars['DateTime']>;
  isIncludedInUtilization?: Maybe<Scalars['Boolean']>;
};

export enum TuTradelineOpenClosed {
  Open = 'Open',
  Closed = 'Closed'
}

export enum TuTradelineOpenClosedSymbol {
  O = 'O',
  C = 'C'
}

export type TuTradelinePayment = {
  __typename?: 'TuTradelinePayment';
  status: Scalars['String'];
  date: Scalars['String'];
};

export enum TuVantageScore3Buckets {
  Excellent = 'EXCELLENT',
  Average = 'AVERAGE',
  Good = 'GOOD',
  Poor = 'POOR'
}

export enum TuVantageScore3ChangeDirections {
  Increase = 'INCREASE',
  Nochange = 'NOCHANGE',
  Decrease = 'DECREASE'
}

export enum TuVantageScore3DeltaBuckets {
  SmallIncrease = 'SMALL_INCREASE',
  LargeIncrease = 'LARGE_INCREASE',
  SmallDecrease = 'SMALL_DECREASE',
  LargeDecrease = 'LARGE_DECREASE',
  NoChange = 'NO_CHANGE'
}

export type UnsafeEntityPlacementDriver = EntityPlacementDriverInterface & {
  __typename?: 'UnsafeEntityPlacementDriver';
  /** The driver description */
  description?: Maybe<Scalars['StructuredContentDocument']>;
  /** The driver label */
  label: Scalars['String'];
  /** The tooltip associated with the driver label */
  labelTooltip?: Maybe<Scalars['String']>;
  /** The driver value */
  value?: Maybe<Scalars['StructuredContentDocument']>;
  /**
   * The legacy driver tooltip
   * @deprecated This field is only used for `EducationLoansOfferV2` as it has HTML in its tooltip. It should be migrated to a StructuredContent compatible service and resolved into `tooltip`.
   */
  unsafeTooltip?: Maybe<Scalars['String']>;
};

export type UpdateFinancialMerchantTransactionCategoryResponse = {
  __typename?: 'UpdateFinancialMerchantTransactionCategoryResponse';
  success: Scalars['Boolean'];
};

/** The expected input for the `updateIncome` mutation */
export type UpdateIncomeInput = {
  annualIncome?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
};

export type UpdateIncomeResponse = {
  __typename?: 'UpdateIncomeResponse';
  success: Scalars['Boolean'];
  annualIncome?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
};

/** The expected input for the `updateName` mutation */
export type UpdateNameInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type UpdateNameResponse = {
  __typename?: 'UpdateNameResponse';
  success: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

/** The expected data shape of the updateNetWorthAccountVisibility mutation response */
export type UpdateNetWorthAccountVisibilityResponse = {
  __typename?: 'UpdateNetWorthAccountVisibilityResponse';
  account: NetWorthAccount;
};

/** Wraps the update net worth real API response, which allows for adding fields at a later date */
export type UpdateNetWorthRealAssetResponse = {
  __typename?: 'UpdateNetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

export type UpdatePasswordInfoInput = {
  /** The user's old password before the update */
  oldPassword: Scalars['String'];
  /** The user's new password after the update */
  newPassword: Scalars['String'];
};

/**
 * The expected payload for the `updateSubscriptionProfile` mutation,
 * should be synced with SubscriptionIdentityProfile.
 */
export type UpdateSubscriptionProfileInput = {
  emailEnabled?: Maybe<Scalars['Boolean']>;
  emailCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  emailProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  emailProgressUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  emailProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  emailMarketingEnabled?: Maybe<Scalars['Boolean']>;
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  pushEnabled?: Maybe<Scalars['Boolean']>;
  pushProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  pushCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  pushProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
};


/** Input Type for accepting URL params for a query */
export type UrlParamsInput = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecord = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'UrlRecord';
  /**
   * The topic that should be used as the 'Attribution Topic' for this piece of
   * content. This value is used for attributing metrics related to this piece of
   * content in analytics reports.
   */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the UrlRecord object. */
  categories?: Maybe<Array<Category>>;
  /** The content clusters for this piece of content. Content clusters are meant to be arbitrary groupings of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The WordPress ID for the resource. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content field for this URL record. */
  primaryContent?: Maybe<Scalars['StructuredContentDocument']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The full URL for this record. */
  url?: Maybe<Scalars['URL']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordDateArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordModifiedArgs = {
  format?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordTitleArgs = {
  format?: Maybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type UrlRecordConnectionResponse = {
  __typename?: 'UrlRecordConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The UrlRecord returned for the connection. */
  items?: Maybe<Array<UrlRecord>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of UrlRecord objects. */
export type UrlRecordFilterInput = {
  /** Limit collection to UrlRecords published by particular authors, or not published by particular authors. */
  authorIds?: Maybe<IdFilterInput>;
  /** Limit collection to UrlRecords within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: Maybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: Maybe<Scalars['String']>;
  /** Limit collection to UrlRecords with or without specific ID's. */
  ids?: Maybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Limit collection to UrlRecords with a specific slug or multiple slugs. */
  slugs?: Maybe<Array<Scalars['String']>>;
};

/**
 * A UserAction is anything that the user might do in response to an insight.  At their simplest, they are just a raw
 * AppAction (e.g., a simple CTA that navigates to an L2), but can be augmented with additional context or even bespoke
 * data visualizations.
 */
export type UserAction = {
  __typename?: 'UserAction';
  /**
   * A human-readable identifier for a particular user action.  Primarily used for analytics.
   * 
   * Example: credit-score-pay-off-account-early
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * Language that summarizes or introduces the UserAction.
   * 
   * This is *not* the CTA text -- that should be supplied in appAction.text
   */
  title?: Maybe<Scalars['String']>;
  /**
   * Language that describes the UserAction in detail.
   * 
   * This is *not* the CTA text -- that should be supplied in appAction.text
   */
  body?: Maybe<Scalars['String']>;
  /** The mechanical action to be performed in the app when the user engages with this UserAction */
  appAction: AppAction;
};

export enum UserFinancialTransactionRuleType {
  Category = 'CATEGORY',
  Hide = 'HIDE',
  Tag = 'TAG'
}

/**
 * UserInsightDataVisualizationInterface must be implemented by a concrete type that contains all the data necessary to
 * render a specific data visualization.
 */
export type UserInsightDataVisualizationInterface = {
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/** UserInsightDataVisualizationTypeEnum represents all possible data visualizations that might appear with an insight */
export enum UserInsightDataVisualizationTypeEnum {
  /** A visualization of the user's spending in the current month, by the top categories */
  SpendingByTopCategories = 'SPENDING_BY_TOP_CATEGORIES',
  /**
   * A visualization of the user's total spending in the current month to date vs. their total spending as of the same
   * date in the previous month
   */
  SpendingByMonths = 'SPENDING_BY_MONTHS',
  /** A visualization for credit score activation */
  CreditScoreActivation = 'CREDIT_SCORE_ACTIVATION',
  /** A visualization for financial account(s) activation */
  FinancialAccountsActivation = 'FINANCIAL_ACCOUNTS_ACTIVATION',
  /** A visualization of the user's credit score change */
  WhyDidMyScoreChange = 'WHY_DID_MY_SCORE_CHANGE',
  /** A visualization of the user's potential score change */
  CreditBooster = 'CREDIT_BOOSTER',
  /** A visualization for My Cards activation */
  MyCardsActivation = 'MY_CARDS_ACTIVATION'
}

/** UserInsightEligibleModulesEnum represents all possible eligible modules */
export enum UserInsightEligibleModulesEnum {
  /** Indicates the insight is eligible for the why did my score change module */
  WhyDidMyScoreChange = 'WHY_DID_MY_SCORE_CHANGE',
  /** Indicates the insight is eligible for the credit booster module */
  CreditBooster = 'CREDIT_BOOSTER',
  /** Indicates the insight is eligible for the member home module */
  MemberHome = 'MEMBER_HOME',
  /** Indicates the insight is eligible for the credit score UI&A module */
  CreditScore = 'CREDIT_SCORE',
  /** Indicates the insight is eligible for the cash flow UI&A module */
  CashFlow = 'CASH_FLOW',
  /** Indicates the insight is eligible for the net worth UI&A module */
  NetWorth = 'NET_WORTH',
  /** Indicates the insight is eligible for the member home activation UI&A module */
  MemberHomeActivationHooks = 'MEMBER_HOME_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the credit score activation UI&A module */
  CreditScoreActivationHooks = 'CREDIT_SCORE_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the Moment of Delight module at the end of TU Activation */
  TuActivationComplete = 'TU_ACTIVATION_COMPLETE'
}

/**
 * This field encapsulates the concept of an increase or gain to a user’s personal finances.
 * 
 * This could range from credit score increases to an increase in savings or debt.
 */
export type UserInsightGain = {
  __typename?: 'UserInsightGain';
  /** Represents the minimum gain from this user insight */
  minGain: Scalars['Float'];
  /** Represents the maximum gain from this user insight */
  maxGain: Scalars['Float'];
  /** Represents the type of gain from this user insight */
  gainUnit: UserInsightGainUnitEnum;
  /** Describes the gain impact */
  description: Scalars['String'];
};

/**
 * "
 * UserInsightGainUnitEnum represents all possible gain units for user insights
 */
export enum UserInsightGainUnitEnum {
  /** Indicates the unit for gain is points */
  CreditScorePoints = 'CREDIT_SCORE_POINTS'
}

/**
 * A "user insight" is something noteworthy or interesting that NerdWallet has identified about the user.
 * 
 * Examples include:
 * - Your credit score changed this week -- here's why
 * - How your cash flow compares to the same day last month
 * - Your monthly spending breakdown by category
 * - You have too much money in your checking account -- consider moving some to a high-yield savings account
 * 
 * There are several insight inventory sources, each with a bespoke data model.  This interface represents the fields
 * that are common across each inventory source.
 */
export type UserInsightInterface = {
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   * 
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   * 
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   * 
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   * 
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   * 
   * For exmaple, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   * 
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   * 
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   * 
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   * 
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

/** UserInsightInventorySourceEnum represents all possible sources of truth for user insights. */
export enum UserInsightInventorySourceEnum {
  /**
   * Some insights are derived on-demand by credit-serivce; specifically, an activation UI&A for user's who have not
   * yet linked TU
   */
  CreditService = 'CREDIT_SERVICE',
  /**
   * Some insights are derived from Wordpress entities (e.g. FeedCardInsights).  Note that the inventory source for
   * such insights is the CMS, not the intermediary service by which they were retrieved (e.g. the feed service).
   */
  Wordpress = 'WORDPRESS',
  /**
   * Some insights are generated on-demand by recommendation-service.  Note that the inventory source for such insights
   * is recommendation-service, not the intermediary orchestration layer through which they were retrieved (e.g.
   * Factory)
   */
  RecommendationService = 'RECOMMENDATION_SERVICE',
  /**
   * Some insights are generated on-demand by financial-insights service. Note that the inventory source for such insights
   * is financial-insights service, not FDP which is where the data that determines the UI&A is derived
   */
  FinancialInsightsService = 'FINANCIAL_INSIGHTS_SERVICE',
  /** Some insights are generated on-demand by my-cards-service */
  MyCardsService = 'MY_CARDS_SERVICE'
}

/** The personalized ranking score that was used to rank this insight. */
export type UserInsightPersonalizedRankingScore = {
  __typename?: 'UserInsightPersonalizedRankingScore';
  /**
   * The model execution IDs that were involved in producing the user's personalized ranking score for this insight.
   * These should all be included in analytics events for this insight.
   * 
   * Includes:
   * - A model execution ID that indicates which ML model produced this ranking score
   * - A model execution ID that indicates which _variant_ of the ML model produced this ranking score
   */
  modelExecutionIds: Array<Scalars['String']>;
  /**
   * A measure of how compelling this particular insight is to this particular user.  Used as an input into ranking
   * decisions.  Takes a value from 0 to 1.
   */
  score: Scalars['Float'];
};

/**
 * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
 * treatment (e.g. red vs. yellow vs. blue accent color).
 */
export enum UserInsightSentimentEnum {
  /** Indicates that the insight is beneficial for the user (e.g., their paycheck was deposited) */
  Positive = 'POSITIVE',
  /** Indicates that the insight is neither inherently beneficial nor cautionary */
  Neutral = 'NEUTRAL',
  /**
   * Indicates that the insight is potentially (but not necessarily) harmful for the user (e.g., a hard credit pull or
   * detection of a large transaction)
   */
  Cautionary = 'CAUTIONARY'
}

export type UserInsightsFilterInput = {
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /** If specified, only include insights at or above this level of urgency.  Ranges from 0 to 1. */
  minUrgency?: Maybe<Scalars['Float']>;
  /** If specified, only include insights at or below this level of urgency.  Ranges from 0 to 1. */
  maxUrgency?: Maybe<Scalars['Float']>;
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** If specified, exclude insights with matching slugs */
  ineligibleInsightSlugs?: Maybe<Array<Scalars['String']>>;
};

export type UserInsightsResponse = {
  __typename?: 'UserInsightsResponse';
  userInsights: Array<UserInsightInterface>;
};

/** A non-actionable suggestion related to a UserInsight */
export type UserInsightTip = {
  __typename?: 'UserInsightTip';
  /** The label under which the tip appears (e.g. "Nerdy Tip") */
  label?: Maybe<Scalars['String']>;
  /** Language that describes the tip in detail */
  description: Scalars['String'];
};

/** This type holds a subset of fields from the portal_activity_occurred event that is relevant for User Ops. */
export type UserOpsPaoEventDetails = {
  __typename?: 'UserOpsPAOEventDetails';
  /** The activity type that happened (such as linking_process_error). */
  activityType?: Maybe<Scalars['String']>;
  /** Authentication state of the portal. */
  authState?: Maybe<FinancialPortalAuthState>;
  /** When this event occurred */
  eventOccurredAt: Scalars['DateTime'];
  /** app-schemata definition: The raw error payload from FDP Proxy. */
  fdpPrimaryErrorBlob?: Maybe<UserOpsPaoEventDetailsError>;
  /** app-schemata definition: The associated Plaid event_name. */
  plaidEventName?: Maybe<Scalars['String']>;
  /** app-schemata definition: Plaid's link_session_idZ. */
  plaidLinkSessionId?: Maybe<Scalars['ID']>;
  /** app-schemata definition: Plaid's request_id. */
  plaidRequestId?: Maybe<Scalars['String']>;
  /** ID of the portal for which this event was fired */
  portalId?: Maybe<Scalars['ID']>;
  /**
   * app-schemata definition: The identifier of the institution as defined in the underlying source,
   * i.e. plaid_id or yodlee_id.
   */
  sourceInstitutionId?: Maybe<Scalars['String']>;
};

/** This type represents the error blob inside the portal_activity_occurred event. */
export type UserOpsPaoEventDetailsError = {
  __typename?: 'UserOpsPAOEventDetailsError';
  /** The error code from Plaid. */
  errorCode?: Maybe<Scalars['String']>;
  /** The error message from Plaid. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The error type from Plaid. */
  errorType?: Maybe<Scalars['String']>;
};

export type UserReportedCreditCardInput = {
  cardId: Scalars['Int'];
  cardName: Scalars['String'];
};

export type UserReportedCreditCardsResult = {
  __typename?: 'UserReportedCreditCardsResult';
  /** User self-reported list of credit cards */
  cards?: Maybe<Array<RewardsCreditCard>>;
};

/**
 * The `UserReportedFinancialAccount` type represents a financial
 * account queried as part of the Financial Identity Profile
 */
export type UserReportedFinancialAccount = {
  __typename?: 'UserReportedFinancialAccount';
  id?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  ccExtraData?: Maybe<Scalars['JSON']>;
  yodleeFk?: Maybe<Scalars['String']>;
  marketplaceFk?: Maybe<Scalars['String']>;
  transunionFk?: Maybe<Scalars['String']>;
  tuTradelineCompositeKey?: Maybe<Scalars['String']>;
  institutionFk?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  currentValue?: Maybe<Scalars['Float']>;
};

/** A set of facts related to user's average monthly spending over ~3-month period */
export type UserSpendingByCategoryThreeMonthAverage = {
  __typename?: 'UserSpendingByCategoryThreeMonthAverage';
  /** User's TU credit score */
  creditScore?: Maybe<Scalars['Int']>;
  /** User's average monthly spending on outstanding debts */
  debtPayment?: Maybe<Scalars['Float']>;
};

export type Variant = {
  __typename?: 'Variant';
  variantId: Scalars['String'];
  variantName: Scalars['String'];
  customData?: Maybe<Scalars['JSON']>;
};

export type WebFeatureDiscoveryDetails = {
  __typename?: 'WebFeatureDiscoveryDetails';
  title?: Maybe<Scalars['String']>;
  copy: Scalars['String'];
  destinationUrl: Scalars['String'];
  featuredImageUrl: Scalars['URL'];
  featureName: Scalars['String'];
};

export type WhyDidMyScoreChangeDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'WhyDidMyScoreChangeDataVisualization';
  /** This will always be WHY_DID_MY_SCORE_CHANGE */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /** User's current credit score info */
  creditScoreChangeInfo: CreditScoreChangeInfo;
};

/** The input type representing the Yak message to be published */
export type YakMessageInput = {
  /**
   * The Yak exchange to which the message should be delivered.  Supplied on the message envelope.
   * 
   * Example: `ANALYTIC_PIPELINE_MOUTH`
   */
  exchangeId: Scalars['String'];
  /**
   * The Yak message type.  Supplied on the message envelope.
   * 
   * Example: `navigate` (for a navigation analytics event)
   */
  type?: Maybe<Scalars['String']>;
  /** The Yak message subtype.  Supplied on the message envelope. */
  subType?: Maybe<Scalars['String']>;
  /** The Yak message payload */
  payload?: Maybe<Scalars['JSON']>;
};

export type AdvertiserDisclosureFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'showAdvertiserDisclosure'>
  & { disclosureType: Article['advertiserDisclosureType'] }
);

export type AuthorDetailsFragment = (
  { __typename?: 'Author' }
  & Pick<Author, 'contactEmail' | 'facebook' | 'name' | 'link' | 'slug' | 'tagline' | 'twitter'>
  & { avatarUrls?: Maybe<Array<(
    { __typename?: 'AuthorAvatarUrl' }
    & Pick<AuthorAvatarUrl, 'url'>
  )>> }
);

export type AuthorBoxFragment = (
  { __typename?: 'Article' }
  & { authors?: Maybe<Array<(
    { __typename?: 'Author' }
    & AuthorDetailsFragment
  )>> }
);

export type BlockGroupFragment = (
  { __typename?: 'BlockGroup' }
  & Pick<BlockGroup, 'id'>
  & { blocks?: Maybe<Array<Maybe<(
    { __typename?: 'CombinedBlockGroupBlock' }
    & BlockFragment
  )>>> }
);

export type BlockFragment = (
  { __typename?: 'CombinedBlockGroupBlock' }
  & Pick<CombinedBlockGroupBlock, 'type' | 'title' | 'data'>
);

export type ContentPageHeaderFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'hideDate' | 'showLastModifiedDate'>
  & WordPressContentPageHeader_Article_Fragment
);

export type EditorialStandardsFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'showEditorialDisclaimer'>
  & { disclaimerType: Article['editorialDisclaimerType'] }
);

export type HouseAdFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'articleType'>
  & { houseAd?: Maybe<(
    { __typename?: 'HouseAd' }
    & Pick<HouseAd, 'id'>
  )> }
);

export type MethodologyFragment = (
  { __typename?: 'Article' }
  & { methodology?: Maybe<(
    { __typename?: 'Block' }
    & Pick<Block, 'content'>
  )> }
);

export type NextStepsFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'id' | 'articleType'>
  & { nextSteps?: Maybe<(
    { __typename?: 'BlockGroup' }
    & BlockGroupFragment
  )>, primaryCategory?: Maybe<(
    { __typename?: 'Category' }
    & Pick<Category, 'name' | 'link'>
  )> }
);

export type RelatedLinksFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'id' | 'articleType'>
  & { relatedLinks?: Maybe<(
    { __typename?: 'BlockGroup' }
    & BlockGroupFragment
  )>, primaryCategory?: Maybe<(
    { __typename?: 'Category' }
    & Pick<Category, 'name' | 'link'>
  )> }
);

export type BreadcrumbFragment = (
  { __typename?: 'Article' }
  & { breadcrumb?: Maybe<(
    { __typename?: 'Breadcrumb' }
    & Pick<Breadcrumb, 'slug'>
    & { page?: Maybe<(
      { __typename?: 'BreadcrumbPage' }
      & Pick<BreadcrumbPage, 'title'>
    )> }
  )> }
);

export type ArticleFragmentFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'id' | 'isPublished' | 'articleType' | 'title' | 'slug' | 'pageTaxonomy' | 'content' | 'link' | 'showEditorialDisclaimer' | 'showAuthorBox' | 'contentClusters' | 'hideFeaturedImage'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'extraJsonLd'>
  )>, featuredImage?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id' | 'altText'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height' | 'size'>
      )>> }
    )> }
  )> }
  & NextStepsFragment
  & RelatedLinksFragment
  & AuthorBoxFragment
  & ContentPageHeaderFragment
  & MethodologyFragment
  & HouseAdFragment
  & GetArticleCanonicalUrlFragment
  & GetNerdlayoutDynamicOptions_Article_Fragment
  & GetArticleSchemaFragment
  & GetAbTestConfigFragment
  & AdvertiserDisclosureFragment
  & EditorialStandardsFragment
  & BreadcrumbFragment
);

export type ArticleQueryVariables = Exact<{
  identifier: Scalars['ID'];
  wpnonce?: Maybe<Scalars['ID']>;
}>;


export type ArticleQuery = (
  { __typename?: 'Query' }
  & { article?: Maybe<(
    { __typename?: 'Article' }
    & ArticleFragmentFragment
  )> }
);

export type ArticleForkQueryVariables = Exact<{
  identifier: Scalars['ID'];
  wpnonce?: Maybe<Scalars['String']>;
  forkPreview?: Maybe<Scalars['Boolean']>;
  forkIdentifier: Scalars['Int'];
  forkNonce?: Maybe<Scalars['String']>;
}>;


export type ArticleForkQuery = (
  { __typename?: 'Query' }
  & { articleFork?: Maybe<(
    { __typename?: 'Article' }
    & ArticleFragmentFragment
  )> }
);

export type GetAbTestConfigFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'articleType'>
);

export type GetArticleCanonicalUrlFragment = (
  { __typename?: 'Article' }
  & Pick<Article, 'link'>
);

export type GetArticleSchemaFragment = (
  { __typename: 'Article' }
  & Pick<Article, 'id' | 'link' | 'modified' | 'date'>
  & { featuredMediaForJsonLd?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'size' | 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
  & GetAuthorSchemaFragment
  & GetEditorSchemaFragment
  & GetAboutSchemaFragment
);

export type GetArticleSchemaQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type GetArticleSchemaQuery = (
  { __typename?: 'Query' }
  & { article?: Maybe<(
    { __typename?: 'Article' }
    & GetArticleSchemaFragment
  )> }
);

export type GetAuthorSchemaFragment = (
  { __typename: 'Article' }
  & { authors?: Maybe<Array<(
    { __typename?: 'Author' }
    & Pick<Author, 'id' | 'name' | 'link' | 'alumniOf' | 'affiliation' | 'award' | 'honorificSuffix' | 'jobTitle' | 'specialties'>
    & { avatarUrls?: Maybe<Array<(
      { __typename?: 'AuthorAvatarUrl' }
      & Pick<AuthorAvatarUrl, 'size' | 'url'>
    )>> }
  )>> }
);

export type GetEditorSchemaFragment = (
  { __typename: 'Article' }
  & { assigningEditor?: Maybe<(
    { __typename?: 'Author' }
    & Pick<Author, 'id' | 'name' | 'link' | 'alumniOf' | 'affiliation' | 'award' | 'honorificSuffix' | 'jobTitle' | 'specialties'>
    & { avatarUrls?: Maybe<Array<(
      { __typename?: 'AuthorAvatarUrl' }
      & Pick<AuthorAvatarUrl, 'size' | 'url'>
    )>> }
  )> }
);

export type GetAboutSchemaFragment = (
  { __typename: 'Article' }
  & { categories?: Maybe<Array<(
    { __typename?: 'Category' }
    & Pick<Category, 'name'>
  )>> }
);

export type GetAuthorSchemaQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type GetAuthorSchemaQuery = (
  { __typename?: 'Query' }
  & { article?: Maybe<(
    { __typename?: 'Article' }
    & GetAuthorSchemaFragment
  )> }
);

export type GetAboutSchemaQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type GetAboutSchemaQuery = (
  { __typename?: 'Query' }
  & { article?: Maybe<(
    { __typename?: 'Article' }
    & GetAboutSchemaFragment
  )> }
);

export type GetItemListSchemaFragment = (
  { __typename?: 'Roundup' }
  & Pick<Roundup, 'link' | 'marketplaceProductType' | 'titleWithoutEntityCount'>
);

type WordPressContentPageHeader_Article_Fragment = (
  { __typename: 'Article' }
  & Pick<Article, 'advertiserDisclosureType' | 'id' | 'showAdvertiserDisclosure' | 'showAuthorByline' | 'showEditorialDisclaimer' | 'title'>
  & { dateTimeDisplayDate: Article['displayDate'], stringSynopsis: Article['synopsis'] }
  & { authors?: Maybe<Array<(
    { __typename?: 'Author' }
    & Pick<Author, 'name' | 'link'>
  )>>, primaryCategory?: Maybe<(
    { __typename?: 'Category' }
    & Pick<Category, 'name'>
  )> }
);

type WordPressContentPageHeader_Roundup_Fragment = (
  { __typename: 'Roundup' }
  & Pick<Roundup, 'eyebrowText' | 'advertiserDisclosureType' | 'id' | 'showAdvertiserDisclosure' | 'showAuthorByline' | 'showEditorialDisclaimer' | 'title'>
  & { formattedDisplayDate: Roundup['displayDate'], structuredContentSynopsis: Roundup['synopsis'] }
  & { authors?: Maybe<Array<(
    { __typename?: 'Author' }
    & Pick<Author, 'name' | 'link'>
  )>>, primaryCategory?: Maybe<(
    { __typename?: 'Category' }
    & Pick<Category, 'name'>
  )> }
);

export type WordPressContentPageHeaderFragment = WordPressContentPageHeader_Article_Fragment | WordPressContentPageHeader_Roundup_Fragment;

type GetPageTaxonomyData_Article_Fragment = (
  { __typename: 'Article' }
  & Pick<Article, 'pageTaxonomy'>
);

type GetPageTaxonomyData_Review_Fragment = (
  { __typename: 'Review' }
  & Pick<Review, 'pageTaxonomy'>
);

type GetPageTaxonomyData_Roundup_Fragment = (
  { __typename: 'Roundup' }
  & Pick<Roundup, 'pageTaxonomy'>
);

export type GetPageTaxonomyDataFragment = GetPageTaxonomyData_Article_Fragment | GetPageTaxonomyData_Review_Fragment | GetPageTaxonomyData_Roundup_Fragment;

type GetNerdlayoutDynamicOptions_ContentPack_Fragment = (
  { __typename: 'ContentPack' }
  & Pick<ContentPack, 'id' | 'type' | 'link'>
);

type GetNerdlayoutDynamicOptions_Banner_Fragment = (
  { __typename: 'Banner' }
  & Pick<Banner, 'id' | 'type' | 'link'>
);

type GetNerdlayoutDynamicOptions_BlockGroup_Fragment = (
  { __typename: 'BlockGroup' }
  & Pick<BlockGroup, 'id' | 'type' | 'link'>
);

type GetNerdlayoutDynamicOptions_HouseAd_Fragment = (
  { __typename: 'HouseAd' }
  & Pick<HouseAd, 'id' | 'type' | 'link'>
  & { featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_MediaItem_Fragment = (
  { __typename: 'MediaItem' }
  & Pick<MediaItem, 'id' | 'type' | 'link'>
);

type GetNerdlayoutDynamicOptions_Article_Fragment = (
  { __typename: 'Article' }
  & Pick<Article, 'synopsis' | 'id' | 'type' | 'link'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'title' | 'description' | 'nofollow' | 'noindex' | 'keyword'>
    & { facebook?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description'>
    )>, twitter?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description' | 'image'>
    )> }
  )>, featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
  & GetPageTaxonomyData_Article_Fragment
);

type GetNerdlayoutDynamicOptions_Block_Fragment = (
  { __typename: 'Block' }
  & Pick<Block, 'id' | 'type' | 'link'>
);

type GetNerdlayoutDynamicOptions_Hub_Fragment = (
  { __typename: 'Hub' }
  & Pick<Hub, 'id' | 'type' | 'link'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'title' | 'description' | 'nofollow' | 'noindex' | 'keyword'>
    & { facebook?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description'>
    )>, twitter?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description' | 'image'>
    )> }
  )>, featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_LandingPage_Fragment = (
  { __typename: 'LandingPage' }
  & Pick<LandingPage, 'id' | 'type' | 'link'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'title' | 'description' | 'nofollow' | 'noindex' | 'keyword'>
    & { facebook?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description'>
    )>, twitter?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description' | 'image'>
    )> }
  )>, featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_Page_Fragment = (
  { __typename: 'Page' }
  & Pick<Page, 'id' | 'type' | 'link'>
  & { featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_Post_Fragment = (
  { __typename: 'Post' }
  & Pick<Post, 'id' | 'type' | 'link'>
  & { featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_Review_Fragment = (
  { __typename: 'Review' }
  & Pick<Review, 'id' | 'type' | 'link'>
  & { featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
  & GetPageTaxonomyData_Review_Fragment
);

type GetNerdlayoutDynamicOptions_Roundup_Fragment = (
  { __typename: 'Roundup' }
  & Pick<Roundup, 'id' | 'type' | 'link'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'title' | 'description' | 'nofollow' | 'noindex' | 'keyword'>
    & { facebook?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description'>
    )>, twitter?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description' | 'image'>
    )> }
  )>, featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
  & GetPageTaxonomyData_Roundup_Fragment
);

type GetNerdlayoutDynamicOptions_LegacyLender_Fragment = (
  { __typename: 'LegacyLender' }
  & Pick<LegacyLender, 'id' | 'type' | 'link'>
  & { featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_UrlRecord_Fragment = (
  { __typename: 'UrlRecord' }
  & Pick<UrlRecord, 'id' | 'type' | 'link'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'title' | 'description' | 'nofollow' | 'noindex' | 'keyword'>
    & { facebook?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description'>
    )>, twitter?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description' | 'image'>
    )> }
  )>, featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_ContentSearchResult_Fragment = (
  { __typename: 'ContentSearchResult' }
  & Pick<ContentSearchResult, 'id' | 'type' | 'link'>
  & { featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

type GetNerdlayoutDynamicOptions_EngineeringPost_Fragment = (
  { __typename: 'EngineeringPost' }
  & Pick<EngineeringPost, 'id' | 'type' | 'link'>
  & { seo?: Maybe<(
    { __typename?: 'SeoSettings' }
    & Pick<SeoSettings, 'title' | 'description' | 'nofollow' | 'noindex' | 'keyword'>
    & { facebook?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description'>
    )>, twitter?: Maybe<(
      { __typename?: 'SocialSeoSettings' }
      & Pick<SocialSeoSettings, 'title' | 'description' | 'image'>
    )> }
  )>, featuredMedia?: Maybe<(
    { __typename?: 'MediaItem' }
    & Pick<MediaItem, 'id'>
    & { mediaDetails?: Maybe<(
      { __typename?: 'MediaDetails' }
      & Pick<MediaDetails, 'id'>
      & { sizes?: Maybe<Array<(
        { __typename?: 'MediaSize' }
        & Pick<MediaSize, 'sourceUrl' | 'width' | 'height'>
      )>> }
    )> }
  )> }
);

export type GetNerdlayoutDynamicOptionsFragment = GetNerdlayoutDynamicOptions_ContentPack_Fragment | GetNerdlayoutDynamicOptions_Banner_Fragment | GetNerdlayoutDynamicOptions_BlockGroup_Fragment | GetNerdlayoutDynamicOptions_HouseAd_Fragment | GetNerdlayoutDynamicOptions_MediaItem_Fragment | GetNerdlayoutDynamicOptions_Article_Fragment | GetNerdlayoutDynamicOptions_Block_Fragment | GetNerdlayoutDynamicOptions_Hub_Fragment | GetNerdlayoutDynamicOptions_LandingPage_Fragment | GetNerdlayoutDynamicOptions_Page_Fragment | GetNerdlayoutDynamicOptions_Post_Fragment | GetNerdlayoutDynamicOptions_Review_Fragment | GetNerdlayoutDynamicOptions_Roundup_Fragment | GetNerdlayoutDynamicOptions_LegacyLender_Fragment | GetNerdlayoutDynamicOptions_UrlRecord_Fragment | GetNerdlayoutDynamicOptions_ContentSearchResult_Fragment | GetNerdlayoutDynamicOptions_EngineeringPost_Fragment;

export const BlockFragmentDoc = gql`
    fragment block on CombinedBlockGroupBlock {
  type
  title
  data
}
    `;
export const BlockGroupFragmentDoc = gql`
    fragment BlockGroup on BlockGroup {
  id
  blocks {
    ...block
  }
}
    ${BlockFragmentDoc}`;
export const NextStepsFragmentDoc = gql`
    fragment NextSteps on Article {
  id
  articleType
  nextSteps {
    ...BlockGroup
  }
  primaryCategory {
    name
    link
  }
}
    ${BlockGroupFragmentDoc}`;
export const RelatedLinksFragmentDoc = gql`
    fragment RelatedLinks on Article {
  id
  articleType
  relatedLinks {
    ...BlockGroup
  }
  primaryCategory {
    name
    link
  }
}
    ${BlockGroupFragmentDoc}`;
export const AuthorDetailsFragmentDoc = gql`
    fragment AuthorDetails on Author {
  avatarUrls(sizes: [SIZE_96]) {
    url
  }
  contactEmail
  facebook
  name
  link
  slug
  tagline
  twitter
}
    `;
export const AuthorBoxFragmentDoc = gql`
    fragment AuthorBox on Article {
  authors {
    ...AuthorDetails
  }
}
    ${AuthorDetailsFragmentDoc}`;
export const WordPressContentPageHeaderFragmentDoc = gql`
    fragment WordPressContentPageHeader on ContentPageHeaderInterface {
  __typename
  advertiserDisclosureType
  authors {
    name
    link
  }
  id
  primaryCategory {
    name
  }
  showAdvertiserDisclosure
  showAuthorByline
  showEditorialDisclaimer
  title
  ... on Article {
    dateTimeDisplayDate: displayDate
    stringSynopsis: synopsis
  }
  ... on Roundup {
    eyebrowText
    formattedDisplayDate: displayDate(format: "LL")
    structuredContentSynopsis: synopsis
  }
}
    `;
export const ContentPageHeaderFragmentDoc = gql`
    fragment ContentPageHeader on Article {
  hideDate
  showLastModifiedDate
  ...WordPressContentPageHeader
}
    ${WordPressContentPageHeaderFragmentDoc}`;
export const MethodologyFragmentDoc = gql`
    fragment Methodology on Article {
  methodology {
    content
  }
}
    `;
export const HouseAdFragmentDoc = gql`
    fragment HouseAd on Article {
  articleType
  houseAd {
    id
  }
}
    `;
export const GetArticleCanonicalUrlFragmentDoc = gql`
    fragment getArticleCanonicalUrl on Article {
  link
}
    `;
export const GetPageTaxonomyDataFragmentDoc = gql`
    fragment getPageTaxonomyData on PostWithPageTaxonomyInterface {
  __typename
  pageTaxonomy
}
    `;
export const GetNerdlayoutDynamicOptionsFragmentDoc = gql`
    fragment getNerdlayoutDynamicOptions on PostInterface {
  __typename
  id
  type
  link
  ...getPageTaxonomyData
  ... on Article {
    synopsis
  }
  ... on PostWithSEOInterface {
    seo {
      title
      description
      nofollow
      noindex
      keyword
      facebook {
        title
        description
      }
      twitter {
        title
        description
        image
      }
    }
  }
  ... on PostWithFeaturedImageInterface {
    featuredMedia {
      id
      mediaDetails {
        id
        sizes(sizes: ["primary-xl", "full"]) {
          sourceUrl
          width
          height
        }
      }
    }
  }
}
    ${GetPageTaxonomyDataFragmentDoc}`;
export const GetAuthorSchemaFragmentDoc = gql`
    fragment getAuthorSchema on Article {
  __typename
  authors {
    id
    name
    link
    avatarUrls(sizes: [SIZE_96]) {
      size
      url
    }
    alumniOf
    affiliation
    award
    honorificSuffix
    jobTitle
    specialties
  }
}
    `;
export const GetEditorSchemaFragmentDoc = gql`
    fragment getEditorSchema on Article {
  __typename
  assigningEditor {
    id
    name
    link
    avatarUrls(sizes: [SIZE_96]) {
      size
      url
    }
    alumniOf
    affiliation
    award
    honorificSuffix
    jobTitle
    specialties
  }
}
    `;
export const GetAboutSchemaFragmentDoc = gql`
    fragment getAboutSchema on Article {
  __typename
  categories {
    name
  }
}
    `;
export const GetArticleSchemaFragmentDoc = gql`
    fragment getArticleSchema on Article {
  __typename
  id
  ...getAuthorSchema
  ...getEditorSchema
  ...getAboutSchema
  featuredMediaForJsonLd: featuredMedia {
    id
    mediaDetails {
      id
      sizes(sizes: ["primary-m-uncropped"]) {
        size
        sourceUrl
        width
        height
      }
    }
  }
  link
  modified
  date
}
    ${GetAuthorSchemaFragmentDoc}
${GetEditorSchemaFragmentDoc}
${GetAboutSchemaFragmentDoc}`;
export const GetAbTestConfigFragmentDoc = gql`
    fragment getAbTestConfig on Article {
  articleType
}
    `;
export const AdvertiserDisclosureFragmentDoc = gql`
    fragment AdvertiserDisclosure on Article {
  showAdvertiserDisclosure
  disclosureType: advertiserDisclosureType
}
    `;
export const EditorialStandardsFragmentDoc = gql`
    fragment EditorialStandards on Article {
  showEditorialDisclaimer
  disclaimerType: editorialDisclaimerType
}
    `;
export const BreadcrumbFragmentDoc = gql`
    fragment Breadcrumb on Article {
  breadcrumb {
    slug
    page {
      title
    }
  }
}
    `;
export const ArticleFragmentFragmentDoc = gql`
    fragment articleFragment on Article {
  id
  isPublished
  articleType
  title
  seo {
    extraJsonLd
  }
  slug
  pageTaxonomy
  content
  link
  showEditorialDisclaimer
  showAuthorBox
  contentClusters
  hideFeaturedImage
  featuredImage: featuredMedia {
    id
    altText
    mediaDetails {
      id
      sizes(sizes: ["bb-article", "primary-xxxl", "primary-xxl", "primary-xl", "primary-l", "primary-m", "primary-s", "primary-xs", "primary-xxs", "full"]) {
        sourceUrl
        width
        height
        size
      }
    }
  }
  ...NextSteps
  ...RelatedLinks
  ...AuthorBox
  ...ContentPageHeader
  ...Methodology
  ...HouseAd
  ...getArticleCanonicalUrl
  ...getNerdlayoutDynamicOptions
  ...getArticleSchema
  ...getAbTestConfig
  ...AdvertiserDisclosure
  ...EditorialStandards
  ...Breadcrumb
}
    ${NextStepsFragmentDoc}
${RelatedLinksFragmentDoc}
${AuthorBoxFragmentDoc}
${ContentPageHeaderFragmentDoc}
${MethodologyFragmentDoc}
${HouseAdFragmentDoc}
${GetArticleCanonicalUrlFragmentDoc}
${GetNerdlayoutDynamicOptionsFragmentDoc}
${GetArticleSchemaFragmentDoc}
${GetAbTestConfigFragmentDoc}
${AdvertiserDisclosureFragmentDoc}
${EditorialStandardsFragmentDoc}
${BreadcrumbFragmentDoc}`;
export const GetItemListSchemaFragmentDoc = gql`
    fragment getItemListSchema on Roundup {
  link
  marketplaceProductType
  titleWithoutEntityCount
}
    `;
export const ArticleDocument = gql`
    query article($identifier: ID!, $wpnonce: ID) {
  article(input: {identifier: $identifier, wpnonce: $wpnonce}) {
    ...articleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArticleQuery, ArticleQueryVariables>, 'query'> & ({ variables: ArticleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArticleComponent = (props: ArticleComponentProps) => (
      <ApolloReactComponents.Query<ArticleQuery, ArticleQueryVariables> query={ArticleDocument} {...props} />
    );
    
export type ArticleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArticleQuery, ArticleQueryVariables>
    } & TChildProps;
export function withArticle<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArticleQuery,
  ArticleQueryVariables,
  ArticleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArticleQuery, ArticleQueryVariables, ArticleProps<TChildProps, TDataName>>(ArticleDocument, {
      alias: 'article',
      ...operationOptions
    });
};

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      wpnonce: // value for 'wpnonce'
 *   },
 * });
 */
export function useArticleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
        return ApolloReactHooks.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, baseOptions);
      }
export function useArticleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, baseOptions);
        }
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = ApolloReactCommon.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const ArticleForkDocument = gql`
    query articleFork($identifier: ID!, $wpnonce: String, $forkPreview: Boolean, $forkIdentifier: Int!, $forkNonce: String) {
  articleFork(input: {identifier: $identifier, wpnonce: $wpnonce, forkPreview: $forkPreview, forkIdentifier: $forkIdentifier, forkNonce: $forkNonce}) {
    ...articleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleForkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArticleForkQuery, ArticleForkQueryVariables>, 'query'> & ({ variables: ArticleForkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArticleForkComponent = (props: ArticleForkComponentProps) => (
      <ApolloReactComponents.Query<ArticleForkQuery, ArticleForkQueryVariables> query={ArticleForkDocument} {...props} />
    );
    
export type ArticleForkProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArticleForkQuery, ArticleForkQueryVariables>
    } & TChildProps;
export function withArticleFork<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArticleForkQuery,
  ArticleForkQueryVariables,
  ArticleForkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArticleForkQuery, ArticleForkQueryVariables, ArticleForkProps<TChildProps, TDataName>>(ArticleForkDocument, {
      alias: 'articleFork',
      ...operationOptions
    });
};

/**
 * __useArticleForkQuery__
 *
 * To run a query within a React component, call `useArticleForkQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleForkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleForkQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      wpnonce: // value for 'wpnonce'
 *      forkPreview: // value for 'forkPreview'
 *      forkIdentifier: // value for 'forkIdentifier'
 *      forkNonce: // value for 'forkNonce'
 *   },
 * });
 */
export function useArticleForkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArticleForkQuery, ArticleForkQueryVariables>) {
        return ApolloReactHooks.useQuery<ArticleForkQuery, ArticleForkQueryVariables>(ArticleForkDocument, baseOptions);
      }
export function useArticleForkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArticleForkQuery, ArticleForkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ArticleForkQuery, ArticleForkQueryVariables>(ArticleForkDocument, baseOptions);
        }
export type ArticleForkQueryHookResult = ReturnType<typeof useArticleForkQuery>;
export type ArticleForkLazyQueryHookResult = ReturnType<typeof useArticleForkLazyQuery>;
export type ArticleForkQueryResult = ApolloReactCommon.QueryResult<ArticleForkQuery, ArticleForkQueryVariables>;
export const GetArticleSchemaDocument = gql`
    query getArticleSchema($articleId: ID!) {
  article(input: {identifier: $articleId}) {
    ...getArticleSchema
  }
}
    ${GetArticleSchemaFragmentDoc}`;
export type GetArticleSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>, 'query'> & ({ variables: GetArticleSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetArticleSchemaComponent = (props: GetArticleSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetArticleSchemaQuery, GetArticleSchemaQueryVariables> query={GetArticleSchemaDocument} {...props} />
    );
    
export type GetArticleSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>
    } & TChildProps;
export function withGetArticleSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetArticleSchemaQuery,
  GetArticleSchemaQueryVariables,
  GetArticleSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetArticleSchemaQuery, GetArticleSchemaQueryVariables, GetArticleSchemaProps<TChildProps, TDataName>>(GetArticleSchemaDocument, {
      alias: 'getArticleSchema',
      ...operationOptions
    });
};

/**
 * __useGetArticleSchemaQuery__
 *
 * To run a query within a React component, call `useGetArticleSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleSchemaQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetArticleSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>(GetArticleSchemaDocument, baseOptions);
      }
export function useGetArticleSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>(GetArticleSchemaDocument, baseOptions);
        }
export type GetArticleSchemaQueryHookResult = ReturnType<typeof useGetArticleSchemaQuery>;
export type GetArticleSchemaLazyQueryHookResult = ReturnType<typeof useGetArticleSchemaLazyQuery>;
export type GetArticleSchemaQueryResult = ApolloReactCommon.QueryResult<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>;
export const GetAuthorSchemaDocument = gql`
    query getAuthorSchema($articleId: ID!) {
  article(input: {identifier: $articleId}) {
    ...getAuthorSchema
  }
}
    ${GetAuthorSchemaFragmentDoc}`;
export type GetAuthorSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>, 'query'> & ({ variables: GetAuthorSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAuthorSchemaComponent = (props: GetAuthorSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables> query={GetAuthorSchemaDocument} {...props} />
    );
    
export type GetAuthorSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>
    } & TChildProps;
export function withGetAuthorSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAuthorSchemaQuery,
  GetAuthorSchemaQueryVariables,
  GetAuthorSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables, GetAuthorSchemaProps<TChildProps, TDataName>>(GetAuthorSchemaDocument, {
      alias: 'getAuthorSchema',
      ...operationOptions
    });
};

/**
 * __useGetAuthorSchemaQuery__
 *
 * To run a query within a React component, call `useGetAuthorSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorSchemaQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetAuthorSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>(GetAuthorSchemaDocument, baseOptions);
      }
export function useGetAuthorSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>(GetAuthorSchemaDocument, baseOptions);
        }
export type GetAuthorSchemaQueryHookResult = ReturnType<typeof useGetAuthorSchemaQuery>;
export type GetAuthorSchemaLazyQueryHookResult = ReturnType<typeof useGetAuthorSchemaLazyQuery>;
export type GetAuthorSchemaQueryResult = ApolloReactCommon.QueryResult<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>;
export const GetAboutSchemaDocument = gql`
    query getAboutSchema($articleId: ID!) {
  article(input: {identifier: $articleId}) {
    ...getAboutSchema
  }
}
    ${GetAboutSchemaFragmentDoc}`;
export type GetAboutSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>, 'query'> & ({ variables: GetAboutSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAboutSchemaComponent = (props: GetAboutSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetAboutSchemaQuery, GetAboutSchemaQueryVariables> query={GetAboutSchemaDocument} {...props} />
    );
    
export type GetAboutSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>
    } & TChildProps;
export function withGetAboutSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAboutSchemaQuery,
  GetAboutSchemaQueryVariables,
  GetAboutSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAboutSchemaQuery, GetAboutSchemaQueryVariables, GetAboutSchemaProps<TChildProps, TDataName>>(GetAboutSchemaDocument, {
      alias: 'getAboutSchema',
      ...operationOptions
    });
};

/**
 * __useGetAboutSchemaQuery__
 *
 * To run a query within a React component, call `useGetAboutSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAboutSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAboutSchemaQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetAboutSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>(GetAboutSchemaDocument, baseOptions);
      }
export function useGetAboutSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>(GetAboutSchemaDocument, baseOptions);
        }
export type GetAboutSchemaQueryHookResult = ReturnType<typeof useGetAboutSchemaQuery>;
export type GetAboutSchemaLazyQueryHookResult = ReturnType<typeof useGetAboutSchemaLazyQuery>;
export type GetAboutSchemaQueryResult = ApolloReactCommon.QueryResult<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>;